import * as i0 from '@angular/core';
import { input, signal, viewChild, computed, Component, Injectable, reflectComponentType, forwardRef, effect, ChangeDetectionStrategy } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/platform-browser';

// no-op
// this file exists in case a target needs to add logic to the top of the index file in an
// override.
const _c0 = ["tagnameTemplate"];
const _c1 = ["*"];
const _c2 = (a0, a1, a2) => ({
  attributes: a0,
  actionAttributes: a1,
  tagName: a2
});
const _c3 = (a0, a1) => ({
  attributes: a0,
  actionAttributes: a1
});
function DynamicRenderer_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function DynamicRenderer_ng_container_2_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DynamicRenderer_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicRenderer_ng_container_2_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.mappedComponent())("ngComponentOutletInputs", i0.ɵɵpureFunction3(3, _c2, ctx_r0.attributes(), ctx_r0.actionAttributes(), ctx_r0.tagName()))("ngComponentOutletContent", ctx_r0.myContent);
  }
}
function DynamicRenderer_ng_container_2_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DynamicRenderer_ng_container_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicRenderer_ng_container_2_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.effectiveTagName())("ngComponentOutletInputs", i0.ɵɵpureFunction3(3, _c2, ctx_r0.attributes(), ctx_r0.actionAttributes(), ctx_r0.tagName()))("ngComponentOutletContent", ctx_r0.myContent);
  }
}
function DynamicRenderer_ng_container_2_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DynamicRenderer_ng_container_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicRenderer_ng_container_2_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.effectiveTagName())("ngComponentOutletInputs", i0.ɵɵpureFunction2(3, _c3, ctx_r0.attributes(), ctx_r0.actionAttributes()))("ngComponentOutletContent", ctx_r0.myContent);
  }
}
function DynamicRenderer_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicRenderer_ng_container_2_ng_container_1_Template, 2, 7, "ng-container", 1)(2, DynamicRenderer_ng_container_2_ng_container_2_Template, 2, 7, "ng-container", 1)(3, DynamicRenderer_ng_container_2_ng_container_3_Template, 2, 6, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.tagNameIsString());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.tagNameIsString() && ctx_r0.dynamicTagName() !== "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.tagNameIsString() && ctx_r0.dynamicTagName() === "");
  }
}
function DynamicRenderer_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DynamicRenderer_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicRenderer_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.effectiveTagName())("ngComponentOutletInputs", i0.ɵɵpureFunction2(3, _c3, ctx_r0.attributes(), ctx_r0.actionAttributes()))("ngComponentOutletContent", ctx_r0.myContent);
  }
}
const _c4 = ["v"];
const _c5 = () => ({});
function BlockStyles_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "inlined-styles", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("styles", ctx_r0.css())("nonce", ctx_r0.context().nonce);
  }
}
const _c6 = (a0, a1) => ({
  block: a0,
  context: a1
});
const _c7 = (a0, a1, a2, a3, a4) => ({
  block: a0,
  rootState: a1,
  rootSetState: a2,
  localState: a3,
  context: a4,
  stripPrefix: true
});
const _c8 = ["wrapperTemplate"];
const _c9 = ["*", "*"];
function InteractiveElement_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function InteractiveElement_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "awaiter", 1);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("load", ctx_r0.Wrapper().load)("fallback", ctx_r0.Wrapper().fallback)("props", ctx_r0.wrapperProps())("attributes", ctx_r0.attributes());
  }
}
function InteractiveElement_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function InteractiveElement_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, InteractiveElement_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.Wrapper())("ngComponentOutletInputs", ctx_r0.dynamicProps_z2itiz())("ngComponentOutletContent", ctx_r0.myContent());
  }
}
function ComponentRef_ng_template_0_Conditional_0_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "block", 1);
  }
  if (rf & 2) {
    const child_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("block", child_r1)("context", ctx_r1.context())("registeredComponents", ctx_r1.registeredComponents())("linkComponent", ctx_r1.linkComponent());
  }
}
function ComponentRef_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, ComponentRef_ng_template_0_Conditional_0_For_1_Template, 1, 4, "block", 1, i0.ɵɵcomponentInstance().trackByChild0, true);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r1.blockChildren());
  }
}
function ComponentRef_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ComponentRef_ng_template_0_Conditional_0_Template, 2, 0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.componentRef() ? 0 : -1);
  }
}
function ComponentRef_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ComponentRef_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ComponentRef_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r1.Wrapper())("ngComponentOutletInputs", ctx_r1.dynamicProps_vn4rls())("ngComponentOutletContent", ctx_r1.myContent());
  }
}
function Block_Conditional_0_Conditional_1_Conditional_0_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "block", 3);
  }
  if (rf & 2) {
    const child_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("block", child_r1)("registeredComponents", ctx_r1.registeredComponents())("linkComponent", ctx_r1.linkComponent())("context", ctx_r1.context());
  }
}
function Block_Conditional_0_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "block-wrapper", 1);
    i0.ɵɵelement(1, "component-ref", 2);
    i0.ɵɵrepeaterCreate(2, Block_Conditional_0_Conditional_1_Conditional_0_For_3_Template, 1, 4, "block", 3, i0.ɵɵcomponentInstance().trackByChild0, true);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("Wrapper", ctx_r1.Tag())("block", ctx_r1.processedBlock())("context", ctx_r1.context());
    i0.ɵɵadvance();
    i0.ɵɵproperty("componentRef", ctx_r1.componentRefProps().componentRef)("componentOptions", ctx_r1.componentRefProps().componentOptions)("blockChildren", ctx_r1.componentRefProps().blockChildren)("context", ctx_r1.componentRefProps().context)("registeredComponents", ctx_r1.componentRefProps().registeredComponents)("linkComponent", ctx_r1.componentRefProps().linkComponent)("builderBlock", ctx_r1.componentRefProps().builderBlock)("includeBlockProps", ctx_r1.componentRefProps().includeBlockProps)("isInteractive", ctx_r1.componentRefProps().isInteractive);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.childrenWithoutParentComponent());
  }
}
function Block_Conditional_0_Conditional_1_Conditional_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "repeated-block", 4);
  }
  if (rf & 2) {
    const data_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("repeatContext", data_r3.context)("block", data_r3.block)("registeredComponents", ctx_r1.registeredComponents())("linkComponent", ctx_r1.linkComponent());
  }
}
function Block_Conditional_0_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, Block_Conditional_0_Conditional_1_Conditional_1_For_1_Template, 1, 4, "repeated-block", 4, i0.ɵɵcomponentInstance().trackByData1, true);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵrepeater(ctx_r1.repeatItem());
  }
}
function Block_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Block_Conditional_0_Conditional_1_Conditional_0_Template, 4, 12, "block-wrapper", 1)(1, Block_Conditional_0_Conditional_1_Conditional_1_Template, 2, 0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(!ctx_r1.repeatItem() ? 0 : 1);
  }
}
function Block_Conditional_0_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "component-ref", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("componentRef", ctx_r1.componentRefProps().componentRef)("componentOptions", ctx_r1.componentRefProps().componentOptions)("blockChildren", ctx_r1.componentRefProps().blockChildren)("context", ctx_r1.componentRefProps().context)("registeredComponents", ctx_r1.componentRefProps().registeredComponents)("linkComponent", ctx_r1.componentRefProps().linkComponent)("builderBlock", ctx_r1.componentRefProps().builderBlock)("includeBlockProps", ctx_r1.componentRefProps().includeBlockProps)("isInteractive", ctx_r1.componentRefProps().isInteractive);
  }
}
function Block_Conditional_0_Conditional_2_Conditional_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "repeated-block", 4);
  }
  if (rf & 2) {
    const data_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("repeatContext", data_r4.context)("block", data_r4.block)("registeredComponents", ctx_r1.registeredComponents())("linkComponent", ctx_r1.linkComponent());
  }
}
function Block_Conditional_0_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, Block_Conditional_0_Conditional_2_Conditional_1_For_1_Template, 1, 4, "repeated-block", 4, i0.ɵɵcomponentInstance().trackByData2, true);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵrepeater(ctx_r1.repeatItem());
  }
}
function Block_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Block_Conditional_0_Conditional_2_Conditional_0_Template, 1, 9, "component-ref", 2)(1, Block_Conditional_0_Conditional_2_Conditional_1_Template, 2, 0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(!ctx_r1.repeatItem() ? 0 : 1);
  }
}
function Block_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "block-styles", 0);
    i0.ɵɵtemplate(1, Block_Conditional_0_Conditional_1_Template, 2, 1)(2, Block_Conditional_0_Conditional_2_Template, 2, 1);
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("block", ctx_r1.processedBlock())("context", ctx_r1.context());
    i0.ɵɵadvance();
    i0.ɵɵconditional(!((tmp_3_0 = ctx_r1.blockComponent()) == null ? null : tmp_3_0.noWrap) ? 1 : 2);
  }
}
const _c10 = ["blockswrapperTemplate"];
const _c11 = ["blocksWrapperRef"];
function BlocksWrapper_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function BlocksWrapper_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Blocks_Conditional_2_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "block", 1);
  }
  if (rf & 2) {
    const block_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("block", block_r1)("linkComponent", ctx_r1.linkComponent())("context", ctx_r1.context() || ctx_r1.builderContext)("registeredComponents", ctx_r1.registeredComponents() || (ctx_r1.componentsContext == null ? null : ctx_r1.componentsContext.registeredComponents));
  }
}
function Blocks_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, Blocks_Conditional_2_For_1_Template, 1, 4, "block", 1, i0.ɵɵcomponentInstance().trackByBlock0, true);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r1.blocks());
  }
}
const _c12 = ["elRef0"];
const _c13 = () => ({
  flexGrow: "1"
});
function Columns_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "inlined-styles", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("styles", ctx_r0.columnsStyles())("nonce", ctx_r0.builderContext().nonce);
  }
}
function Columns_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dynamic-renderer", 3);
    i0.ɵɵelement(1, "blocks", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r2 = ctx.$implicit;
    const ɵ$index_6_r3 = ctx.$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("TagName", ctx_r0.getTagName(column_r2))("actionAttributes", i0.ɵɵpureFunction0(10, _c5))("attributes", ctx_r0.getAttributes(column_r2, ɵ$index_6_r3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("path", ctx_r0.templateStr_9tnc0u(column_r2, ɵ$index_6_r3))("parent", ctx_r0.builderBlock().id)("context", ctx_r0.builderContext())("registeredComponents", ctx_r0.builderComponents())("linkComponent", ctx_r0.builderLinkComponent())("blocks", column_r2.blocks)("styleProp", i0.ɵɵpureFunction0(11, _c13));
  }
}
const _c14 = a0 => ({
  paddingTop: a0
});
function Image_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "source", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("srcset", ctx_r0.webpSrcSet());
  }
}
function Image_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c14, ctx_r0.aspectRatio() * 100 + "%"));
  }
}
function Image_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function Image_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
const _c15 = a0 => ({
  width: "100%",
  alignSelf: "stretch",
  flexGrow: 1,
  boxSizing: "border-box",
  maxWidth: a0,
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  marginLeft: "auto",
  marginRight: "auto"
});
function Accordion_For_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "blocks", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const item_r5 = ctx_r3.$implicit;
    const ɵ$index_3_r2 = ctx_r3.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2.getAccordionDetailClassName(ɵ$index_3_r2));
    i0.ɵɵproperty("ngStyle", ctx_r2.accordionDetailStyles());
    i0.ɵɵadvance();
    i0.ɵɵproperty("blocks", item_r5.detail)("path", ctx_r2.templateStr_x0msw(item_r5, ɵ$index_3_r2))("parent", ctx_r2.builderBlock().id)("context", ctx_r2.builderContext())("registeredComponents", ctx_r2.builderComponents())("linkComponent", ctx_r2.builderLinkComponent());
  }
}
function Accordion_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵlistener("click", function Accordion_For_2_Template_div_click_1_listener() {
      const ɵ$index_3_r2 = i0.ɵɵrestoreView(_r1).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onClick(ɵ$index_3_r2));
    });
    i0.ɵɵelement(2, "blocks", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, Accordion_For_2_Conditional_3_Template, 2, 9, "div", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ɵ$index_3_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.getAccordionTitleClassName(ɵ$index_3_r2));
    i0.ɵɵproperty("ngStyle", ctx_r2.objSpread_style_oaowqb(item_r5, ɵ$index_3_r2));
    i0.ɵɵattribute("data-index", ɵ$index_3_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("blocks", item_r5.title)("path", ctx_r2.templateStr_z2r7ff(item_r5, ɵ$index_3_r2))("parent", ctx_r2.builderBlock().id)("context", ctx_r2.builderContext())("registeredComponents", ctx_r2.builderComponents())("linkComponent", ctx_r2.builderLinkComponent());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.open().includes(ɵ$index_3_r2) ? 3 : -1);
  }
}
const _c16 = ["rootRef"];
function PersonalizationContainer_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "blocks", 1);
  }
  if (rf & 2) {
    let tmp_4_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("blocks", ctx_r0.blocksToRender().blocks)("parent", (tmp_4_0 = ctx_r0.builderBlock()) == null ? null : tmp_4_0.id)("path", ctx_r0.blocksToRender().path)("context", ctx_r0.builderContext())("registeredComponents", ctx_r0.builderComponents())("BlocksWrapperProps", ctx_r0.objSpread_BlocksWrapperProps_oi5c20());
  }
}
function PersonalizationContainer_Conditional_4_Conditional_0_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "blocks", 4);
    i0.ɵɵelement(1, "inlined-script", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_17_0;
    let tmp_21_0;
    const variant_r2 = ctx.$implicit;
    const ɵ$index_12_r3 = ctx.$index;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("BlocksWrapperProps", ctx_r0.objSpread_BlocksWrapperProps_wq9i0g(variant_r2, ɵ$index_12_r3))("blocks", variant_r2.blocks)("parent", (tmp_17_0 = ctx_r0.builderBlock()) == null ? null : tmp_17_0.id)("path", ctx_r0.templateStr_q6jkc(variant_r2, ɵ$index_12_r3))("context", ctx_r0.builderContext())("registeredComponents", ctx_r0.builderComponents());
    i0.ɵɵadvance();
    i0.ɵɵproperty("nonce", ((tmp_21_0 = ctx_r0.builderContext()) == null ? null : tmp_21_0.nonce) || "")("scriptStr", ctx_r0.scriptStr())("id", ctx_r0.templateStr_cbpzp5(variant_r2, ɵ$index_12_r3));
  }
}
function PersonalizationContainer_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "inlined-styles", 3)(1, "inlined-script", 2);
    i0.ɵɵrepeaterCreate(2, PersonalizationContainer_Conditional_4_Conditional_0_For_3_Template, 2, 9, "blocks", 4, i0.ɵɵcomponentInstance().trackByVariant0, true);
  }
  if (rf & 2) {
    let tmp_4_0;
    let tmp_7_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("nonce", ((tmp_4_0 = ctx_r0.builderContext()) == null ? null : tmp_4_0.nonce) || "")("styles", ctx_r0.hideVariantsStyleString())("id", ctx_r0.templateStr_lw6jtt());
    i0.ɵɵadvance();
    i0.ɵɵproperty("nonce", ((tmp_7_0 = ctx_r0.builderContext()) == null ? null : tmp_7_0.nonce) || "")("scriptStr", ctx_r0.updateVisibilityStylesScript())("id", ctx_r0.templateStr_rpibqx());
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.variants());
  }
}
function PersonalizationContainer_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "inlined-script", 2);
  }
  if (rf & 2) {
    let tmp_4_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("nonce", ((tmp_4_0 = ctx_r0.builderContext()) == null ? null : tmp_4_0.nonce) || "")("scriptStr", ctx_r0.scriptStr())("id", ctx_r0.templateStr_f5w03p());
  }
}
function PersonalizationContainer_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PersonalizationContainer_Conditional_4_Conditional_0_Template, 4, 6);
    i0.ɵɵelementStart(1, "blocks", 1);
    i0.ɵɵtemplate(2, PersonalizationContainer_Conditional_4_Conditional_2_Template, 1, 3, "inlined-script", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.shouldRenderVariants() ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("blocks", ctx_r0.blocksToRender().blocks)("parent", (tmp_5_0 = ctx_r0.builderBlock()) == null ? null : tmp_5_0.id)("path", ctx_r0.blocksToRender().path)("context", ctx_r0.builderContext())("registeredComponents", ctx_r0.builderComponents())("BlocksWrapperProps", ctx_r0.objSpread_BlocksWrapperProps_oi5c20());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.shouldRenderVariants() ? 2 : -1);
  }
}
const _c17 = () => ({
  pointerEvents: "auto"
});
const _c18 = a0 => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: a0,
  overflow: "auto"
});
function Tabs_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵlistener("click", function Tabs_For_3_Template_span_click_0_listener() {
      const ɵ$index_5_r2 = i0.ɵɵrestoreView(_r1).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onClick(ɵ$index_5_r2));
    });
    i0.ɵɵelement(1, "blocks", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r4 = ctx.$implicit;
    const ɵ$index_5_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2.templateStr_1fubij(tab_r4, ɵ$index_5_r2));
    i0.ɵɵproperty("ngStyle", ctx_r2.getTabStyle(ɵ$index_5_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("parent", ctx_r2.builderBlock().id)("path", ctx_r2.templateStr_fz5znr(tab_r4, ɵ$index_5_r2))("blocks", tab_r4.label)("context", ctx_r2.builderContext())("registeredComponents", ctx_r2.builderComponents())("linkComponent", ctx_r2.builderLinkComponent());
  }
}
function Tabs_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "blocks", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("parent", ctx_r2.builderBlock().id)("path", ctx_r2.templateStr_nlekn6())("blocks", ctx_r2.activeTabContent(ctx_r2.activeTab()))("context", ctx_r2.builderContext())("registeredComponents", ctx_r2.builderComponents())("linkComponent", ctx_r2.builderLinkComponent());
  }
}
const _c19 = () => ({
  outline: "none"
});
const _c20 = ["elementRef"];
const _c21 = ["elem"];
const _c22 = ["formRef"];
function FormComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "blocks", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("blocks", ctx_r1.errorMessage())("context", ctx_r1.builderContext());
  }
}
function FormComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "blocks", 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("blocks", ctx_r1.sendingMessage())("context", ctx_r1.builderContext());
  }
}
function FormComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("        ", ctx_r1.errorResponse(ctx_r1.responseData()), "");
  }
}
function FormComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "blocks", 5);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("blocks", ctx_r1.successMessage())("context", ctx_r1.builderContext());
  }
}
function SelectComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r1 = ctx.$implicit;
    i0.ɵɵattribute("value", option_r1.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r1.name || option_r1.value, " ");
  }
}
const _c23 = (a0, a1) => ({
  objectFit: a0,
  objectPosition: a1
});
const _c24 = ["videoRef"];
const _c25 = ["elRef1"];
const _c26 = () => ({
  position: "relative"
});
const _c27 = a0 => ({
  width: "100%",
  paddingTop: a0,
  pointerEvents: "none",
  fontSize: "0px"
});
const _c28 = () => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch"
});
const _c29 = () => ({
  pointerEvents: "none",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  position: "absolute",
  top: "0",
  left: "0",
  width: "100%",
  height: "100%"
});
function Video_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c27, ctx_r0.aspectRatio() * 100 + "%"));
  }
}
function Video_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(1, _c28));
  }
}
function Video_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(1, _c29));
  }
}
const _c30 = ["contentwrapperTemplate"];
function EnableEditor_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function EnableEditor_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EnableEditor_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EnableEditor_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngComponentOutlet", ctx_r0.ContentWrapper())("ngComponentOutletInputs", ctx_r0.dynamicProps_sb7chb())("ngComponentOutletContent", ctx_r0.myContent());
  }
}
function ContentComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "inlined-script", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("scriptStr", ctx_r0.scriptStr())("nonce", ctx_r0.nonce() || "");
  }
}
function ContentComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "content-styles", 2);
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_4_0;
    let tmp_5_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("nonce", ctx_r0.nonce() || "")("isNestedRender", ctx_r0.isNestedRender())("contentId", (tmp_3_0 = ctx_r0.builderContextSignal().content) == null ? null : tmp_3_0.id)("cssCode", (tmp_4_0 = ctx_r0.builderContextSignal().content) == null ? null : tmp_4_0.data == null ? null : tmp_4_0.data.cssCode)("customFonts", (tmp_5_0 = ctx_r0.builderContextSignal().content) == null ? null : tmp_5_0.data == null ? null : tmp_5_0.data.customFonts);
  }
}
function ContentVariants_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "inlined-script", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("nonce", ctx_r0.nonce() || "")("scriptStr", ctx_r0.getInitPersonalizationVariantsFnsScriptString());
  }
}
function ContentVariants_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "inlined-script", 1);
    i0.ɵɵtemplate(1, ContentVariants_Conditional_1_Conditional_1_Template, 1, 2, "inlined-script", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("scriptStr", ctx_r0.getInitVariantsFnsScriptString())("nonce", ctx_r0.nonce() || "");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.SDKS_SUPPORTING_PERSONALIZATION.includes(ctx_r0.TARGET) ? 1 : -1);
  }
}
function ContentVariants_Conditional_2_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "content-component", 5);
  }
  if (rf & 2) {
    const variant_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("apiHost", ctx_r0.apiHost())("isNestedRender", ctx_r0.isNestedRender())("nonce", ctx_r0.nonce())("content", variant_r2)("showContent", false)("model", ctx_r0.model())("data", ctx_r0.data())("context", ctx_r0.context())("apiKey", ctx_r0.apiKey())("apiVersion", ctx_r0.apiVersion())("customComponents", ctx_r0.customComponents())("linkComponent", ctx_r0.linkComponent())("canTrack", ctx_r0.canTrack())("locale", ctx_r0.locale())("enrich", ctx_r0.enrich())("isSsrAbTest", ctx_r0.shouldRenderVariants())("blocksWrapper", ctx_r0.blocksWrapper())("blocksWrapperProps", ctx_r0.blocksWrapperProps())("contentWrapper", ctx_r0.contentWrapper())("contentWrapperProps", ctx_r0.contentWrapperProps())("trustedHosts", ctx_r0.trustedHosts());
  }
}
function ContentVariants_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "inlined-styles", 3)(1, "inlined-script", 4);
    i0.ɵɵrepeaterCreate(2, ContentVariants_Conditional_2_For_3_Template, 1, 21, "content-component", 5, i0.ɵɵcomponentInstance().trackByVariant0, true);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("styles", ctx_r0.hideVariantsStyleString())("nonce", ctx_r0.nonce() || "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("scriptStr", ctx_r0.updateCookieAndStylesScriptStr())("nonce", ctx_r0.nonce() || "");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.getVariants(ctx_r0.content()));
  }
}
var undefined$1 = undefined;

/**
 * https://developer.mozilla.org/en-US/docs/Glossary/Empty_element
 */
const EMPTY_HTML_ELEMENTS = new Set(['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
const isEmptyElement = tagName => {
  return typeof tagName === 'string' && EMPTY_HTML_ELEMENTS.has(tagName.toLowerCase());
};
let DynamicRenderer = /*#__PURE__*/(() => {
  class DynamicRenderer {
    constructor(vcRef) {
      this.vcRef = vcRef;
      this.isEmptyElement = isEmptyElement;
      this.TagName = input.required();
      this.attributes = input.required();
      this.actionAttributes = input.required();
      this.tagName = signal('');
      this.tagnameTemplateRef = viewChild('tagnameTemplate');
      this._processedTagName = signal(null);
      this.tagNameIsString = computed(() => typeof this.TagName() === 'string');
      this.dynamicTagName = computed(() => this.tagName());
      this.effectiveTagName = computed(() => this._processedTagName());
      this.mappedComponent = computed(() => {
        if (this.tagNameIsString()) {
          return this.getComponentType(this.TagName());
        }
        return null;
      });
      this.tagComponentMap = {
        'a': DynamicA,
        'button': DynamicButton,
        'div': DynamicDiv$1,
        'span': DynamicSpan,
        'p': DynamicP,
        'img': DynamicImg,
        'input': DynamicInput,
        'textarea': DynamicTextarea,
        'select': DynamicSelect,
        'option': DynamicOption,
        'form': DynamicForm,
        'label': DynamicLabel,
        'ul': DynamicUl,
        'li': DynamicLi,
        'table': DynamicTable,
        'tr': DynamicTr,
        'td': DynamicTd,
        'th': DynamicTh,
        'thead': DynamicThead,
        'tbody': DynamicTbody,
        'footer': DynamicFooter,
        'header': DynamicHeader,
        'nav': DynamicNav,
        'section': DynamicSection,
        'article': DynamicArticle,
        'aside': DynamicAside,
        'h1': DynamicH1,
        'h2': DynamicH2,
        'h3': DynamicH3,
        'h4': DynamicH4,
        'h5': DynamicH5,
        'h6': DynamicH6,
        'blockquote': DynamicBlockquote,
        'code': DynamicCode,
        'pre': DynamicPre,
        'figure': DynamicFigure,
        'figcaption': DynamicFigcaption,
        'video': DynamicVideo,
        'audio': DynamicAudio,
        'canvas': DynamicCanvas,
        'iframe': DynamicIframe
      };
    }
    getComponentType(tagName) {
      return this.tagComponentMap[tagName] || DynamicElement;
    }
    ngAfterContentInit() {
      if (this.tagNameIsString()) {
        if (this.tagComponentMap[this.TagName()]) {
          this._processedTagName.set(this.tagComponentMap[this.TagName()]);
        } else {
          this.tagName.set(this.TagName());
          this._processedTagName.set(DynamicElement);
        }
      } else {
        this._processedTagName.set(this.TagName());
      }
      this.myContent = [this.vcRef.createEmbeddedView(this.tagnameTemplateRef()).rootNodes];
    }
    static {
      this.ɵfac = function DynamicRenderer_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicRenderer)(i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicRenderer,
        selectors: [["dynamic-renderer"], ["DynamicRenderer"]],
        viewQuery: function DynamicRenderer_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.tagnameTemplateRef, _c0, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          TagName: [1, "TagName"],
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 4,
        vars: 2,
        consts: [["tagnameTemplate", ""], [4, "ngIf"], [4, "ngComponentOutlet", "ngComponentOutletInputs", "ngComponentOutletContent"]],
        template: function DynamicRenderer_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, DynamicRenderer_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, DynamicRenderer_ng_container_2_Template, 4, 3, "ng-container", 1)(3, DynamicRenderer_ng_container_3_Template, 2, 6, "ng-container", 1);
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.isEmptyElement(ctx.effectiveTagName()));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !!ctx.isEmptyElement(ctx.effectiveTagName()));
          }
        },
        dependencies: [CommonModule, i1.NgComponentOutlet, i1.NgIf],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicRenderer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicA = /*#__PURE__*/(() => {
  class DynamicA {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicA_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicA)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicA,
        selectors: [["dynamic-a"], ["DynamicA"]],
        viewQuery: function DynamicA_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicA_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "a", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicA;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicButton = /*#__PURE__*/(() => {
  class DynamicButton {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicButton_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicButton)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicButton,
        selectors: [["dynamic-button"], ["DynamicButton"]],
        viewQuery: function DynamicButton_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicButton_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "button", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicDiv$1 = /*#__PURE__*/(() => {
  let DynamicDiv$1 = class DynamicDiv {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicDiv_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicDiv)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicDiv,
        selectors: [["dynamic-div"], ["DynamicDiv"]],
        viewQuery: function DynamicDiv_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicDiv_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  };
  return DynamicDiv$1;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicSpan = /*#__PURE__*/(() => {
  class DynamicSpan {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicSpan_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicSpan)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicSpan,
        selectors: [["dynamic-span"], ["DynamicSpan"]],
        viewQuery: function DynamicSpan_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicSpan_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "span", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicSpan;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicP = /*#__PURE__*/(() => {
  class DynamicP {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicP_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicP)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicP,
        selectors: [["dynamic-p"], ["DynamicP"]],
        viewQuery: function DynamicP_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicP_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "p", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicP;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicImg = /*#__PURE__*/(() => {
  class DynamicImg {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicImg_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicImg)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicImg,
        selectors: [["dynamic-img"], ["DynamicImg"]],
        viewQuery: function DynamicImg_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicImg_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "img", null, 0);
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicImg;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicInput = /*#__PURE__*/(() => {
  class DynamicInput {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicInput_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicInput)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicInput,
        selectors: [["dynamic-input"], ["DynamicInput"]],
        viewQuery: function DynamicInput_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicInput_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "input", null, 0);
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicInput;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicTextarea = /*#__PURE__*/(() => {
  class DynamicTextarea {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicTextarea_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicTextarea)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicTextarea,
        selectors: [["dynamic-textarea"], ["DynamicTextarea"]],
        viewQuery: function DynamicTextarea_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicTextarea_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "textarea", null, 0);
            i0.ɵɵtext(2, "<ng-content></ng-content>");
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicTextarea;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicSelect = /*#__PURE__*/(() => {
  class DynamicSelect {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicSelect_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicSelect)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicSelect,
        selectors: [["dynamic-select"], ["DynamicSelect"]],
        viewQuery: function DynamicSelect_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicSelect_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "select", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicSelect;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicOption = /*#__PURE__*/(() => {
  class DynamicOption {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicOption_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicOption)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicOption,
        selectors: [["dynamic-option"], ["DynamicOption"]],
        viewQuery: function DynamicOption_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicOption_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "option", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicOption;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicForm = /*#__PURE__*/(() => {
  class DynamicForm {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicForm_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicForm)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicForm,
        selectors: [["dynamic-form"], ["DynamicForm"]],
        viewQuery: function DynamicForm_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicForm_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "form", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicForm;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicLabel = /*#__PURE__*/(() => {
  class DynamicLabel {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicLabel_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicLabel)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicLabel,
        selectors: [["dynamic-label"], ["DynamicLabel"]],
        viewQuery: function DynamicLabel_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicLabel_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "label", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicLabel;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicUl = /*#__PURE__*/(() => {
  class DynamicUl {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicUl_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicUl)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicUl,
        selectors: [["dynamic-ul"], ["DynamicUl"]],
        viewQuery: function DynamicUl_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicUl_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "ul", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicUl;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicLi = /*#__PURE__*/(() => {
  class DynamicLi {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicLi_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicLi)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicLi,
        selectors: [["dynamic-li"], ["DynamicLi"]],
        viewQuery: function DynamicLi_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicLi_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "li", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicLi;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicTable = /*#__PURE__*/(() => {
  class DynamicTable {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicTable_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicTable)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicTable,
        selectors: [["dynamic-table"], ["DynamicTable"]],
        viewQuery: function DynamicTable_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicTable_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "table", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicTable;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicTr = /*#__PURE__*/(() => {
  class DynamicTr {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicTr_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicTr)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicTr,
        selectors: [["dynamic-tr"], ["DynamicTr"]],
        viewQuery: function DynamicTr_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicTr_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "tr", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicTr;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicTd = /*#__PURE__*/(() => {
  class DynamicTd {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicTd_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicTd)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicTd,
        selectors: [["dynamic-td"], ["DynamicTd"]],
        viewQuery: function DynamicTd_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicTd_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "td", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicTd;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicTh = /*#__PURE__*/(() => {
  class DynamicTh {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicTh_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicTh)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicTh,
        selectors: [["dynamic-th"], ["DynamicTh"]],
        viewQuery: function DynamicTh_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicTh_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "th", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicTh;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicThead = /*#__PURE__*/(() => {
  class DynamicThead {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicThead_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicThead)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicThead,
        selectors: [["dynamic-thead"], ["DynamicThead"]],
        viewQuery: function DynamicThead_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicThead_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "thead", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicThead;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicTbody = /*#__PURE__*/(() => {
  class DynamicTbody {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicTbody_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicTbody)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicTbody,
        selectors: [["dynamic-tbody"], ["DynamicTbody"]],
        viewQuery: function DynamicTbody_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicTbody_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "tbody", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicTbody;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicFooter = /*#__PURE__*/(() => {
  class DynamicFooter {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicFooter_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicFooter)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicFooter,
        selectors: [["dynamic-footer"], ["DynamicFooter"]],
        viewQuery: function DynamicFooter_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicFooter_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "footer", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicFooter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicHeader = /*#__PURE__*/(() => {
  class DynamicHeader {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicHeader_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicHeader)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicHeader,
        selectors: [["dynamic-header"], ["DynamicHeader"]],
        viewQuery: function DynamicHeader_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicHeader_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "header", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicHeader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicNav = /*#__PURE__*/(() => {
  class DynamicNav {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicNav_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicNav)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicNav,
        selectors: [["dynamic-nav"], ["DynamicNav"]],
        viewQuery: function DynamicNav_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicNav_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "nav", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicNav;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicSection = /*#__PURE__*/(() => {
  class DynamicSection {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicSection_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicSection)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicSection,
        selectors: [["dynamic-section"], ["DynamicSection"]],
        viewQuery: function DynamicSection_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicSection_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "section", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicSection;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicArticle = /*#__PURE__*/(() => {
  class DynamicArticle {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicArticle_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicArticle)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicArticle,
        selectors: [["dynamic-article"], ["DynamicArticle"]],
        viewQuery: function DynamicArticle_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicArticle_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "article", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicArticle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicAside = /*#__PURE__*/(() => {
  class DynamicAside {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicAside_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicAside)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicAside,
        selectors: [["dynamic-aside"], ["DynamicAside"]],
        viewQuery: function DynamicAside_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicAside_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "aside", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicAside;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicH1 = /*#__PURE__*/(() => {
  class DynamicH1 {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicH1_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicH1)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicH1,
        selectors: [["dynamic-h1"], ["DynamicH1"]],
        viewQuery: function DynamicH1_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicH1_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "h1", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicH1;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicH2 = /*#__PURE__*/(() => {
  class DynamicH2 {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicH2_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicH2)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicH2,
        selectors: [["dynamic-h2"], ["DynamicH2"]],
        viewQuery: function DynamicH2_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicH2_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "h2", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicH2;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicH3 = /*#__PURE__*/(() => {
  class DynamicH3 {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicH3_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicH3)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicH3,
        selectors: [["dynamic-h3"], ["DynamicH3"]],
        viewQuery: function DynamicH3_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicH3_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "h3", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicH3;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicH4 = /*#__PURE__*/(() => {
  class DynamicH4 {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicH4_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicH4)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicH4,
        selectors: [["dynamic-h4"], ["DynamicH4"]],
        viewQuery: function DynamicH4_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicH4_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "h4", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicH4;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicH5 = /*#__PURE__*/(() => {
  class DynamicH5 {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicH5_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicH5)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicH5,
        selectors: [["dynamic-h5"], ["DynamicH5"]],
        viewQuery: function DynamicH5_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicH5_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "h5", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicH5;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicH6 = /*#__PURE__*/(() => {
  class DynamicH6 {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicH6_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicH6)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicH6,
        selectors: [["dynamic-h6"], ["DynamicH6"]],
        viewQuery: function DynamicH6_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicH6_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "h6", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicH6;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicBlockquote = /*#__PURE__*/(() => {
  class DynamicBlockquote {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicBlockquote_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicBlockquote)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicBlockquote,
        selectors: [["dynamic-blockquote"], ["DynamicBlockquote"]],
        viewQuery: function DynamicBlockquote_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicBlockquote_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "blockquote", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicBlockquote;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicCode = /*#__PURE__*/(() => {
  class DynamicCode {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicCode_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicCode)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicCode,
        selectors: [["dynamic-code"], ["DynamicCode"]],
        viewQuery: function DynamicCode_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicCode_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "code", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicCode;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicPre = /*#__PURE__*/(() => {
  class DynamicPre {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicPre_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicPre)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicPre,
        selectors: [["dynamic-pre"], ["DynamicPre"]],
        viewQuery: function DynamicPre_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicPre_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "pre", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicPre;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicFigure = /*#__PURE__*/(() => {
  class DynamicFigure {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicFigure_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicFigure)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicFigure,
        selectors: [["dynamic-figure"], ["DynamicFigure"]],
        viewQuery: function DynamicFigure_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicFigure_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "figure", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicFigure;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicFigcaption = /*#__PURE__*/(() => {
  class DynamicFigcaption {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicFigcaption_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicFigcaption)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicFigcaption,
        selectors: [["dynamic-figcaption"], ["DynamicFigcaption"]],
        viewQuery: function DynamicFigcaption_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicFigcaption_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "figcaption", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicFigcaption;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicVideo = /*#__PURE__*/(() => {
  class DynamicVideo {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicVideo_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicVideo)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicVideo,
        selectors: [["dynamic-video"], ["DynamicVideo"]],
        viewQuery: function DynamicVideo_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicVideo_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "video", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicVideo;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicAudio = /*#__PURE__*/(() => {
  class DynamicAudio {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicAudio_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicAudio)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicAudio,
        selectors: [["dynamic-audio"], ["DynamicAudio"]],
        viewQuery: function DynamicAudio_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicAudio_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "audio", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicAudio;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicCanvas = /*#__PURE__*/(() => {
  class DynamicCanvas {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicCanvas_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicCanvas)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicCanvas,
        selectors: [["dynamic-canvas"], ["DynamicCanvas"]],
        viewQuery: function DynamicCanvas_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicCanvas_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "canvas", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicCanvas;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicIframe = /*#__PURE__*/(() => {
  class DynamicIframe {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input.required();
      this.actionAttributes = input();
      this.tagName = input();
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    ngAfterViewInit() {
      this.setAttributes(this.v()?.nativeElement, this.attributes());
    }
    ngOnChanges(changes) {
      if (changes.attributes) {
        this.setAttributes(this.v()?.nativeElement, this.attributes(), changes.attributes.currentValue);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicIframe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicIframe)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicIframe,
        selectors: [["dynamic-iframe"], ["DynamicIframe"]],
        viewQuery: function DynamicIframe_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          tagName: [1, "tagName"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""]],
        template: function DynamicIframe_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "iframe", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return DynamicIframe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicElement = /*#__PURE__*/(() => {
  class DynamicElement {
    constructor(hostRef, renderer) {
      this.hostRef = hostRef;
      this.renderer = renderer;
      this.tagName = input();
      this.attributes = input();
      this.actionAttributes = input();
      this._listenerFns = new Map();
    }
    ngOnInit() {
      if (this.tagName()) {
        this._element = this.renderer.createElement(this.tagName());
        this.renderer.appendChild(this.hostRef.nativeElement, this._element);
        this.setAttributes(this._element, this.attributes());
      }
    }
    ngAfterViewInit() {
      if (this.hostRef.nativeElement.children.length > 1) {
        this.renderer.appendChild(this.hostRef.nativeElement.children[1], this.hostRef.nativeElement.children[0]);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    setAttributes(el, attributes) {
      if (!attributes) return;
      Object.keys(attributes).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          const eventType = key.replace('on', '').toLowerCase();
          this._listenerFns.set(key, this.renderer.listen(el, eventType, attributes[key]));
        } else {
          this.renderer.setAttribute(el, key, attributes[key] ?? '');
        }
      });
    }
    static {
      this.ɵfac = function DynamicElement_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicElement)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicElement,
        selectors: [["dynamic-element"]],
        inputs: {
          tagName: [1, "tagName"],
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 1,
        vars: 0,
        template: function DynamicElement_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return DynamicElement;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** This file should be overriden for each framework. Ideally this would be implemented in Mitosis.  */
const TARGET = 'angular';
const getClassPropName = () => {
  switch (TARGET) {
    case 'react':
    case 'reactNative':
    case 'rsc':
      return 'className';
    case 'svelte':
    case 'vue':
    case 'solid':
    case 'qwik':
    case 'angular':
      return 'class';
  }
};
let Button = /*#__PURE__*/(() => {
  class Button {
    attrs() {
      return {
        ...this.attributes(),
        [getClassPropName()]: `${this.link() ? "" : "builder-button"} ${this.attributes()[getClassPropName()] || ""}`,
        ...(this.link() ? {
          href: this.link(),
          target: this.openLinkInNewTab() ? "_blank" : undefined,
          role: "link"
        } : {
          role: "button"
        })
      };
    }
    constructor() {
      this.attributes = input();
      this.link = input();
      this.openLinkInNewTab = input();
      this.builderLinkComponent = input();
      this.text = input();
    }
    static {
      this.ɵfac = function Button_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Button)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Button,
        selectors: [["builder-button"]],
        inputs: {
          attributes: [1, "attributes"],
          link: [1, "link"],
          openLinkInNewTab: [1, "openLinkInNewTab"],
          builderLinkComponent: [1, "builderLinkComponent"],
          text: [1, "text"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 5,
        consts: [[3, "attributes", "TagName", "actionAttributes"]],
        template: function Button_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "dynamic-renderer", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("attributes", ctx.attrs())("TagName", ctx.link() ? ctx.builderLinkComponent() || "a" : "button")("actionAttributes", i0.ɵɵpureFunction0(4, _c5));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.text(), " ");
          }
        },
        dependencies: [CommonModule, DynamicRenderer],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return Button;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BuilderContext = /*#__PURE__*/(() => {
  class BuilderContext {
    rootSetState() {}
    constructor() {
      this.content = null;
      this.context = {};
      this.localState = undefined;
      this.rootState = {};
      this.apiKey = null;
      this.apiVersion = undefined;
      this.componentInfos = {};
      this.inheritedStyles = {};
      this.BlocksWrapper = "div";
      this.BlocksWrapperProps = {};
      this.nonce = "";
      this.model = "";
    }
    static {
      this.ɵfac = function BuilderContext_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BuilderContext)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BuilderContext,
        factory: BuilderContext.ɵfac,
        providedIn: "root"
      });
    }
  }
  return BuilderContext;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ComponentsContext = /*#__PURE__*/(() => {
  class ComponentsContext {
    constructor() {
      this.registeredComponents = {};
    }
    static {
      this.ɵfac = function ComponentsContext_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ComponentsContext)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ComponentsContext,
        factory: ComponentsContext.ɵfac,
        providedIn: "root"
      });
    }
  }
  return ComponentsContext;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MSG_PREFIX = '[Builder.io]: ';
const logger = {
  log: (...message) => console.log(MSG_PREFIX, ...message),
  error: (...message) => console.error(MSG_PREFIX, ...message),
  warn: (...message) => console.warn(MSG_PREFIX, ...message),
  debug: (...message) => console.debug(MSG_PREFIX, ...message)
};
const get = (obj, path, defaultValue) => {
  const result = String.prototype.split.call(path, /[,[\].]+?/).filter(Boolean).reduce((res, key) => res !== null && res !== undefined ? res[key] : res, obj);
  return result === undefined || result === obj ? defaultValue : result;
};
function isBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
const convertSearchParamsToQueryObject = searchParams => {
  const options = {};
  searchParams.forEach((value, key) => {
    options[key] = value;
  });
  return options;
};
const normalizeSearchParams = searchParams => searchParams instanceof URLSearchParams ? convertSearchParamsToQueryObject(searchParams) : searchParams;
const getSearchString = search => {
  if (typeof search === 'string') {
    return search;
  } else if (search instanceof URLSearchParams) {
    return search.toString();
  }
  return new URLSearchParams(search).toString();
};
function isIframe() {
  return isBrowser() && window.self !== window.top;
}
function isEditing(search) {
  return isIframe() && (TARGET === 'reactNative' ||
  // accessing window.location.search is safe here because `isIframe()` is only `true` if we're in a browser.
  getSearchString(search || window.location.search).indexOf('builder.frameEditing=') !== -1);
}
const getLocation = () => {
  if (TARGET === 'reactNative') {
    return null;
  } else if (isBrowser()) {
    const parsedLocation = new URL(location.href);
    // IE11 bug with parsed path being empty string
    // causes issues with our user targeting
    if (parsedLocation.pathname === '') {
      parsedLocation.pathname = '/';
    }
    return parsedLocation;
  } else {
    console.warn('Cannot get location for tracking in non-browser environment');
    return null;
  }
};
const getUserAgent = () => typeof navigator === 'object' && navigator.userAgent || '';
const getUserAttributes = () => {
  const userAgent = getUserAgent();
  const isMobile = {
    Android() {
      return userAgent.match(/Android/i);
    },
    BlackBerry() {
      return userAgent.match(/BlackBerry/i);
    },
    iOS() {
      return userAgent.match(/iPhone|iPod/i);
    },
    Opera() {
      return userAgent.match(/Opera Mini/i);
    },
    Windows() {
      return userAgent.match(/IEMobile/i) || userAgent.match(/WPDesktop/i);
    },
    any() {
      return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows() || TARGET === 'reactNative';
    }
  };
  const isTablet = userAgent.match(/Tablet|iPad/i);
  const url = getLocation();
  return {
    urlPath: url?.pathname,
    host: url?.host || url?.hostname,
    device: isTablet ? 'tablet' : isMobile.any() ? 'mobile' : 'desktop'
  };
};
const getFunctionArguments = ({
  builder,
  context,
  event,
  state
}) => {
  return Object.entries({
    state,
    Builder: builder,
    // legacy
    builder,
    context,
    event
  });
};
const getBuilderGlobals = () => ({
  isEditing: isEditing(),
  isBrowser: isBrowser(),
  isServer: !isBrowser(),
  getUserAttributes: () => getUserAttributes()
});
const parseCode = (code, {
  isExpression = true
}) => {
  // Be able to handle simple expressions like "state.foo" or "1 + 1"
  // as well as full blocks like "var foo = "bar"; return foo"
  const useReturn =
  // we disable this for cases where we definitely don't want a return
  isExpression && !(code.includes(';') || code.includes(' return ') || code.trim().startsWith('return '));
  const useCode = useReturn ? `return (${code});` : code;
  return useCode;
};
function flattenState({
  rootState,
  localState,
  rootSetState
}) {
  return new Proxy(rootState, {
    get: (target, prop) => {
      if (localState && prop in localState) {
        return localState[prop];
      }
      const val = target[prop];
      if (typeof val === 'object' && val !== null) {
        return flattenState({
          rootState: val,
          localState: undefined,
          rootSetState: rootSetState ? subState => {
            target[prop] = subState;
            rootSetState(target);
          } : undefined
        });
      }
      return val;
    },
    set: (target, prop, value) => {
      if (localState && prop in localState) {
        throw new Error('Writing to local state is not allowed as it is read-only.');
      }
      target[prop] = value;
      rootSetState?.(target);
      return true;
    }
  });
}
const runInBrowser = ({
  code,
  builder,
  context,
  event,
  localState,
  rootSetState,
  rootState
}) => {
  const functionArgs = getFunctionArguments({
    builder,
    context,
    event,
    state: flattenState({
      rootState,
      localState,
      rootSetState
    })
  });
  return new Function(...functionArgs.map(([name]) => name), code)(...functionArgs.map(([, value]) => value));
};
const checkIsDefined = maybeT => maybeT !== null && maybeT !== undefined;

/**
 * Identifies node runtime
 */
function isNodeRuntime() {
  return typeof process !== 'undefined' && checkIsDefined(process?.versions?.node);
}
const shouldForceBrowserRuntimeInNode = ({
  shouldLogWarning
}) => {
  if (!isNodeRuntime()) return false;
  const isArm64 = process.arch === 'arm64';
  const isNode20 = process.version.startsWith('v20');
  const hasNoNodeSnapshotNodeOption = process.env.NODE_OPTIONS?.includes('--no-node-snapshot');
  if (isArm64 && isNode20 && !hasNoNodeSnapshotNodeOption) {
    if (shouldLogWarning) {
      logger.log(`Skipping usage of \`isolated-vm\` to avoid crashes in Node v20 on an arm64 machine.
    If you would like to use the \`isolated-vm\` package on this machine, please provide the \`NODE_OPTIONS=--no-node-snapshot\` config to your Node process.
    See https://github.com/BuilderIO/builder/blob/main/packages/sdks/README.md#node-v20--m1-macs-apple-silicon-support for more information.
    `);
    }
    return true;
  }
  return false;
};

/*
 * THIS FILE IS EXPECTED TO EXIST WITH THIS EXACT NAME BY SUBSEQUENT BUNDLE STEPS THAT TRANSFORM IT.
 * DO NOT RENAME THIS FILE.
 */
/**
 * Even though we have separate runtimes for browser/node/edge, sometimes frameworks will
 * end up sending the server runtime code to the browser (most notably in dev mode).
 */
const chooseBrowserOrServerEval = args => isBrowser() || shouldForceBrowserRuntimeInNode({
  shouldLogWarning: true
}) ? runInBrowser(args) : runInBrowser(args);

/**
 * handles multi-level gets on state: `state.x.y.z`
 * does not handle bracket notation
 * see https://regexr.com/87a9j
 */
const STATE_GETTER_REGEX = /^(return )?(\s*)?state(?<getPath>(\.\w+)+)(\s*);?$/;
/**
 * Handles multi-level gets on state transpiled by rollup with virtual index.
 * see https://regexr.com/87ai4
 */
const VIRTUAL_INDEX_REGEX = /(\s)*var(\s)+_virtual_index(\s)*=(\s)*state(?<getPath>(\.\w+)+)(\s*);?(\s)*return(\s)*_virtual_index(\s)*/;
const getSimpleExpressionGetPath = code => {
  return STATE_GETTER_REGEX.exec(code.trim())?.groups?.getPath?.slice(1) || VIRTUAL_INDEX_REGEX.exec(code.trim())?.groups?.getPath?.slice(1);
};
function evaluate({
  code,
  context,
  localState,
  rootState,
  rootSetState,
  event,
  isExpression = true
}) {
  if (code.trim() === '') {
    return undefined;
  }
  /**
   * For very simple expressions like "state.foo" we can optimize by skipping
   * the executor altogether.
   * We try not to take many risks with this optimizations, so we only do it for
   * `state.{path}` expressions.
   */
  const getPath = getSimpleExpressionGetPath(code.trim());
  if (getPath) {
    return get({
      ...rootState,
      ...localState
    }, getPath);
  }
  const args = {
    code: parseCode(code, {
      isExpression
    }),
    builder: getBuilderGlobals(),
    context,
    event,
    rootSetState,
    rootState,
    localState
  };
  try {
    const newEval = chooseBrowserOrServerEval(args);
    return newEval;
  } catch (e) {
    logger.error('Failed code evaluation: ' + e.message, {
      code
    });
    return undefined;
  }
}
function getBlockComponentOptions(block, context) {
  return {
    ...block.component?.options,
    ...block.options,
    ...evaluateTextComponentTextOption(block, context)
  };
}
const evaluateTextComponentTextOption = (block, context) => {
  if (block.component?.name === 'Text' && block.component.options?.text && typeof block.component.options.text === 'string') {
    return {
      ...block.component.options,
      text: block.component.options.text.replace(/{{([^}]+)}}/g, (_match, group) => evaluate({
        code: group,
        context,
        localState: context.localState,
        rootState: context.rootState,
        rootSetState: context.rootSetState
      }))
    };
  }
};
function omit(obj, ...values) {
  const newObject = Object.assign({}, obj);
  for (const key of values) {
    delete newObject[key];
  }
  return newObject;
}

/**
 * Recursively traverses an object or array, invoking a callback on each value.
 *
 * @param {any} obj - The object or array to traverse. Can also handle primitives, null, or undefined.
 * @param {TraverseCallback} callback - The function to invoke on each value. Receives the current value
 * and an `update` function to modify the value in its parent container.
 * @param {any} [parent=null] - The parent object or array of the current value. Used internally.
 * @param {any} [key=null] - The key or index of the current value in its parent. Used internally.
 * @param {WeakSet} [visited=new WeakSet()] - Tracks visited objects to handle circular references. Used internally.
 *
 * @example
 * // Example: Doubling all numbers in an object
 * const obj = { a: 1, b: [2, 3, { c: 4 }] };
 * traverse(obj, (value, update) => {
 *   if (typeof value === 'number') {
 *     update(value * 2);
 *   }
 * });
 * console.log(obj); // { a: 2, b: [4, 6, { c: 8 }] }
 *
 * @example
 * // Example: Handling circular references
 * const obj = { a: 1 };
 * obj.self = obj;
 * traverse(obj, (value, update) => {
 *   if (typeof value === 'number') {
 *     update(value * 2);
 *   }
 * });
 * console.log(obj.a); // 2
 */
function traverse(obj, callback, parent = null, key = null, visited = new WeakSet()) {
  if (obj == null || typeof obj !== 'object') {
    callback(obj, newValue => {
      if (parent !== null && key !== null) {
        parent[key] = newValue;
      }
    });
    return;
  }
  if (visited.has(obj)) {
    return;
  }
  visited.add(obj);
  if (Array.isArray(obj)) {
    obj.forEach((item, index) => {
      const update = newValue => {
        obj[index] = newValue;
      };
      callback(item, update);
      traverse(item, callback, obj, index, visited);
    });
  } else {
    Object.entries(obj).forEach(([key, value]) => {
      const update = newValue => {
        obj[key] = newValue;
      };
      callback(value, update);
      traverse(value, callback, obj, key, visited);
    });
  }
}
function isLocalizedField(value) {
  return value && typeof value === 'object' && value['@type'] === '@builder.io/core:LocalizedValue';
}
function containsLocalizedValues(data) {
  if (!data || !Object.getOwnPropertyNames(data).length) {
    return false;
  }
  let hasLocalizedValues = false;
  traverse(data, value => {
    if (isLocalizedField(value)) {
      hasLocalizedValues = true;
      return;
    }
  });
  return hasLocalizedValues;
}
function extractLocalizedValues(data, locale) {
  if (!data || !Object.getOwnPropertyNames(data).length) {
    return {};
  }
  traverse(data, (value, update) => {
    if (isLocalizedField(value)) {
      update(value[locale] ?? undefined);
    }
  });
  return data;
}
function resolveLocalizedValues(block, locale) {
  if (block.component?.options && containsLocalizedValues(block.component?.options)) {
    if (!locale) {
      console.warn('[Builder.io] In order to use localized fields in Builder, you must pass a locale prop to the BuilderComponent or to options object while fetching the content to resolve localized fields. Learn more: https://www.builder.io/c/docs/localization-inline#targeting-and-inline-localization');
    }
    block.component.options = extractLocalizedValues(block.component.options, locale ?? 'Default');
  }
  return block;
}

/**
 * We need to serialize values to a string in case there are Proxy values, as is the case with SolidJS etc.
 */
const fastClone = obj => JSON.parse(JSON.stringify(obj));

/**
 * Minimal implementation of lodash's _.set
 * https://lodash.com/docs/4.17.15#set
 *
 * See ./set.test.ts for usage examples
 */
const set = (obj, _path, value) => {
  if (Object(obj) !== obj) {
    return obj;
  }
  const path = Array.isArray(_path) ? _path : _path.toString().match(/[^.[\]]+/g);
  path.slice(0, -1).reduce((a, c, i) => Object(a[c]) === a[c] ? a[c] : a[c] = Math.abs(Number(path[i + 1])) >> 0 === +path[i + 1] ? [] : {}, obj)[path[path.length - 1]] = value;
  return obj;
};

// Noope way for targets to make modifications to the block object if/as needed
function transformBlock(block) {
  return block;
}

// Deep clone a block but without cloning any child blocks
function deepCloneWithConditions(obj) {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(item => deepCloneWithConditions(item));
  }
  if (obj['@type'] === '@builder.io/sdk:Element') {
    return obj;
  }
  const clonedObj = {};
  for (const key in obj) {
    if (key !== 'meta' && Object.prototype.hasOwnProperty.call(obj, key)) {
      clonedObj[key] = deepCloneWithConditions(obj[key]);
    }
  }
  return clonedObj;
}
const IS_SDK_WITHOUT_CACHED_PROCESSED_BLOCK = ['svelte', 'vue', 'angular', 'qwik', 'solid'].includes(TARGET);
const getCopy = block => {
  if (IS_SDK_WITHOUT_CACHED_PROCESSED_BLOCK) {
    const copy = fastClone(block);
    const copied = {
      ...copy,
      properties: {
        ...copy.properties
      },
      actions: {
        ...copy.actions
      }
    };
    return copied;
  } else {
    const copy = deepCloneWithConditions(omit(block, 'children', 'meta'));
    return {
      ...copy,
      properties: {
        ...copy.properties
      },
      actions: {
        ...copy.actions
      },
      children: block.children,
      meta: block.meta
    };
  }
};
const evaluateBindings = ({
  block,
  context,
  localState,
  rootState,
  rootSetState
}) => {
  if (!block.bindings) {
    return block;
  }
  const copied = getCopy(block);
  for (const binding in block.bindings) {
    const expression = block.bindings[binding];
    const value = evaluate({
      code: expression,
      localState,
      rootState,
      rootSetState,
      context
    });
    set(copied, binding, value);
  }
  return copied;
};
function getProcessedBlock({
  block,
  context,
  localState,
  rootState,
  rootSetState
}) {
  let transformedBlock = transformBlock(block);
  transformedBlock = evaluateBindings({
    block: transformedBlock,
    localState,
    rootState,
    rootSetState,
    context
  });
  transformedBlock = resolveLocalizedValues(transformedBlock, rootState.locale);
  return transformedBlock;
}
let DynamicDiv = /*#__PURE__*/(() => {
  class DynamicDiv {
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input(undefined);
      this.actionAttributes = input(undefined);
      this.BlockWrapperProps = input(undefined);
      this.builderPath = input(undefined, {
        alias: 'builder-path'
      });
      this.builderParentId = input(undefined, {
        alias: 'builder-parent-id'
      });
      this.BlocksWrapperProps = input(undefined);
      this.contentWrapperProps = input(undefined);
      this.builderModel = input(undefined, {
        alias: 'builder-model'
      });
      this.builderContentId = input(undefined, {
        alias: 'builder-content-id'
      });
      this.ref = input(undefined);
      this.classProp = input(undefined, {
        alias: 'class'
      });
      this.style = input(undefined);
      this.showContentProps = input(undefined);
      this.onClick = input(undefined);
      this.onMouseEnter = input(undefined);
      this.onKeyPress = input(undefined);
      this.hidden = input(undefined);
      this.ariaHidden = input(undefined, {
        alias: 'aria-hidden'
      });
      this.className = input(undefined);
      this.v = viewChild('v');
      this._listenerFns = new Map();
    }
    ngAfterViewInit() {
      const el = this.v()?.nativeElement;
      if (!el) {
        return;
      }
      this.setAttributes(el, this.attributes());
      this.setAttributes(el, this.actionAttributes());
      this.setAttributes(el, this.showContentProps());
      this.setAttribute(el, 'class', [this.classProp() ?? '', this.className() ?? ''].join(' ').trim());
      this.handleStyleProp(el, this.style());
      this.setAttribute(el, 'builder-parent-id', this.builderParentId());
      this.setAttribute(el, 'builder-path', this.builderPath());
      this.setAttribute(el, 'builder-model', this.builderModel());
      this.setAttribute(el, 'builder-content-id', this.builderContentId());
      this.setAttribute(el, 'hidden', this.hidden());
      this.setAttribute(el, 'aria-hidden', this.ariaHidden());
    }
    ngOnChanges(changes) {
      const el = this.v()?.nativeElement;
      if (!el) {
        return;
      }
      if (Object.keys(changes).length === 0) {
        return;
      }
      if (changes.attributes && JSON.stringify(changes.attributes.currentValue) !== JSON.stringify(changes.attributes.previousValue)) {
        this.setAttributes(el, this.attributes(), changes.attributes.currentValue);
      }
      if (changes.actionAttributes && Object.keys(changes.actionAttributes.currentValue).length > 0) {
        this.setAttributes(el, this.actionAttributes(), changes.actionAttributes.currentValue);
      }
      if (changes.showContentProps) {
        this.setAttributes(el, this.showContentProps(), changes.showContentProps.currentValue);
      }
      if (changes.classProp || changes.className) {
        this.setAttribute(el, 'class', [this.classProp() ?? '', this.className() ?? ''].join(' ').trim());
      }
      if (changes.style) this.handleStyleProp(el, this.style());
      if (changes.builderParentId) this.setAttribute(el, 'builder-parent-id', this.builderParentId());
      if (changes.builderPath) this.setAttribute(el, 'builder-path', this.builderPath());
      if (changes.builderModel) this.setAttribute(el, 'builder-model', this.builderModel());
      if (changes.builderContentId) this.setAttribute(el, 'builder-content-id', this.builderContentId());
      if (changes.hidden) this.setAttribute(el, 'hidden', this.hidden());
      if (changes.ariaHidden) this.setAttribute(el, 'aria-hidden', this.ariaHidden());
    }
    setAttributes(el, value, changes) {
      if (!el) return;
      const target = changes ? changes : value;
      if (!target) return;
      Object.keys(target).forEach(key => {
        if (key.startsWith('on')) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace('on', '').toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key, target[key] ?? '');
        }
      });
    }
    setAttribute(el, key, value) {
      if (value) {
        this.renderer.setAttribute(el, key, value);
      }
    }
    handleStyleProp(el, style) {
      if (!style) return;
      if (typeof style === 'object') {
        Object.entries(style).forEach(([key, value]) => {
          this.renderer.setStyle(el, key, value);
        });
      } else {
        this.renderer.setAttribute(el, 'style', style);
      }
    }
    ngOnDestroy() {
      this._listenerFns.forEach(fn => fn());
    }
    static {
      this.ɵfac = function DynamicDiv_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicDiv)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicDiv,
        selectors: [["dynamic-div"], ["DynamicDiv"]],
        viewQuery: function DynamicDiv_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.v, _c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          actionAttributes: [1, "actionAttributes"],
          BlockWrapperProps: [1, "BlockWrapperProps"],
          builderPath: [1, "builder-path", "builderPath"],
          builderParentId: [1, "builder-parent-id", "builderParentId"],
          BlocksWrapperProps: [1, "BlocksWrapperProps"],
          contentWrapperProps: [1, "contentWrapperProps"],
          builderModel: [1, "builder-model", "builderModel"],
          builderContentId: [1, "builder-content-id", "builderContentId"],
          ref: [1, "ref"],
          classProp: [1, "class", "classProp"],
          style: [1, "style"],
          showContentProps: [1, "showContentProps"],
          onClick: [1, "onClick"],
          onMouseEnter: [1, "onMouseEnter"],
          onKeyPress: [1, "onKeyPress"],
          hidden: [1, "hidden"],
          ariaHidden: [1, "aria-hidden", "ariaHidden"],
          className: [1, "className"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["v", ""], [3, "click", "mouseenter"]],
        template: function DynamicDiv_Template1(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵlistener("click", function DynamicDiv_Template1_div_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClick() && ctx.onClick()($event));
            })("mouseenter", function DynamicDiv_Template1_div_mouseenter_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onMouseEnter() && ctx.onMouseEnter()($event));
            });
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [CommonModule],
        styles: ["[_nghost-%COMP%]{display:contents}", ".this-blocks-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:stretch}"]
      });
    }
  }
  return DynamicDiv;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const camelToKebabCase = str => str ? str.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase() : '';

// eslint-disable-next-line @typescript-eslint/ban-types
function throttle(func, wait, options = {}) {
  let context;
  let args;
  let result;
  let timeout = null;
  let previous = 0;
  const later = function () {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    const now = Date.now();
    if (!previous && options.leading === false) previous = now;
    const remaining = wait - (now - previous);
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    context = this;
    // eslint-disable-next-line prefer-rest-params
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}
function assign(target, ..._args) {
  const to = Object(target);
  for (let index = 1; index < arguments.length; index++) {
    // eslint-disable-next-line prefer-rest-params
    const nextSource = arguments[index];
    if (nextSource != null) {
      // Skip over if undefined or null
      for (const nextKey in nextSource) {
        // Avoid bugs when hasOwnProperty is shadowed
        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
          to[nextKey] = nextSource[nextKey];
        }
      }
    }
  }
  return to;
}
function bindAnimations(animations) {
  if (TARGET === 'reactNative') {
    return;
  }
  for (const animation of animations) {
    switch (animation.trigger) {
      case 'pageLoad':
        triggerAnimation(animation);
        break;
      case 'scrollInView':
        bindScrollInViewAnimation(animation);
        break;
    }
  }
}
function warnElementNotPresent(id) {
  console.warn(`Cannot animate element: element with ID ${id} not found!`);
}
function augmentAnimation(animation, element) {
  const stylesUsed = getAllStylesUsed(animation);
  const computedStyle = getComputedStyle(element);
  // const computedStyle = getComputedStyle(element);
  // // FIXME: this will break if original load is in one reponsive size then resize to another hmmm
  // Need to use transform instead of left since left can change on screen sizes
  const firstStyles = animation.steps[0].styles;
  const lastStyles = animation.steps[animation.steps.length - 1].styles;
  const bothStyles = [firstStyles, lastStyles];
  // FIXME: this won't work as expected for augmented animations - may need the editor itself to manage this
  for (const styles of bothStyles) {
    for (const style of stylesUsed) {
      if (!(style in styles)) {
        styles[style] = computedStyle[style];
      }
    }
  }
}
function getAllStylesUsed(animation) {
  const properties = [];
  for (const step of animation.steps) {
    for (const key in step.styles) {
      if (properties.indexOf(key) === -1) {
        properties.push(key);
      }
    }
  }
  return properties;
}
function triggerAnimation(animation) {
  // TODO: do for ALL elements
  const elements = Array.prototype.slice.call(document.getElementsByClassName(animation.elementId || animation.id || ''));
  if (!elements.length) {
    warnElementNotPresent(animation.elementId || animation.id || '');
    return;
  }
  Array.from(elements).forEach(element => {
    augmentAnimation(animation, element);
    // TODO: do this properly, may have other animations of different properties
    // TODO: only override the properties
    // TODO: if there is an entrance and hover animation, the transition duration will get effed
    // element.setAttribute('style', '');
    // const styledUsed = this.getAllStylesUsed(animation);
    element.style.transition = 'none';
    element.style.transitionDelay = '0';
    assign(element.style, animation.steps[0].styles);
    // TODO: queue/batch these timeouts
    // TODO: only include properties explicitly set in the animation
    // using Object.keys(styles)
    setTimeout(() => {
      element.style.transition = `all ${animation.duration}s ${camelToKebabCase(animation.easing)}`;
      if (animation.delay) {
        element.style.transitionDelay = animation.delay + 's';
      }
      assign(element.style, animation.steps[1].styles);
      // TODO: maybe remove/reset transitoin property after animation duration
      // TODO: queue timers
      setTimeout(() => {
        // TODO: what if has other transition (reset back to what it was)
        element.style.transition = '';
        element.style.transitionDelay = '';
      }, (animation.delay || 0) * 1000 + animation.duration * 1000 + 100);
    });
  });
}
// TODO: unbind on element remove
function bindScrollInViewAnimation(animation) {
  // TODO: apply to ALL matching elements
  const elements = Array.prototype.slice.call(document.getElementsByClassName(animation.elementId || animation.id || ''));
  if (!elements.length) {
    warnElementNotPresent(animation.elementId || animation.id || '');
    return;
  }
  // TODO: if server side rendered and scrolled into view don't animate...
  Array.from(elements).forEach(element => {
    augmentAnimation(animation, element);
    let triggered = false;
    let pendingAnimation = false;
    function immediateOnScroll() {
      if (!triggered && isScrolledIntoView(element)) {
        triggered = true;
        pendingAnimation = true;
        setTimeout(() => {
          assign(element.style, animation.steps[1].styles);
          if (!animation.repeat) {
            document.removeEventListener('scroll', onScroll);
          }
          setTimeout(() => {
            pendingAnimation = false;
            if (!animation.repeat) {
              element.style.transition = '';
              element.style.transitionDelay = '';
            }
          }, (animation.duration + (animation.delay || 0)) * 1000 + 100);
        });
      } else if (animation.repeat && triggered && !pendingAnimation && !isScrolledIntoView(element)) {
        // we want to repeat the animation every time the the element is out of view and back again
        triggered = false;
        assign(element.style, animation.steps[0].styles);
      }
    }
    // TODO: roll all of these in one for more efficiency of checking all the rects
    const onScroll = throttle(immediateOnScroll, 200, {
      leading: false
    });
    // TODO: fully in view or partially
    function isScrolledIntoView(elem) {
      const rect = elem.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const thresholdPercent = (animation.thresholdPercent || 0) / 100;
      const threshold = thresholdPercent * windowHeight;
      // TODO: partial in view? or what if element is larger than screen itself
      return rect.bottom > threshold && rect.top < windowHeight - threshold // Element is peeking top or bottom
      ;
    }
    const defaultState = animation.steps[0].styles;
    function attachDefaultState() {
      assign(element.style, defaultState);
    }
    attachDefaultState();
    // TODO: queue/batch these timeouts!
    setTimeout(() => {
      element.style.transition = `all ${animation.duration}s ${camelToKebabCase(animation.easing)}`;
      if (animation.delay) {
        element.style.transitionDelay = animation.delay + 's';
      }
    });
    // TODO: one listener for everything
    document.addEventListener('scroll', onScroll, {
      capture: true,
      passive: true
    });
    // Do an initial check
    immediateOnScroll();
  });
}
const TEXT_STYLE_KEYS = ['color', 'whiteSpace', 'direction', 'hyphens', 'overflowWrap'];
/**
 * Check if the key represent a CSS style property that applies to text
 * See MDN docs for refrence of what properties apply to text.
 * https://developer.mozilla.org/en-US/docs/Learn/CSS/Styling_text/Fundamentals#summary
 */
const isTextStyle = key => {
  return TEXT_STYLE_KEYS.includes(key) || key.startsWith('font') || key.startsWith('text') || key.startsWith('letter') || key.startsWith('line') || key.startsWith('word') || key.startsWith('writing');
};
/**
 * Extract styles that apply to text from a style object.
 */
const extractTextStyles = styles => {
  const textStyles = {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Object.entries(styles).forEach(([key, value]) => {
    if (isTextStyle(key)) {
      textStyles[key] = value;
    }
  });
  return textStyles;
};
const convertStyleMapToCSSArray = style => {
  const cssProps = Object.entries(style).map(([key, value]) => {
    if (typeof value === 'string') {
      return `${camelToKebabCase(key)}: ${value};`;
    } else {
      return undefined;
    }
  });
  return cssProps.filter(checkIsDefined);
};
const convertStyleMapToCSS = style => convertStyleMapToCSSArray(style).join('\n');
const createCssClass = ({
  mediaQuery,
  className,
  styles
}) => {
  const cssClass = `.${className} {
    ${convertStyleMapToCSS(styles)}
  }`;
  if (mediaQuery) {
    return `${mediaQuery} {
      ${cssClass}
    }`;
  } else {
    return cssClass;
  }
};
function transformStyleProperty({
  style
}) {
  return style;
}
const getStyle = ({
  block,
  context
}) => {
  return mapStyleObjToStrIfNeeded(transformStyleProperty({
    style: block.style || {},
    context,
    block
  }));
};
/**
 * Svelte does not support style attribute as an object so we need to flatten it.
 *
 * Additionally, Svelte, Vue and other frameworks use kebab-case styles, so we need to convert them.
 */
function mapStyleObjToStrIfNeeded(style) {
  switch (TARGET) {
    case 'svelte':
    case 'vue':
    case 'solid':
    case 'angular':
      return convertStyleMapToCSSArray(style).join(' ');
    case 'qwik':
    case 'reactNative':
    case 'react':
    case 'rsc':
      return style;
  }
}
const checkIsComponentRestricted = (component, model) => {
  if (!component) return true;
  if (!model) return false;
  return component.models && component.models.length > 0 && !component.models.includes(model);
};
const getComponent = ({
  block,
  registeredComponents,
  model
}) => {
  const componentName = block.component?.name;
  if (!componentName) {
    return null;
  }
  const ref = registeredComponents[componentName];
  if (!ref || checkIsComponentRestricted(ref, model)) {
    // TODO: Public doc page with more info about this message
    console.warn(`
      Could not find a registered component named "${componentName}". 
      If you registered it, is the file that registered it imported by the file that needs to render it?`);
    return undefined;
  } else {
    return ref;
  }
};
const getRepeatItemData = ({
  block,
  context
}) => {
  /**
   * we don't use `state.processedBlock` here because the processing done within its logic includes evaluating the block's bindings,
   * which will not work if there is a repeat.
   */
  const {
    repeat,
    ...blockWithoutRepeat
  } = block;
  if (!repeat?.collection) {
    return undefined;
  }
  const itemsArray = evaluate({
    code: repeat.collection,
    localState: context.localState,
    rootState: context.rootState,
    rootSetState: context.rootSetState,
    context: context.context
  });
  if (!Array.isArray(itemsArray)) {
    return undefined;
  }
  const collectionName = repeat.collection.split('.').pop();
  const itemNameToUse = repeat.itemName || (collectionName ? collectionName + 'Item' : 'item');
  const repeatArray = itemsArray.map((item, index) => ({
    context: {
      ...context,
      localState: {
        ...context.localState,
        $index: index,
        $item: item,
        [itemNameToUse]: item,
        [`$${itemNameToUse}Index`]: index
      }
    },
    block: blockWithoutRepeat
  }));
  return repeatArray;
};
const getInheritedStyles = ({
  block,
  context
}) => {
  const style = getStyle({
    block,
    context
  });
  if (!style) {
    return {};
  }
  return extractTextStyles(style);
};
const provideLinkComponent = (block, linkComponent) => {
  if (block?.shouldReceiveBuilderProps?.builderLinkComponent) return {
    builderLinkComponent: linkComponent
  };
  return {};
};
const provideRegisteredComponents = (block, registeredComponents, model) => {
  if (block?.shouldReceiveBuilderProps?.builderComponents) {
    const filteredRegisteredComponents = Object.fromEntries(Object.entries(registeredComponents).filter(([_, component]) => {
      return !checkIsComponentRestricted(component, model);
    }));
    return {
      builderComponents: filteredRegisteredComponents
    };
  }
  return {};
};
const provideBuilderBlock = (block, builderBlock) => {
  if (block?.shouldReceiveBuilderProps?.builderBlock) return {
    builderBlock
  };
  return {};
};
const provideBuilderContext = (block, context) => {
  if (block?.shouldReceiveBuilderProps?.builderContext) return {
    builderContext: context
  };
  return {};
};
const generateKey = index => {
  //This does not handle the case in Qwik
  return index.toString();
};
const SIZES = {
  xsmall: {
    min: 0,
    default: 160,
    max: 320
  },
  small: {
    min: 321,
    default: 321,
    max: 640
  },
  medium: {
    min: 641,
    default: 642,
    max: 991
  },
  large: {
    min: 990,
    default: 991,
    max: 1200
  }
};
const getMaxWidthQueryForSize = (size, sizeValues = SIZES) => `@media (max-width: ${sizeValues[size].max}px)`;
const getSizesForBreakpoints = breakpoints => {
  const newSizes = fastClone(SIZES); // Note: this helps to get a deep clone of fields like small, medium etc
  if (!breakpoints) {
    return newSizes;
  }
  const {
    xsmall,
    small,
    medium
  } = breakpoints;
  if (xsmall) {
    const xsmallMin = Math.floor(xsmall / 2);
    newSizes.xsmall = {
      max: xsmall,
      min: xsmallMin,
      default: xsmallMin + 1
    };
  }
  if (!small || !medium) {
    return newSizes;
  }
  const smallMin = xsmall ? newSizes.xsmall.max + 1 : Math.floor(small / 2);
  newSizes.small = {
    max: small,
    min: smallMin,
    default: smallMin + 1
  };
  const mediumMin = newSizes.small.max + 1;
  newSizes.medium = {
    max: medium,
    min: mediumMin,
    default: mediumMin + 1
  };
  const largeMin = newSizes.medium.max + 1;
  newSizes.large = {
    max: 2000,
    // TODO: decide upper limit
    min: largeMin,
    default: largeMin + 1
  };
  return newSizes;
};
let InlinedStyles = /*#__PURE__*/(() => {
  class InlinedStyles {
    constructor(renderer, elRef) {
      this.renderer = renderer;
      this.elRef = elRef;
      this.styles = input.required();
      this.id = input.required();
      this.nonce = input.required();
    }
    ngOnChanges(changes) {
      if (changes.styles) {
        if (this.styleElement) {
          this.styleElement.textContent = this.styles();
        } else {
          this.styleElement = this.renderer.createElement('style');
          this.renderer.setAttribute(this.styleElement, 'data-id', this.id());
          this.renderer.appendChild(this.styleElement, this.renderer.createText(this.styles()));
          this.renderer.setAttribute(this.styleElement, 'nonce', this.nonce());
          this.renderer.appendChild(this.elRef.nativeElement, this.styleElement);
        }
      }
    }
    static {
      this.ɵfac = function InlinedStyles_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InlinedStyles)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InlinedStyles,
        selectors: [["inlined-styles"], ["InlinedStyles"]],
        inputs: {
          styles: [1, "styles"],
          id: [1, "id"],
          nonce: [1, "nonce"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 0,
        vars: 0,
        template: function InlinedStyles_Template(rf, ctx) {},
        dependencies: [CommonModule],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return InlinedStyles;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BlockStyles = /*#__PURE__*/(() => {
  class BlockStyles {
    constructor() {
      this.TARGET = TARGET;
      this.block = input();
      this.context = input();
      this.canShowBlock = computed(() => {
        const processedBlock = this.block();
        // only render styles for blocks that are visible
        if (checkIsDefined(processedBlock.hide)) {
          return !processedBlock.hide;
        }
        if (checkIsDefined(processedBlock.show)) {
          return processedBlock.show;
        }
        return true;
      });
      this.css = computed(() => {
        const processedBlock = this.block();
        const styles = processedBlock.responsiveStyles;
        const content = this.context().content;
        const sizesWithUpdatedBreakpoints = getSizesForBreakpoints(content?.meta?.breakpoints || {});
        const contentHasXSmallBreakpoint = Boolean(content?.meta?.breakpoints?.xsmall);
        const largeStyles = styles?.large;
        const mediumStyles = styles?.medium;
        const smallStyles = styles?.small;
        const xsmallStyles = styles?.xsmall;
        const className = processedBlock.id;
        if (!className) {
          return "";
        }
        const largeStylesClass = largeStyles ? createCssClass({
          className,
          styles: largeStyles
        }) : "";
        const mediumStylesClass = mediumStyles ? createCssClass({
          className,
          styles: mediumStyles,
          mediaQuery: getMaxWidthQueryForSize("medium", sizesWithUpdatedBreakpoints)
        }) : "";
        const smallStylesClass = smallStyles ? createCssClass({
          className,
          styles: smallStyles,
          mediaQuery: getMaxWidthQueryForSize("small", sizesWithUpdatedBreakpoints)
        }) : "";
        const xsmallStylesClass = xsmallStyles && contentHasXSmallBreakpoint ? createCssClass({
          className,
          styles: xsmallStyles,
          mediaQuery: getMaxWidthQueryForSize("xsmall", sizesWithUpdatedBreakpoints)
        }) : "";
        const hoverAnimation = processedBlock.animations && processedBlock.animations.find(item => item.trigger === "hover");
        let hoverStylesClass = "";
        if (hoverAnimation) {
          const hoverStyles = hoverAnimation.steps?.[1]?.styles || {};
          hoverStylesClass = createCssClass({
            className: `${className}:hover`,
            styles: {
              ...hoverStyles,
              transition: `all ${hoverAnimation.duration}s ${camelToKebabCase(hoverAnimation.easing)}`,
              transitionDelay: hoverAnimation.delay ? `${hoverAnimation.delay}s` : "0s"
            }
          }) || "";
        }
        return [largeStylesClass, mediumStylesClass, smallStylesClass, xsmallStylesClass, hoverStylesClass].join(" ");
      });
    }
    static {
      this.ɵfac = function BlockStyles_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BlockStyles)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BlockStyles,
        selectors: [["block-styles"]],
        inputs: {
          block: [1, "block"],
          context: [1, "context"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 1,
        consts: [["id", "builderio-block", 3, "styles", "nonce"]],
        template: function BlockStyles_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, BlockStyles_Conditional_0_Template, 1, 2, "inlined-styles", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.TARGET !== "reactNative" && ctx.css() && ctx.canShowBlock() ? 0 : -1);
          }
        },
        dependencies: [CommonModule, InlinedStyles],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return BlockStyles;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const getEventHandlerName = key => `on${capitalizeFirstLetter(key)}`;
const createEventHandler = (value, options) => event => evaluate({
  code: value,
  context: options.context,
  localState: options.localState,
  rootState: options.rootState,
  rootSetState: options.rootSetState,
  event,
  isExpression: false
});
function getBlockActions(options) {
  const obj = {};
  const optionActions = options.block.actions ?? {};
  for (const key in optionActions) {
    // eslint-disable-next-line no-prototype-builtins
    if (!optionActions.hasOwnProperty(key)) {
      continue;
    }
    const value = optionActions[key];
    let eventHandlerName = getEventHandlerName(key);
    if (options.stripPrefix) {
      switch (TARGET) {
        case 'vue':
          eventHandlerName = eventHandlerName.replace('v-on:', '');
          break;
        case 'svelte':
          eventHandlerName = eventHandlerName.replace('on:', '');
          break;
      }
    }
    obj[eventHandlerName] = createEventHandler(value, options);
  }
  return obj;
}
function transformBlockProperties({
  properties
}) {
  return properties;
}
const extractRelevantRootBlockProperties = block => {
  // currently we are only spreading the `href` property
  // TO-DO: potentially spread all properties from block, but only if they are not already defined by BuilderBlock
  // const {
  //   '@type': _type,
  //   '@version': _version,
  //   id: _id,
  //   tagName: _tagName,
  //   layerName: _layerName,
  //   groupLocked: _groupLocked,
  //   layerLocked: _layerLocked,
  //   class: _class,
  //   children: _children,
  //   responsiveStyles: _responsiveStyles,
  //   component: _component,
  //   bindings: _bindings,
  //   meta: _meta,
  //   actions: _actions,
  //   properties: _properties,
  //   code: _code,
  //   repeat: _repeat,
  //   animations: _animations,
  //   style: _style,
  //   hide: _hide,
  //   show: _show,
  //   // anything set by dynamic bindings outside of predefined `BuilderBlock` properties
  //   ...remainingBlockProperties
  // } = block;
  return {
    href: block.href
  };
};
function getBlockProperties({
  block,
  context
}) {
  const properties = {
    ...extractRelevantRootBlockProperties(block),
    ...block.properties,
    'builder-id': block.id,
    style: getStyle({
      block,
      context
    }),
    [getClassPropName()]: [block.id, 'builder-block', block.class, block.properties?.class].filter(Boolean).join(' ')
  };
  return transformBlockProperties({
    properties,
    context,
    block
  });
}
let BlockWrapper = /*#__PURE__*/(() => {
  class BlockWrapper {
    constructor() {
      this.getBlockProperties = getBlockProperties;
      this.getBlockActions = getBlockActions;
      this.Wrapper = input();
      this.block = input();
      this.context = input();
    }
    static {
      this.ɵfac = function BlockWrapper_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BlockWrapper)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BlockWrapper,
        selectors: [["block-wrapper"]],
        inputs: {
          Wrapper: [1, "Wrapper"],
          block: [1, "block"],
          context: [1, "context"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 2,
        vars: 12,
        consts: [[3, "TagName", "attributes", "actionAttributes"]],
        template: function BlockWrapper_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "dynamic-renderer", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("TagName", ctx.Wrapper())("attributes", ctx.getBlockProperties(i0.ɵɵpureFunction2(3, _c6, ctx.block(), ctx.context())))("actionAttributes", ctx.getBlockActions(i0.ɵɵpureFunction5(6, _c7, ctx.block(), ctx.context().rootState, ctx.context().rootSetState, ctx.context().localState, ctx.context().context)));
          }
        },
        dependencies: [CommonModule, DynamicRenderer],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return BlockWrapper;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Awaiter = /*#__PURE__*/(() => {
  class Awaiter {
    constructor() {
      this.load = input();
      this.props = input();
      this.attributes = input();
      this.fallback = input();
    }
    ngAfterViewInit() {
      if (typeof window !== "undefined") {
        /** this is a hack to include unused props */
        const _ = {
          a: this.load(),
          b: this.props(),
          c: this.attributes(),
          d: this.fallback()
        };
      }
    }
    static {
      this.ɵfac = function Awaiter_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Awaiter)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Awaiter,
        selectors: [["awaiter"]],
        inputs: {
          load: [1, "load"],
          props: [1, "props"],
          attributes: [1, "attributes"],
          fallback: [1, "fallback"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 2,
        vars: 0,
        template: function Awaiter_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementContainerStart(0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementContainerEnd();
          }
        },
        dependencies: [CommonModule],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return Awaiter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InteractiveElement = /*#__PURE__*/(() => {
  class InteractiveElement {
    hasAttributesInput(component) {
      return !!reflectComponentType(component)?.inputs.find(input => input.propName === "attributes");
    }
    filterPropsThatWrapperNeeds(allProps) {
      const definedPropNames = reflectComponentType(this.Wrapper()).inputs.map(prop => prop.propName);
      return definedPropNames.reduce((acc, propName) => {
        acc[propName] = allProps[propName];
        return acc;
      }, {});
    }
    updateAttributes(el, attributes) {
      Object.keys(attributes).forEach(attr => {
        if (attr.startsWith("on")) {
          if (this._listenerFns.has(attr)) {
            this._listenerFns.get(attr)();
          }
          this._listenerFns.set(attr, this.renderer.listen(el, attr.replace("on", "").toLowerCase(), attributes[attr]));
        } else if (attr === "class" && attributes[attr]) {
          const classes = attributes[attr].split(" ");
          classes.forEach(cls => this.renderer.addClass(el, cls.trim()));
        } else {
          this.renderer.setAttribute(el, attr.toLowerCase(), attributes[attr] ?? "");
        }
      });
    }
    constructor(viewContainer, renderer) {
      this.viewContainer = viewContainer;
      this.renderer = renderer;
      this.myContent = signal([]);
      this.wrapperTemplateRef = viewChild("wrapperTemplate");
      this.wrapperProps = input();
      this.block = input();
      this.includeBlockProps = input();
      this.context = input();
      this.Wrapper = input();
      this.forceRenderCount = signal(0);
      this._listenerFns = new Map();
      this.attributes = computed(() => {
        return this.includeBlockProps() ? {
          ...getBlockProperties({
            block: this.block(),
            context: this.context()
          }),
          ...getBlockActions({
            block: this.block(),
            rootState: this.context().rootState,
            rootSetState: this.context().rootSetState,
            localState: this.context().localState,
            context: this.context().context
          })
        } : {};
      });
      this.targetWrapperProps = computed(() => {
        return this.wrapperProps();
      });
      this.dynamicProps_z2itiz = computed(() => {
        return {
          ...this.filterPropsThatWrapperNeeds(this.targetWrapperProps()),
          ...(this.hasAttributesInput(this.Wrapper()) && {
            attributes: this.attributes()
          })
        };
      });
    }
    _updateView() {
      this.myContent.set([this.viewContainer.createEmbeddedView(this.wrapperTemplateRef()).rootNodes]);
    }
    ngAfterViewInit() {
      if (!this.hasAttributesInput(this.Wrapper())) {
        const wrapperElement = this.wrapperTemplateRef()?.elementRef.nativeElement?.nextElementSibling;
        if (wrapperElement) {
          this.updateAttributes(wrapperElement, this.attributes());
        }
      }
    }
    ngAfterContentInit() {
      this._updateView();
    }
    ngOnDestroy() {
      for (const fn of this._listenerFns.values()) {
        fn();
      }
    }
    static {
      this.ɵfac = function InteractiveElement_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InteractiveElement)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InteractiveElement,
        selectors: [["interactive-element"]],
        viewQuery: function InteractiveElement_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.wrapperTemplateRef, _c8, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          wrapperProps: [1, "wrapperProps"],
          block: [1, "block"],
          includeBlockProps: [1, "includeBlockProps"],
          context: [1, "context"],
          Wrapper: [1, "Wrapper"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c9,
        decls: 4,
        vars: 1,
        consts: [["wrapperTemplate", ""], [3, "load", "fallback", "props", "attributes"], [4, "ngComponentOutlet", "ngComponentOutletInputs", "ngComponentOutletContent"]],
        template: function InteractiveElement_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c9);
            i0.ɵɵtemplate(0, InteractiveElement_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, InteractiveElement_Conditional_2_Template, 2, 4, "awaiter", 1)(3, InteractiveElement_Conditional_3_Template, 1, 3, "ng-container");
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.Wrapper().load ? 2 : 3);
          }
        },
        dependencies: [CommonModule, i1.NgComponentOutlet, Awaiter],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return InteractiveElement;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const getWrapperProps = ({
  componentOptions,
  builderBlock,
  context,
  componentRef,
  includeBlockProps,
  isInteractive,
  contextValue
}) => {
  const wrapperPropsWithAttributes = {
    ...componentOptions,
    /**
     * If `noWrap` is set to `true`, then the block's props/attributes are provided to the
     * component itself directly. Otherwise, they are provided to the wrapper element.
     */
    ...(includeBlockProps ? {
      attributes: getBlockProperties({
        block: builderBlock,
        context: contextValue
      })
    } : {})
  };
  const interactiveElementProps = {
    Wrapper: componentRef,
    block: builderBlock,
    context,
    wrapperProps: componentOptions,
    includeBlockProps
  };
  return isInteractive ? interactiveElementProps : wrapperPropsWithAttributes;
};
let ComponentRef = /*#__PURE__*/(() => {
  class ComponentRef {
    trackByChild0(_, child) {
      return child.id;
    }
    constructor(viewContainer) {
      this.viewContainer = viewContainer;
      this.getWrapperProps = getWrapperProps;
      this.myContent = signal([]);
      this.wrapperTemplateRef = viewChild("wrapperTemplate");
      this.isInteractive = input();
      this.componentRef = input();
      this.componentOptions = input();
      this.builderBlock = input();
      this.context = input();
      this.linkComponent = input();
      this.includeBlockProps = input();
      this.blockChildren = input();
      this.registeredComponents = input();
      this.shouldUpdate = signal(false);
      this.Wrapper = signal(undefined);
      this.dynamicProps_vn4rls = computed(() => {
        return {
          ...getWrapperProps({
            componentOptions: this.componentOptions(),
            builderBlock: this.builderBlock(),
            context: this.context(),
            componentRef: this.componentRef(),
            linkComponent: this.linkComponent(),
            includeBlockProps: this.includeBlockProps(),
            isInteractive: this.isInteractive(),
            contextValue: this.context()
          })
        };
      });
    }
    ngOnInit() {
      this.Wrapper.set(this.isInteractive() ? InteractiveElement : this.componentRef());
    }
    _updateView() {
      this.myContent.set([this.viewContainer.createEmbeddedView(this.wrapperTemplateRef()).rootNodes]);
    }
    ngAfterContentInit() {
      this._updateView();
    }
    static {
      this.ɵfac = function ComponentRef_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ComponentRef)(i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ComponentRef,
        selectors: [["component-ref"]],
        viewQuery: function ComponentRef_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.wrapperTemplateRef, _c8, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          isInteractive: [1, "isInteractive"],
          componentRef: [1, "componentRef"],
          componentOptions: [1, "componentOptions"],
          builderBlock: [1, "builderBlock"],
          context: [1, "context"],
          linkComponent: [1, "linkComponent"],
          includeBlockProps: [1, "includeBlockProps"],
          blockChildren: [1, "blockChildren"],
          registeredComponents: [1, "registeredComponents"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 1,
        consts: [["wrapperTemplate", ""], [3, "block", "context", "registeredComponents", "linkComponent"], [4, "ngComponentOutlet", "ngComponentOutletInputs", "ngComponentOutletContent"]],
        template: function ComponentRef_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ComponentRef_ng_template_0_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, ComponentRef_Conditional_2_Template, 1, 3, "ng-container");
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.componentRef() ? 2 : -1);
          }
        },
        dependencies: () => [CommonModule, i1.NgComponentOutlet, Block],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return ComponentRef;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RepeatedBlock = /*#__PURE__*/(() => {
  class RepeatedBlock {
    constructor() {
      this.repeatContext = input();
      this.block = input();
      this.registeredComponents = input();
      this.linkComponent = input();
      this.store = signal(undefined);
      if (typeof window !== "undefined") {
        effect(() => {
          // --- Mitosis: Workaround to make sure the effect() is triggered ---
          this.repeatContext();
          // ---
          this.store.set(this.repeatContext());
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngOnInit() {
      this.store.set(this.repeatContext());
    }
    static {
      this.ɵfac = function RepeatedBlock_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RepeatedBlock)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RepeatedBlock,
        selectors: [["repeated-block"]],
        inputs: {
          repeatContext: [1, "repeatContext"],
          block: [1, "block"],
          registeredComponents: [1, "registeredComponents"],
          linkComponent: [1, "linkComponent"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 4,
        consts: [[3, "block", "context", "registeredComponents", "linkComponent"]],
        template: function RepeatedBlock_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "block", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("block", ctx.block())("context", ctx.store())("registeredComponents", ctx.registeredComponents())("linkComponent", ctx.linkComponent());
          }
        },
        dependencies: () => [CommonModule, Block],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return RepeatedBlock;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Block = /*#__PURE__*/(() => {
  class Block {
    trackByChild0(_, child) {
      return child.id;
    }
    trackByData1(index, data) {
      return generateKey(index);
    }
    trackByData2(index, data) {
      return generateKey(index);
    }
    constructor() {
      this.generateKey = generateKey;
      this.block = input();
      this.context = input();
      this.registeredComponents = input();
      this.linkComponent = input();
      this._processedBlock = signal({
        value: null,
        update: false
      });
      this.repeatItem = computed(() => {
        return getRepeatItemData({
          block: this.block(),
          context: this.context()
        });
      });
      this.processedBlock = computed(() => {
        const blockToUse = this.block().repeat?.collection ? this.block() : getProcessedBlock({
          block: this.block(),
          localState: this.context().localState,
          rootState: this.context().rootState,
          rootSetState: this.context().rootSetState,
          context: this.context().context
        });
        return blockToUse;
      });
      this.blockComponent = computed(() => {
        return getComponent({
          block: this.processedBlock(),
          registeredComponents: this.registeredComponents(),
          model: this.context().model
        });
      });
      this.Tag = computed(() => {
        const shouldUseLink = this.block().tagName === "a" || this.processedBlock().properties?.href || this.processedBlock().href;
        if (shouldUseLink) {
          return this.linkComponent() || "a";
        }
        return this.block().tagName || DynamicDiv;
      });
      this.canShowBlock = computed(() => {
        if (this.block().repeat?.collection) {
          if (this.repeatItem()?.length) return true;
          return false;
        }
        const shouldHide = "hide" in this.processedBlock() ? this.processedBlock().hide : false;
        const shouldShow = "show" in this.processedBlock() ? this.processedBlock().show : true;
        return shouldShow && !shouldHide;
      });
      this.childrenWithoutParentComponent = computed(() => {
        /**
         * When there is no `componentRef`, there might still be children that need to be rendered. In this case,
         * we render them outside of `componentRef`.
         * NOTE: We make sure not to render this if `repeatItemData` is non-null, because that means we are rendering an array of
         * blocks, and the children will be repeated within those blocks.
         */
        const shouldRenderChildrenOutsideRef = !this.blockComponent()?.component && !this.repeatItem();
        return shouldRenderChildrenOutsideRef ? this.processedBlock().children ?? [] : [];
      });
      this.componentRefProps = computed(() => {
        return {
          blockChildren: this.processedBlock().children ?? [],
          componentRef: this.blockComponent()?.component,
          componentOptions: {
            ...getBlockComponentOptions(this.processedBlock(), this.context()),
            ...provideBuilderBlock(this.blockComponent(), this.processedBlock()),
            ...provideBuilderContext(this.blockComponent(), this.context()),
            ...provideLinkComponent(this.blockComponent(), this.linkComponent()),
            ...provideRegisteredComponents(this.blockComponent(), this.registeredComponents(), this.context().model)
          },
          context: this.context(),
          linkComponent: this.linkComponent(),
          registeredComponents: this.registeredComponents(),
          builderBlock: this.processedBlock(),
          includeBlockProps: this.blockComponent()?.noWrap === true,
          isInteractive: !(this.blockComponent()?.isRSC && TARGET === "rsc")
        };
      });
    }
    ngAfterViewInit() {
      if (typeof window !== "undefined") {
        const blockId = this.processedBlock().id;
        const animations = this.processedBlock().animations;
        if (animations && blockId) {
          // in Angular, the DynamicDiv sets attributes (builder-id) on the element late (ngAfterViewInit)
          // so we need to wait for them to be attached to the DOM before calling this else we'll not find the element
          requestAnimationFrame(() => {
            bindAnimations(animations.map(animation => ({
              ...animation,
              elementId: blockId
            })));
          });
        }
      }
    }
    static {
      this.ɵfac = function Block_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Block)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Block,
        selectors: [["block"]],
        inputs: {
          block: [1, "block"],
          context: [1, "context"],
          registeredComponents: [1, "registeredComponents"],
          linkComponent: [1, "linkComponent"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 1,
        consts: [[3, "block", "context"], [3, "Wrapper", "block", "context"], [3, "componentRef", "componentOptions", "blockChildren", "context", "registeredComponents", "linkComponent", "builderBlock", "includeBlockProps", "isInteractive"], [3, "block", "registeredComponents", "linkComponent", "context"], [3, "repeatContext", "block", "registeredComponents", "linkComponent"]],
        template: function Block_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, Block_Conditional_0_Template, 3, 3);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.canShowBlock() ? 0 : -1);
          }
        },
        dependencies: [Block, CommonModule, BlockStyles, RepeatedBlock, ComponentRef, BlockWrapper],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return Block;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BlocksWrapper = /*#__PURE__*/(() => {
  class BlocksWrapper {
    onClick() {
      if (isEditing() && !this.blocks()?.length) {
        window.parent?.postMessage({
          type: "builder.clickEmptyBlocks",
          data: {
            parentElementId: this.parent(),
            dataPath: this.dataPath()
          }
        }, "*");
      }
    }
    onMouseEnter() {
      if (isEditing() && !this.blocks()?.length) {
        window.parent?.postMessage({
          type: "builder.hoverEmptyBlocks",
          data: {
            parentElementId: this.parent(),
            dataPath: this.dataPath()
          }
        }, "*");
      }
    }
    constructor(viewContainer) {
      this.viewContainer = viewContainer;
      this.myContent = signal([]);
      this.blockswrapperTemplateRef = viewChild("blockswrapperTemplate");
      this.blocks = input();
      this.classNameProp = input();
      this.path = input();
      this.parent = input();
      this.styleProp = input();
      this.BlocksWrapperProps = input();
      this.BlocksWrapper = input();
      this.blocksWrapperRef = viewChild("blocksWrapperRef");
      this.shouldUpdate = signal(false);
      this.className = computed(() => {
        return ["builder-blocks", !this.blocks()?.length ? "no-blocks" : "", this.classNameProp()].filter(Boolean).join(" ");
      });
      this.dataPath = computed(() => {
        if (!this.path()) {
          return undefined;
        }
        const thisPrefix = "this.";
        const pathPrefix = "component.options.";
        return this.path().startsWith(thisPrefix) ? this.path().replace(thisPrefix, "") : this.path().startsWith(pathPrefix) ? this.path() : `${pathPrefix}${this.path() || ""}`;
      });
      this.dynamicProps_d6h9d = computed(() => {
        return {
          ref: this.blocksWrapperRef(),
          class: this.className() + " this-blocks-wrapper",
          "builder-path": this.dataPath(),
          "builder-parent-id": this.parent(),
          style: this.styleProp(),
          onClick: this.onClick.bind(this),
          onMouseEnter: this.onMouseEnter.bind(this),
          onKeyPress: this.onClick.bind(this),
          ...this.BlocksWrapperProps()
        };
      });
      if (typeof window !== "undefined") {
        effect(() => {
          // --- Mitosis: Workaround to make sure the effect() is triggered ---
          this.blocks();
          // ---
          this.shouldUpdate.set(true);
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    _updateView() {
      this.myContent.set([this.viewContainer.createEmbeddedView(this.blockswrapperTemplateRef()).rootNodes]);
    }
    ngAfterViewInit() {
      if (typeof window !== "undefined") {}
    }
    ngAfterContentInit() {
      this._updateView();
    }
    ngAfterContentChecked() {
      if (this.shouldUpdate()) {
        this._updateView();
        this.shouldUpdate.set(false);
      }
    }
    static {
      this.ɵfac = function BlocksWrapper_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BlocksWrapper)(i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BlocksWrapper,
        selectors: [["blocks-wrapper"]],
        viewQuery: function BlocksWrapper_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.blockswrapperTemplateRef, _c10, 5);
            i0.ɵɵviewQuerySignal(ctx.blocksWrapperRef, _c11, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(2);
          }
        },
        inputs: {
          blocks: [1, "blocks"],
          classNameProp: [1, "classNameProp"],
          path: [1, "path"],
          parent: [1, "parent"],
          styleProp: [1, "styleProp"],
          BlocksWrapperProps: [1, "BlocksWrapperProps"],
          BlocksWrapper: [1, "BlocksWrapper"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 3,
        consts: [["blockswrapperTemplate", ""], [4, "ngComponentOutlet", "ngComponentOutletInputs", "ngComponentOutletContent"]],
        template: function BlocksWrapper_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, BlocksWrapper_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, BlocksWrapper_ng_container_2_Template, 1, 0, "ng-container", 1);
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngComponentOutlet", ctx.BlocksWrapper())("ngComponentOutletInputs", ctx.dynamicProps_d6h9d())("ngComponentOutletContent", ctx.myContent());
          }
        },
        dependencies: [CommonModule, i1.NgComponentOutlet],
        styles: ["[_nghost-%COMP%]{display:contents}.this-blocks-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:stretch}"]
      });
    }
  }
  return BlocksWrapper;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Blocks = /*#__PURE__*/(() => {
  class Blocks {
    trackByBlock0(_, block) {
      return block.id;
    }
    constructor(builderContext, componentsContext) {
      this.builderContext = builderContext;
      this.componentsContext = componentsContext;
      this.BlocksWrapper = BlocksWrapper;
      this.blocks = input();
      this.parent = input();
      this.path = input();
      this.styleProp = input();
      this.BlocksWrapperProps = input();
      this.context = input();
      this.className = input();
      this.linkComponent = input();
      this.registeredComponents = input();
    }
    static {
      this.ɵfac = function Blocks_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Blocks)(i0.ɵɵdirectiveInject(BuilderContext), i0.ɵɵdirectiveInject(ComponentsContext));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Blocks,
        selectors: [["blocks"]],
        inputs: {
          blocks: [1, "blocks"],
          parent: [1, "parent"],
          path: [1, "path"],
          styleProp: [1, "styleProp"],
          BlocksWrapperProps: [1, "BlocksWrapperProps"],
          context: [1, "context"],
          className: [1, "className"],
          linkComponent: [1, "linkComponent"],
          registeredComponents: [1, "registeredComponents"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 8,
        consts: [[3, "blocks", "parent", "path", "styleProp", "BlocksWrapperProps", "classNameProp", "BlocksWrapper"], [3, "block", "linkComponent", "context", "registeredComponents"]],
        template: function Blocks_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "blocks-wrapper", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵtemplate(2, Blocks_Conditional_2_Template, 2, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_4_0;
            let tmp_6_0;
            i0.ɵɵproperty("blocks", ctx.blocks())("parent", ctx.parent())("path", ctx.path())("styleProp", ctx.styleProp())("BlocksWrapperProps", ctx.BlocksWrapperProps() || ((tmp_4_0 = ctx.context()) == null ? null : tmp_4_0.BlocksWrapperProps) || (ctx.builderContext == null ? null : ctx.builderContext.BlocksWrapperProps))("classNameProp", ctx.className())("BlocksWrapper", ((tmp_6_0 = ctx.context()) == null ? null : tmp_6_0.BlocksWrapper) || (ctx.builderContext == null ? null : ctx.builderContext.BlocksWrapper));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.blocks() ? 2 : -1);
          }
        },
        dependencies: [CommonModule, BlocksWrapper, Block],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return Blocks;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const getColumnsClass = id => {
  return `builder-columns ${id}-breakpoints`;
};
let Columns = /*#__PURE__*/(() => {
  class Columns {
    getTagName(column) {
      return column.link ? this.builderLinkComponent() || "a" : DynamicDiv;
    }
    getWidth(index) {
      return this.cols()[index]?.width || 100 / this.cols().length;
    }
    getColumnCssWidth(index) {
      const width = this.getWidth(index);
      const subtractWidth = this.gutterSize() * (this.cols().length - 1) * (width / 100);
      return `calc(${width}% - ${subtractWidth}px)`;
    }
    getTabletStyle({
      stackedStyle,
      desktopStyle
    }) {
      return this.stackAt() === "tablet" ? stackedStyle : desktopStyle;
    }
    getMobileStyle({
      stackedStyle,
      desktopStyle
    }) {
      return this.stackAt() === "never" ? desktopStyle : stackedStyle;
    }
    columnsCssVars() {
      return {
        "--flex-dir": this.flexDir(),
        "--flex-dir-tablet": this.getTabletStyle({
          stackedStyle: this.flexDir(),
          desktopStyle: "row"
        })
      };
    }
    columnCssVars(index) {
      const gutter = index === 0 ? 0 : this.gutterSize();
      const width = this.getColumnCssWidth(index);
      const gutterPixels = `${gutter}px`;
      const mobileWidth = "100%";
      const mobileMarginLeft = 0;
      const marginLeftKey = "margin-left";
      const sharedStyles = {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch"
      };
      return {
        ...sharedStyles,
        width,
        [marginLeftKey]: gutterPixels,
        "--column-width-mobile": this.getMobileStyle({
          stackedStyle: mobileWidth,
          desktopStyle: width
        }),
        "--column-margin-left-mobile": this.getMobileStyle({
          stackedStyle: mobileMarginLeft,
          desktopStyle: gutterPixels
        }),
        "--column-width-tablet": this.getTabletStyle({
          stackedStyle: mobileWidth,
          desktopStyle: width
        }),
        "--column-margin-left-tablet": this.getTabletStyle({
          stackedStyle: mobileMarginLeft,
          desktopStyle: gutterPixels
        })
      };
    }
    getWidthForBreakpointSize(size) {
      const breakpointSizes = getSizesForBreakpoints(this.builderContext().content?.meta?.breakpoints || {});
      return breakpointSizes[size].max;
    }
    columnsStyles() {
      const childColumnDiv = `.${this.builderBlock().id}-breakpoints .builder-column:first-of-type`;
      return `
        @media (max-width: ${this.getWidthForBreakpointSize("medium")}px) {
          .${this.builderBlock().id}-breakpoints {
            flex-direction: var(--flex-dir-tablet);
            align-items: stretch;
          }

          ${childColumnDiv} {
            width: var(--column-width-tablet) !important;
            margin-left: var(--column-margin-left-tablet) !important;
          }
        }

        @media (max-width: ${this.getWidthForBreakpointSize("small")}px) {
          .${this.builderBlock().id}-breakpoints {
            flex-direction: var(--flex-dir);
            align-items: stretch;
          }

          ${childColumnDiv} {
            width: var(--column-width-mobile) !important;
            margin-left: var(--column-margin-left-mobile) !important;
          }
        },
      `;
    }
    getAttributes(column, index) {
      return {
        ...{},
        ...(column.link ? {
          href: column.link
        } : {}),
        [getClassPropName()]: "builder-column",
        style: mapStyleObjToStrIfNeeded(this.columnCssVars(index))
      };
    }
    templateStr_9tnc0u(column, index) {
      return `columns.${index}.blocks`;
    }
    setAttributes(el, value, changes) {
      if (!el) {
        return;
      }
      const target = typeof changes === "undefined" ? value : changes;
      Object.keys(target).forEach(key => {
        if (key.startsWith("on")) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace("on", "").toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key.toLowerCase(), target[key] ?? "");
        }
      });
    }
    trackByColumn0(index, column) {
      return index;
    }
    constructor(renderer) {
      this.renderer = renderer;
      this.getColumnsClass = getColumnsClass;
      this.TARGET = TARGET;
      this.space = input();
      this.columns = input();
      this.stackColumnsAt = input();
      this.builderLinkComponent = input();
      this.reverseColumnsWhenStacked = input();
      this.builderContext = input();
      this.builderBlock = input();
      this.builderComponents = input();
      this.elRef0 = viewChild("elRef0");
      this._listenerFns = new Map();
      this.gutterSize = computed(() => {
        return typeof this.space() === "number" ? this.space() || 0 : 20;
      });
      this.cols = computed(() => {
        return this.columns() || [];
      });
      this.stackAt = computed(() => {
        return this.stackColumnsAt() || "tablet";
      });
      this.flexDir = computed(() => {
        return this.stackColumnsAt() === "never" ? "row" : this.reverseColumnsWhenStacked() ? "column-reverse" : "column";
      });
      if (typeof window !== "undefined") {
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, {});
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngAfterViewInit() {
      this.setAttributes(this.elRef0()?.nativeElement, {});
    }
    ngOnDestroy() {
      for (const fn of this._listenerFns.values()) {
        fn();
      }
    }
    static {
      this.ɵfac = function Columns_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Columns)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Columns,
        selectors: [["columns"]],
        viewQuery: function Columns_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.elRef0, _c12, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          space: [1, "space"],
          columns: [1, "columns"],
          stackColumnsAt: [1, "stackColumnsAt"],
          builderLinkComponent: [1, "builderLinkComponent"],
          reverseColumnsWhenStacked: [1, "reverseColumnsWhenStacked"],
          builderContext: [1, "builderContext"],
          builderBlock: [1, "builderBlock"],
          builderComponents: [1, "builderComponents"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 5,
        vars: 4,
        consts: [["elRef0", ""], [3, "ngStyle"], ["id", "builderio-columns", 3, "styles", "nonce"], [3, "TagName", "actionAttributes", "attributes"], [3, "path", "parent", "context", "registeredComponents", "linkComponent", "blocks", "styleProp"]],
        template: function Columns_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵtemplate(2, Columns_Conditional_2_Template, 1, 2, "inlined-styles", 2);
            i0.ɵɵrepeaterCreate(3, Columns_For_4_Template, 2, 12, "dynamic-renderer", 3, ctx.trackByColumn0, true);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_1_0;
            i0.ɵɵclassMap(ctx.getColumnsClass((tmp_1_0 = ctx.builderBlock()) == null ? null : tmp_1_0.id) + " div");
            i0.ɵɵproperty("ngStyle", ctx.columnsCssVars());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.TARGET !== "reactNative" ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.columns());
          }
        },
        dependencies: [CommonModule, i1.NgStyle, InlinedStyles, DynamicRenderer, Blocks],
        styles: ["[_nghost-%COMP%]{display:contents}.div[_ngcontent-%COMP%]{display:flex;line-height:normal;height:100%}"]
      });
    }
  }
  return Columns;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FragmentComponent = /*#__PURE__*/(() => {
  class FragmentComponent {
    constructor() {}
    static {
      this.ɵfac = function FragmentComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FragmentComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FragmentComponent,
        selectors: [["fragment-component"]],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 2,
        vars: 0,
        template: function FragmentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "span");
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [CommonModule],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return FragmentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Taken from (and modified) the shopify theme script repo
// https://github.com/Shopify/theme-scripts/blob/bcfb471f2a57d439e2f964a1bb65b67708cc90c3/packages/theme-images/images.js#L59
function removeProtocol(path) {
  return path.replace(/http(s)?:/, '');
}
function updateQueryParam(uri = '', key, value) {
  const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + encodeURIComponent(value) + '$2');
  }
  return uri + separator + key + '=' + encodeURIComponent(value);
}
function getShopifyImageUrl(src, size) {
  if (!src || !src?.match(/cdn\.shopify\.com/) || !size) {
    return src;
  }
  if (size === 'master') {
    return removeProtocol(src);
  }
  const match = src.match(/(_\d+x(\d+)?)?(\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?)/i);
  if (match) {
    const prefix = src.split(match[0]);
    const suffix = match[3];
    const useSize = size.match('x') ? size : `${size}x`;
    return removeProtocol(`${prefix[0]}_${useSize}${suffix}`);
  }
  return null;
}
function getSrcSet(url) {
  if (!url) {
    return url;
  }
  const sizes = [100, 200, 400, 800, 1200, 1600, 2000];
  if (url.match(/builder\.io/)) {
    let srcUrl = url;
    const widthInSrc = Number(url.split('?width=')[1]);
    if (!isNaN(widthInSrc)) {
      srcUrl = `${srcUrl} ${widthInSrc}w`;
    }
    return sizes.filter(size => size !== widthInSrc).map(size => `${updateQueryParam(url, 'width', size)} ${size}w`).concat([srcUrl]).join(', ');
  }
  if (url.match(/cdn\.shopify\.com/)) {
    return sizes.map(size => [getShopifyImageUrl(url, `${size}x${size}`), size]).filter(([sizeUrl]) => !!sizeUrl).map(([sizeUrl, size]) => `${sizeUrl} ${size}w`).concat([url]).join(', ');
  }
  return url;
}
let Image = /*#__PURE__*/(() => {
  class Image {
    constructor() {
      this.image = input();
      this.src = input();
      this.srcset = input();
      this.noWebp = input();
      this.aspectRatio = input();
      this.highPriority = input();
      this.altText = input();
      this.title = input();
      this.backgroundPosition = input();
      this.backgroundSize = input();
      this.className = input();
      this.sizes = input();
      this.builderBlock = input();
      this.fitContent = input();
      this.srcSetToUse = computed(() => {
        const imageToUse = this.image() || this.src();
        const url = imageToUse;
        if (!url ||
        // We can auto add srcset for cdn.builder.io and shopify
        // images, otherwise you can supply this prop manually
        !(typeof url === "string" && (url.match(/builder\.io/) || url.match(/cdn\.shopify\.com/)))) {
          return this.srcset();
        }
        if (this.noWebp()) {
          return undefined; // no need to add srcset to svg images
        }
        if (this.srcset() && this.image()?.includes("builder.io/api/v1/image")) {
          if (!this.srcset().includes(this.image().split("?")[0])) {
            console.debug("Removed given srcset");
            return getSrcSet(url);
          }
        } else if (this.image() && !this.srcset()) {
          return getSrcSet(url);
        }
        return getSrcSet(url);
      });
      this.webpSrcSet = computed(() => {
        if (this.srcSetToUse()?.match(/builder\.io/) && !this.noWebp()) {
          return this.srcSetToUse().replace(/\?/g, "?format=webp&");
        } else {
          return "";
        }
      });
      this.aspectRatioCss = computed(() => {
        const aspectRatioStyles = {
          position: "absolute",
          height: "100%",
          width: "100%",
          left: "0px",
          top: "0px"
        };
        const out = this.aspectRatio() ? aspectRatioStyles : undefined;
        return out;
      });
      this.objSpread_style_kr3gse = computed(() => {
        return {
          objectPosition: this.backgroundPosition() || "center",
          objectFit: this.backgroundSize() || "cover",
          ...this.aspectRatioCss()
        };
      });
    }
    ngAfterViewInit() {
      if (typeof window !== "undefined") {}
    }
    static {
      this.ɵfac = function Image_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Image)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Image,
        selectors: [["image"]],
        inputs: {
          image: [1, "image"],
          src: [1, "src"],
          srcset: [1, "srcset"],
          noWebp: [1, "noWebp"],
          aspectRatio: [1, "aspectRatio"],
          highPriority: [1, "highPriority"],
          altText: [1, "altText"],
          title: [1, "title"],
          backgroundPosition: [1, "backgroundPosition"],
          backgroundSize: [1, "backgroundSize"],
          className: [1, "className"],
          sizes: [1, "sizes"],
          builderBlock: [1, "builderBlock"],
          fitContent: [1, "fitContent"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c9,
        decls: 7,
        vars: 15,
        consts: [["type", "image/webp"], [3, "ngStyle"], [1, "builder-image-sizer", "div", 3, "ngStyle"], [1, "div-2"]],
        template: function Image_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c9);
            i0.ɵɵelementContainerStart(0);
            i0.ɵɵelementStart(1, "picture");
            i0.ɵɵtemplate(2, Image_Conditional_2_Template, 1, 1, "source", 0);
            i0.ɵɵelement(3, "img", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, Image_Conditional_4_Template, 1, 3, "div", 2)(5, Image_Conditional_5_Template, 1, 0)(6, Image_Conditional_6_Template, 2, 0, "div", 3);
            i0.ɵɵelementContainerEnd();
          }
          if (rf & 2) {
            let tmp_11_0;
            let tmp_12_0;
            let tmp_13_0;
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.webpSrcSet() ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵclassMap("builder-image" + (ctx.className() ? " " + ctx.className() : "") + " img");
            i0.ɵɵproperty("ngStyle", ctx.objSpread_style_kr3gse());
            i0.ɵɵattribute("loading", ctx.highPriority() ? "eager" : "lazy")("fetchpriority", ctx.highPriority() ? "high" : "auto")("alt", ctx.altText())("title", ctx.title())("role", ctx.altText() ? undefined : "presentation")("src", ctx.image(), i0.ɵɵsanitizeUrl)("srcset", ctx.srcSetToUse())("sizes", ctx.sizes());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.aspectRatio() && !(((tmp_11_0 = ctx.builderBlock()) == null ? null : tmp_11_0.children == null ? null : tmp_11_0.children.length) && ctx.fitContent()) ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(((tmp_12_0 = ctx.builderBlock()) == null ? null : tmp_12_0.children == null ? null : tmp_12_0.children.length) && ctx.fitContent() ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.fitContent() && ((tmp_13_0 = ctx.builderBlock()) == null ? null : tmp_13_0.children == null ? null : tmp_13_0.children.length) ? 6 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgStyle],
        styles: ["[_nghost-%COMP%]{display:contents}.img[_ngcontent-%COMP%]{opacity:1;transition:opacity .2s ease-in-out}.div[_ngcontent-%COMP%]{width:100%;pointer-events:none;font-size:0}.div-2[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:stretch;position:absolute;top:0;left:0;width:100%;height:100%}"]
      });
    }
  }
  return Image;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SectionComponent = /*#__PURE__*/(() => {
  class SectionComponent {
    setAttributes(el, value, changes) {
      if (!el) {
        return;
      }
      const target = typeof changes === "undefined" ? value : changes;
      Object.keys(target).forEach(key => {
        if (key.startsWith("on")) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace("on", "").toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key.toLowerCase(), target[key] ?? "");
        }
      });
    }
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input();
      this.maxWidth = input();
      this.elRef0 = viewChild("elRef0");
      this._listenerFns = new Map();
      if (typeof window !== "undefined") {
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, {});
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngAfterViewInit() {
      this.setAttributes(this.elRef0()?.nativeElement, {});
      this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
    }
    ngOnDestroy() {
      for (const fn of this._listenerFns.values()) {
        fn();
      }
    }
    static {
      this.ɵfac = function SectionComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SectionComponent)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SectionComponent,
        selectors: [["section-component"]],
        viewQuery: function SectionComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.elRef0, _c12, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          maxWidth: [1, "maxWidth"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 3,
        consts: [["elRef0", ""], [3, "ngStyle"]],
        template: function SectionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "section", 1, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c15, ctx.maxWidth() || 1200));
          }
        },
        dependencies: [CommonModule, i1.NgStyle],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return SectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * WARNING: This file contains functions that get stringified and inlined into the HTML at build-time.
 * They cannot import anything.
 */
function filterWithCustomTargeting(userAttributes, query, startDate, endDate) {
  function isString(val) {
    return typeof val === 'string';
  }
  function isNumber(val) {
    return typeof val === 'number';
  }
  function objectMatchesQuery(userattr, query) {
    const result = (() => {
      const property = query.property;
      const operator = query.operator;
      let testValue = query.value;
      if (query && query.property === 'urlPath' && query.value && typeof query.value === 'string' && query.value !== '/' && query.value.endsWith('/')) {
        testValue = query.value.slice(0, -1);
      }
      if (!(property && operator)) {
        return true;
      }
      if (Array.isArray(testValue)) {
        if (operator === 'isNot') {
          return testValue.every(val => objectMatchesQuery(userattr, {
            property,
            operator,
            value: val
          }));
        }
        return !!testValue.find(val => objectMatchesQuery(userattr, {
          property,
          operator,
          value: val
        }));
      }
      const value = userattr[property];
      if (Array.isArray(value)) {
        return value.includes(testValue);
      }
      switch (operator) {
        case 'is':
          return value === testValue;
        case 'isNot':
          return value !== testValue;
        case 'contains':
          return (isString(value) || Array.isArray(value)) && value.includes(String(testValue));
        case 'startsWith':
          return isString(value) && value.startsWith(String(testValue));
        case 'endsWith':
          return isString(value) && value.endsWith(String(testValue));
        case 'greaterThan':
          return isNumber(value) && isNumber(testValue) && value > testValue;
        case 'lessThan':
          return isNumber(value) && isNumber(testValue) && value < testValue;
        case 'greaterThanOrEqualTo':
          return isNumber(value) && isNumber(testValue) && value >= testValue;
        case 'lessThanOrEqualTo':
          return isNumber(value) && isNumber(testValue) && value <= testValue;
        default:
          return false;
      }
    })();
    return result;
  }
  const item = {
    query,
    startDate,
    endDate
  };
  const now = userAttributes.date && new Date(userAttributes.date) || new Date();
  if (item.startDate && new Date(item.startDate) > now) {
    return false;
  } else if (item.endDate && new Date(item.endDate) < now) {
    return false;
  }
  if (!item.query || !item.query.length) {
    return true;
  }
  return item.query.every(filter => {
    return objectMatchesQuery(userAttributes, filter);
  });
}
function updateVisibilityStylesScript(variants, blockId, isHydrationTarget, locale) {
  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  const visibilityStylesEl = document.currentScript?.previousElementSibling;
  if (!visibilityStylesEl) {
    return;
  }
  if (isHydrationTarget) {
    visibilityStylesEl.remove();
    const currentScript = document.currentScript;
    if (currentScript) {
      currentScript.remove();
    }
  } else {
    const attributes = JSON.parse(getCookie('builder.userAttributes') || '{}');
    if (locale) {
      attributes.locale = locale;
    }
    const winningVariantIndex = variants?.findIndex(function (variant) {
      return window.filterWithCustomTargeting(attributes, variant.query, variant.startDate, variant.endDate);
    });
    if (winningVariantIndex !== -1) {
      let newStyleStr = variants?.map((_, index) => {
        if (index === winningVariantIndex) return '';
        return `div[data-variant-id="${blockId}-${index}"] { display: none !important; } `;
      }).join('') || '';
      newStyleStr += `div[data-variant-id="${blockId}-default"] { display: none !important; } `;
      visibilityStylesEl.innerHTML = newStyleStr;
    }
  }
}
const PERSONALIZATION_SCRIPT = "function getPersonalizedVariant(variants, blockId, isHydrationTarget, locale) {\n  if (!navigator.cookieEnabled) {\n    return;\n  }\n  function getCookie(name) {\n    const nameEQ = name + '=';\n    const ca = document.cookie.split(';');\n    for (let i = 0; i < ca.length; i++) {\n      let c = ca[i];\n      while (c.charAt(0) == ' ') c = c.substring(1, c.length);\n      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);\n    }\n    return null;\n  }\n  const attributes = JSON.parse(getCookie('builder.userAttributes') || '{}');\n  if (locale) {\n    attributes.locale = locale;\n  }\n  const winningVariantIndex = variants?.findIndex(function (variant) {\n    return window.filterWithCustomTargeting(attributes, variant.query, variant.startDate, variant.endDate);\n  });\n  const parentDiv = document.currentScript?.parentElement;\n  const variantId = parentDiv?.getAttribute('data-variant-id');\n  const isDefaultVariant = variantId === `${blockId}-default`;\n  const isWinningVariant = winningVariantIndex !== -1 && variantId === `${blockId}-${winningVariantIndex}` || winningVariantIndex === -1 && isDefaultVariant;\n  if (isWinningVariant && !isDefaultVariant) {\n    parentDiv?.removeAttribute('hidden');\n    parentDiv?.removeAttribute('aria-hidden');\n  } else if (!isWinningVariant && isDefaultVariant) {\n    parentDiv?.setAttribute('hidden', 'true');\n    parentDiv?.setAttribute('aria-hidden', 'true');\n  }\n  if (isHydrationTarget) {\n    if (!isWinningVariant) {\n      const itsStyleEl = parentDiv?.previousElementSibling;\n      if (itsStyleEl) {\n        itsStyleEl.remove();\n      }\n      parentDiv?.remove();\n    }\n    const thisScript = document.currentScript;\n    if (thisScript) {\n      thisScript.remove();\n    }\n  }\n}";
const FILTER_WITH_CUSTOM_TARGETING_SCRIPT = "function filterWithCustomTargeting(userAttributes, query, startDate, endDate) {\n  function isString(val) {\n    return typeof val === 'string';\n  }\n  function isNumber(val) {\n    return typeof val === 'number';\n  }\n  function objectMatchesQuery(userattr, query) {\n    const result = (() => {\n      const property = query.property;\n      const operator = query.operator;\n      let testValue = query.value;\n      if (query && query.property === 'urlPath' && query.value && typeof query.value === 'string' && query.value !== '/' && query.value.endsWith('/')) {\n        testValue = query.value.slice(0, -1);\n      }\n      if (!(property && operator)) {\n        return true;\n      }\n      if (Array.isArray(testValue)) {\n        if (operator === 'isNot') {\n          return testValue.every(val => objectMatchesQuery(userattr, {\n            property,\n            operator,\n            value: val\n          }));\n        }\n        return !!testValue.find(val => objectMatchesQuery(userattr, {\n          property,\n          operator,\n          value: val\n        }));\n      }\n      const value = userattr[property];\n      if (Array.isArray(value)) {\n        return value.includes(testValue);\n      }\n      switch (operator) {\n        case 'is':\n          return value === testValue;\n        case 'isNot':\n          return value !== testValue;\n        case 'contains':\n          return (isString(value) || Array.isArray(value)) && value.includes(String(testValue));\n        case 'startsWith':\n          return isString(value) && value.startsWith(String(testValue));\n        case 'endsWith':\n          return isString(value) && value.endsWith(String(testValue));\n        case 'greaterThan':\n          return isNumber(value) && isNumber(testValue) && value > testValue;\n        case 'lessThan':\n          return isNumber(value) && isNumber(testValue) && value < testValue;\n        case 'greaterThanOrEqualTo':\n          return isNumber(value) && isNumber(testValue) && value >= testValue;\n        case 'lessThanOrEqualTo':\n          return isNumber(value) && isNumber(testValue) && value <= testValue;\n        default:\n          return false;\n      }\n    })();\n    return result;\n  }\n  const item = {\n    query,\n    startDate,\n    endDate\n  };\n  const now = userAttributes.date && new Date(userAttributes.date) || new Date();\n  if (item.startDate && new Date(item.startDate) > now) {\n    return false;\n  } else if (item.endDate && new Date(item.endDate) < now) {\n    return false;\n  }\n  if (!item.query || !item.query.length) {\n    return true;\n  }\n  return item.query.every(filter => {\n    return objectMatchesQuery(userAttributes, filter);\n  });\n}";
const UPDATE_VISIBILITY_STYLES_SCRIPT = "function updateVisibilityStylesScript(variants, blockId, isHydrationTarget, locale) {\n  function getCookie(name) {\n    const nameEQ = name + '=';\n    const ca = document.cookie.split(';');\n    for (let i = 0; i < ca.length; i++) {\n      let c = ca[i];\n      while (c.charAt(0) == ' ') c = c.substring(1, c.length);\n      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);\n    }\n    return null;\n  }\n  const visibilityStylesEl = document.currentScript?.previousElementSibling;\n  if (!visibilityStylesEl) {\n    return;\n  }\n  if (isHydrationTarget) {\n    visibilityStylesEl.remove();\n    const currentScript = document.currentScript;\n    if (currentScript) {\n      currentScript.remove();\n    }\n  } else {\n    const attributes = JSON.parse(getCookie('builder.userAttributes') || '{}');\n    if (locale) {\n      attributes.locale = locale;\n    }\n    const winningVariantIndex = variants?.findIndex(function (variant) {\n      return window.filterWithCustomTargeting(attributes, variant.query, variant.startDate, variant.endDate);\n    });\n    if (winningVariantIndex !== -1) {\n      let newStyleStr = variants?.map((_, index) => {\n        if (index === winningVariantIndex) return '';\n        return `div[data-variant-id=\"${blockId}-${index}\"] { display: none !important; } `;\n      }).join('') || '';\n      newStyleStr += `div[data-variant-id=\"${blockId}-default\"] { display: none !important; } `;\n      visibilityStylesEl.innerHTML = newStyleStr;\n    }\n  }\n}";
const DEFAULT_INDEX = 'default';
const FILTER_WITH_CUSTOM_TARGETING_SCRIPT_FN_NAME = 'filterWithCustomTargeting';
const BUILDER_IO_PERSONALIZATION_SCRIPT_FN_NAME = 'builderIoPersonalization';
const UPDATE_VARIANT_VISIBILITY_SCRIPT_FN_NAME$1 = 'updateVisibilityStylesScript';
/**
 * SDKs that support Variant Containers
 */
const SDKS_SUPPORTING_PERSONALIZATION = ['react', 'vue', 'svelte', 'qwik'];
/**
 * After hydration, we reset the tree
 * These SDKs handle Personalization Container in a special way:
 * - first, the inlined script will help us add `display: none`, `aria-hidden: true` and `hidden: true` to the non-winning variants
 * - then, on mount / when the component is hydrated - we reset the tree with only the winning variant and deleting the entire tree
 *
 * This helps us to avoid flicker and show the correct / winning variant initially and then once we've hydrated we show the winning variant
 * and keep a track of the cookies to update to the correct variant dynamically when the cookie updates.
 */
const SDKS_REQUIRING_RESET_APPROACH = ['vue', 'svelte', 'qwik'];
function checkShouldRenderVariants$1(variants, canTrack) {
  const hasVariants = variants && variants.length > 0;
  if (TARGET === 'reactNative') return false;
  if (!hasVariants) return false;
  if (!canTrack) return false;
  if (SDKS_REQUIRING_RESET_APPROACH.includes(TARGET)) return true;
  if (isBrowser()) return false;
  return true;
}
function getBlocksToRender({
  variants,
  previewingIndex,
  isHydrated,
  filteredVariants,
  fallbackBlocks
}) {
  const fallback = {
    blocks: fallbackBlocks ?? [],
    path: 'this.children',
    index: DEFAULT_INDEX
  };
  if (isHydrated && isEditing()) {
    // If editing a specific variant
    if (typeof previewingIndex === 'number' && previewingIndex < (variants?.length ?? 0)) {
      const variant = variants?.[previewingIndex];
      if (variant) {
        return {
          blocks: variant.blocks,
          path: `variants.${previewingIndex}.blocks`,
          index: previewingIndex
        };
      }
    }
    // Otherwise we're editing the default variant
    return fallback;
  }
  // If we're on the browser, check if there's a winning variant
  if (isBrowser()) {
    const winningVariant = filteredVariants?.[0];
    if (winningVariant && variants) {
      const variantIndex = variants.indexOf(winningVariant);
      if (variantIndex !== -1) {
        return {
          blocks: winningVariant.blocks,
          path: `variants.${variantIndex}.blocks`,
          index: variantIndex
        };
      }
    }
  }
  // If no winning variant or we are on the server, return the default variant
  return fallback;
}
const getInitPersonalizationVariantsFnsScriptString = () => {
  return `
  window.${FILTER_WITH_CUSTOM_TARGETING_SCRIPT_FN_NAME} = ${FILTER_WITH_CUSTOM_TARGETING_SCRIPT}
  window.${BUILDER_IO_PERSONALIZATION_SCRIPT_FN_NAME} = ${PERSONALIZATION_SCRIPT}
  window.${UPDATE_VARIANT_VISIBILITY_SCRIPT_FN_NAME$1} = ${UPDATE_VISIBILITY_STYLES_SCRIPT}
  `;
};
const isHydrationTarget$1 = TARGET === 'react';
const getPersonalizationScript = (variants, blockId, locale) => {
  return `window.${BUILDER_IO_PERSONALIZATION_SCRIPT_FN_NAME}(${JSON.stringify(variants)}, "${blockId}", ${isHydrationTarget$1}${locale ? `, "${locale}"` : ''})`;
};
const getUpdateVisibilityStylesScript = (variants, blockId, locale) => {
  return `window.${UPDATE_VARIANT_VISIBILITY_SCRIPT_FN_NAME$1}(${JSON.stringify(variants)}, "${blockId}", ${isHydrationTarget$1}${locale ? `, "${locale}"` : ''})`;
};

/**
 * Only gets one level up from hostname
 * wwww.example.com -> example.com
 * www.example.co.uk -> example.co.uk
 */
const getTopLevelDomain = host => {
  if (host === 'localhost' || host === '127.0.0.1') {
    return host;
  }
  const parts = host.split('.');
  if (parts.length > 2) {
    return parts.slice(1).join('.');
  }
  return host;
};
const getCookieSync = ({
  name,
  canTrack
}) => {
  try {
    if (!canTrack) {
      return undefined;
    }
    /**
     * Extracted from MDN docs
     * https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie#example_2_get_a_sample_cookie_named_test2
     */
    return document.cookie.split('; ').find(row => row.startsWith(`${name}=`))?.split('=')[1];
  } catch (err) {
    logger.warn('[COOKIE] GET error: ', err?.message || err);
    return undefined;
  }
};
/**
 * NOTE: This function is `async` because its react-native override is async. Do not remove the `async` keyword!
 * The sync version is only safe to use in code blocks that `react-native` is guaranteed not to not run.
 */
const getCookie = async args => getCookieSync(args);
const stringifyCookie = cookie => cookie.map(([key, value]) => value ? `${key}=${value}` : key).filter(checkIsDefined).join('; ');
const SECURE_CONFIG = [['secure', ''], ['SameSite', 'None']];
const createCookieString = ({
  name,
  value,
  expires
}) => {
  const secure = isBrowser() ? location.protocol === 'https:' : true;
  const secureObj = secure ? SECURE_CONFIG : [[]];
  // TODO: need to know if secure server side
  const expiresObj = expires ? [['expires', expires.toUTCString()]] : [[]];
  const cookieValue = [[name, value], ...expiresObj, ['path', '/'], ['domain', getTopLevelDomain(window.location.hostname)], ...secureObj];
  const cookie = stringifyCookie(cookieValue);
  return cookie;
};
/**
 * NOTE: This function is `async` because its react-native override is async. Do not remove the `async` keyword!
 */
const setCookie = async ({
  name,
  value,
  expires,
  canTrack
}) => {
  try {
    if (!canTrack) {
      return;
    }
    const cookie = createCookieString({
      name,
      value,
      expires
    });
    document.cookie = cookie;
  } catch (err) {
    logger.warn('[COOKIE] SET error: ', err?.message || err);
  }
};
const BUILDER_STORE_PREFIX = 'builder.tests';
const getContentTestKey = id => `${BUILDER_STORE_PREFIX}.${id}`;
const getContentVariationCookie = ({
  contentId
}) => getCookie({
  name: getContentTestKey(contentId),
  canTrack: true
});
const getContentVariationCookieSync = ({
  contentId
}) => getCookieSync({
  name: getContentTestKey(contentId),
  canTrack: true
});
const setContentVariationCookie = ({
  contentId,
  value
}) => setCookie({
  name: getContentTestKey(contentId),
  value,
  canTrack: true
});
const checkIsBuilderContentWithVariations = item => checkIsDefined(item.id) && checkIsDefined(item.variations) && Object.keys(item.variations).length > 0;
/**
 * Randomly assign a variation to a user
 */
const getRandomVariationId = ({
  id,
  variations
}) => {
  let n = 0;
  const random = Math.random();
  // loop over variations test ratios, incrementing a counter,
  // until we find the variation that this user should be assigned to
  for (const id in variations) {
    const testRatio = variations[id]?.testRatio;
    n += testRatio;
    if (random < n) {
      return id;
    }
  }
  // the variations array does not include the default variation.
  // if we arrive here, then it means that the random number fits in the default variation bucket.
  return id;
};
const getAndSetVariantId = args => {
  // if variation not found in storage, assign a random variation to this user
  const randomVariationId = getRandomVariationId(args);
  // store variation in cookies/storage
  setContentVariationCookie({
    contentId: args.id,
    value: randomVariationId
  }).catch(err => {
    logger.error('could not store A/B test variation: ', err);
  });
  return randomVariationId;
};
const getTestFields = ({
  item,
  testGroupId
}) => {
  const variationValue = item.variations[testGroupId];
  if (testGroupId === item.id ||
  // handle edge-case where `testGroupId` points to non-existing variation
  !variationValue) {
    return {
      testVariationId: item.id,
      testVariationName: 'Default'
    };
  } else {
    return {
      data: variationValue.data,
      testVariationId: variationValue.id,
      testVariationName: variationValue.name || (variationValue.id === item.id ? 'Default' : '')
    };
  }
};
const handleABTestingSync = ({
  item,
  canTrack
}) => {
  /**
   * We cannot SSR in React-Native.
   */
  if (TARGET === 'reactNative') return item;
  if (!canTrack) {
    return item;
  }
  if (!item) {
    return undefined;
  }
  if (!checkIsBuilderContentWithVariations(item)) {
    return item;
  }
  const testGroupId = getContentVariationCookieSync({
    contentId: item.id
  }) || getAndSetVariantId({
    variations: item.variations,
    id: item.id
  });
  const variationValue = getTestFields({
    item,
    testGroupId
  });
  return {
    ...item,
    ...variationValue
  };
};
const handleABTesting = async ({
  item,
  canTrack
}) => {
  if (!canTrack) {
    return item;
  }
  if (!checkIsBuilderContentWithVariations(item)) {
    return item;
  }
  const cookieValue = await getContentVariationCookie({
    contentId: item.id
  });
  const testGroupId = cookieValue || getAndSetVariantId({
    variations: item.variations,
    id: item.id
  });
  const variationValue = getTestFields({
    item,
    testGroupId
  });
  return {
    ...item,
    ...variationValue
  };
};
function noSerializeWrapper(fn) {
  return fn;
}
const USER_ATTRIBUTES_COOKIE_NAME = 'builder.userAttributes';
function createUserAttributesService() {
  let canTrack = true;
  const subscribers = new Set();
  return {
    setUserAttributes(newAttrs) {
      if (!isBrowser()) {
        return;
      }
      const userAttributes = {
        ...this.getUserAttributes(),
        ...newAttrs
      };
      setCookie({
        name: USER_ATTRIBUTES_COOKIE_NAME,
        value: JSON.stringify(userAttributes),
        canTrack
      });
      subscribers.forEach(callback => callback(userAttributes));
    },
    getUserAttributes() {
      if (!isBrowser()) {
        return {};
      }
      return JSON.parse(getCookieSync({
        name: USER_ATTRIBUTES_COOKIE_NAME,
        canTrack
      }) || '{}');
    },
    subscribeOnUserAttributesChange(callback, {
      fireImmediately
    } = {}) {
      subscribers.add(callback);
      if (fireImmediately) {
        callback(this.getUserAttributes());
      }
      return noSerializeWrapper(function () {
        subscribers.delete(callback);
      });
    },
    setCanTrack(value) {
      canTrack = value;
    }
  };
}
let _userAttributesService;
if (isBrowser() && TARGET === 'qwik') {
  if (!window.__BUILDER_USER_ATTRIBUTES_SERVICE__) {
    window.__BUILDER_USER_ATTRIBUTES_SERVICE__ = createUserAttributesService();
  }
  _userAttributesService = window.__BUILDER_USER_ATTRIBUTES_SERVICE__;
} else {
  _userAttributesService = createUserAttributesService();
}
const userAttributesService = _userAttributesService;
const setClientUserAttributes = attributes => {
  userAttributesService.setUserAttributes(attributes);
};
const getDefaultCanTrack = canTrack => {
  const result = checkIsDefined(canTrack) ? canTrack : true;
  userAttributesService.setCanTrack(result);
  return result;
};
const defaultTitle = {
  '@type': '@builder.io/sdk:Element',
  layerName: 'Accordion item title',
  responsiveStyles: {
    large: {
      marginTop: '10px',
      position: 'relative',
      display: 'flex',
      alignItems: 'stretch',
      flexDirection: 'column',
      paddingBottom: '10px'
    }
  },
  children: [{
    '@type': '@builder.io/sdk:Element',
    responsiveStyles: {
      large: {
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column'
      }
    },
    component: {
      name: 'Text',
      options: {
        text: 'I am an accordion title. Click me!'
      }
    }
  }]
};
const defaultDetail = {
  '@type': '@builder.io/sdk:Element',
  layerName: 'Accordion item detail',
  responsiveStyles: {
    large: {
      position: 'relative',
      display: 'flex',
      alignItems: 'stretch',
      flexDirection: 'column',
      marginTop: '10px',
      paddingBottom: '10px'
    }
  },
  children: [{
    '@type': '@builder.io/sdk:Element',
    responsiveStyles: {
      large: {
        paddingTop: '50px',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '50px'
      }
    },
    component: {
      name: 'Text',
      options: {
        text: 'I am an accordion detail, hello!'
      }
    }
  }]
};
const componentInfo$j = {
  name: 'Builder:Accordion',
  canHaveChildren: true,
  image: 'https://cdn.builder.io/api/v1/image/assets%2FagZ9n5CUKRfbL9t6CaJOyVSK4Es2%2Ffab6c1fd3fe542408cbdec078bca7f35',
  defaultStyles: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch'
  },
  inputs: [{
    name: 'items',
    type: 'list',
    broadcast: true,
    subFields: [{
      name: 'title',
      type: 'uiBlocks',
      hideFromUI: true,
      defaultValue: [defaultTitle]
    }, {
      name: 'detail',
      type: 'uiBlocks',
      hideFromUI: true,
      defaultValue: [defaultDetail]
    }],
    defaultValue: [{
      title: [defaultTitle],
      detail: [defaultDetail]
    }, {
      title: [defaultTitle],
      detail: [defaultDetail]
    }],
    showIf: options => !options.get('useChildrenForItems')
  }, {
    name: 'oneAtATime',
    helperText: 'Only allow opening one at a time (collapse all others when new item openned)',
    type: 'boolean',
    defaultValue: false
  }, {
    name: 'grid',
    helperText: 'Display as a grid',
    type: 'boolean',
    defaultValue: false
  }, {
    name: 'gridRowWidth',
    helperText: 'Display as a grid',
    type: 'string',
    showIf: options => options.get('grid'),
    defaultValue: '25%'
  }, {
    name: 'useChildrenForItems',
    type: 'boolean',
    helperText: 'Use child elements for each slide, instead of the array. Useful for dynamically repeating items',
    advanced: true,
    defaultValue: false,
    onChange: options => {
      if (options.get('useChildrenForItems') === true) {
        options.set('items', []);
      }
    }
  }],
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true
  }
};
const convertOrderNumberToString = order => {
  return order.toString();
};
let Accordion = /*#__PURE__*/(() => {
  class Accordion {
    getAccordionTitleClassName(index) {
      return `builder-accordion-title builder-accordion-title-${this.open().includes(index) ? "open" : "closed"}`;
    }
    getAccordionDetailClassName(index) {
      return `builder-accordion-detail builder-accordion-detail-${this.open().includes(index) ? "open" : "closed"}`;
    }
    onClick(index) {
      if (this.open().includes(index)) {
        this.open.set(this.onlyOneAtATime() ? [] : this.open().filter(item => item !== index));
      } else {
        this.open.set(this.onlyOneAtATime() ? [index] : this.open().concat(index));
      }
    }
    objSpread_style_oaowqb(item, index) {
      return {
        ...this.accordionTitleStyles(),
        ...(this.grid() && {
          width: this.gridRowWidth(),
          ...{
            order: this.openGridItemOrder() !== null ? convertOrderNumberToString(index) : convertOrderNumberToString(index + 1)
          }
        })
      };
    }
    templateStr_z2r7ff(item, index) {
      return `items.${index}.title`;
    }
    templateStr_x0msw(item, index) {
      return `items.${index}.detail`;
    }
    trackByItem0(index, item) {
      return index;
    }
    constructor() {
      this.grid = input();
      this.oneAtATime = input();
      this.items = input();
      this.gridRowWidth = input();
      this.builderBlock = input();
      this.builderContext = input();
      this.builderComponents = input();
      this.builderLinkComponent = input();
      this.open = signal([]);
      this.onlyOneAtATime = computed(() => {
        return Boolean(this.grid() || this.oneAtATime());
      });
      this.accordionStyles = computed(() => {
        const styles = {
          display: "flex",
          alignItems: "stretch",
          flexDirection: "column",
          ...(this.grid() && {
            flexDirection: "row",
            alignItems: "flex-start",
            flexWrap: "wrap"
          })
        };
        return styles;
      });
      this.accordionTitleStyles = computed(() => {
        const shared = {
          display: "flex",
          flexDirection: "column"
        };
        const styles = {
          ...shared,
          alignItems: "stretch",
          cursor: "pointer"
        };
        return Object.fromEntries(Object.entries(styles).filter(([_, value]) => value !== undefined));
      });
      this.openGridItemOrder = computed(() => {
        let itemOrder = null;
        const getOpenGridItemPosition = this.grid() && this.open().length;
        if (getOpenGridItemPosition && document) {
          const openItemIndex = this.open()[0];
          const openItem = document.querySelector(`.builder-accordion-title[data-index="${openItemIndex}"]`);
          let subjectItem = openItem;
          itemOrder = openItemIndex;
          if (subjectItem) {
            let prevItemRect = subjectItem.getBoundingClientRect();
            while (subjectItem = subjectItem && subjectItem.nextElementSibling) {
              if (subjectItem) {
                if (subjectItem.classList.contains("builder-accordion-detail")) {
                  continue;
                }
                const subjectItemRect = subjectItem.getBoundingClientRect();
                if (subjectItemRect.left > prevItemRect.left) {
                  const index = parseInt(subjectItem.getAttribute("data-index") || "", 10);
                  if (!isNaN(index)) {
                    prevItemRect = subjectItemRect;
                    itemOrder = index;
                  }
                } else {
                  break;
                }
              }
            }
          }
        }
        if (typeof itemOrder === "number") {
          itemOrder = itemOrder + 1;
        }
        return itemOrder;
      });
      this.accordionDetailStyles = computed(() => {
        const styles = {
          ...{
            order: typeof this.openGridItemOrder() === "number" ? this.openGridItemOrder() : undefined
          },
          ...(this.grid() && {
            width: "100%"
          })
        };
        return Object.fromEntries(Object.entries(styles).filter(([_, value]) => value !== undefined));
      });
    }
    static {
      this.ɵfac = function Accordion_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Accordion)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Accordion,
        selectors: [["accordion"]],
        inputs: {
          grid: [1, "grid"],
          oneAtATime: [1, "oneAtATime"],
          items: [1, "items"],
          gridRowWidth: [1, "gridRowWidth"],
          builderBlock: [1, "builderBlock"],
          builderContext: [1, "builderContext"],
          builderComponents: [1, "builderComponents"],
          builderLinkComponent: [1, "builderLinkComponent"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 1,
        consts: [[1, "builder-accordion", 3, "ngStyle"], [3, "click", "ngStyle"], [3, "blocks", "path", "parent", "context", "registeredComponents", "linkComponent"], [3, "class", "ngStyle"], [3, "ngStyle"]],
        template: function Accordion_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵrepeaterCreate(1, Accordion_For_2_Template, 4, 11, "ng-container", null, ctx.trackByItem0, true);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngStyle", ctx.accordionStyles());
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.items());
          }
        },
        dependencies: [CommonModule, i1.NgStyle, Blocks],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return Accordion;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const componentInfo$i = {
  name: 'Core:Button',
  image: 'https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F81a15681c3e74df09677dfc57a615b13',
  defaultStyles: {
    // TODO: make min width more intuitive and set one
    appearance: 'none',
    paddingTop: '15px',
    paddingBottom: '15px',
    paddingLeft: '25px',
    paddingRight: '25px',
    backgroundColor: '#000000',
    color: 'white',
    borderRadius: '4px',
    textAlign: 'center',
    cursor: 'pointer'
  },
  inputs: [{
    name: 'text',
    type: 'text',
    defaultValue: 'Click me!',
    bubble: true
  }, {
    name: 'link',
    type: 'url',
    bubble: true
  }, {
    name: 'openLinkInNewTab',
    type: 'boolean',
    defaultValue: false,
    friendlyName: 'Open link in new tab'
  }],
  static: true,
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderLinkComponent: true
  }
};
const componentInfo$h = {
  // TODO: ways to statically preprocess JSON for references, functions, etc
  name: 'Columns',
  isRSC: true,
  inputs: [{
    name: 'columns',
    type: 'array',
    broadcast: true,
    subFields: [{
      name: 'blocks',
      type: 'array',
      hideFromUI: true,
      defaultValue: [{
        '@type': '@builder.io/sdk:Element',
        responsiveStyles: {
          large: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            flexShrink: '0',
            position: 'relative',
            marginTop: '30px',
            textAlign: 'center',
            lineHeight: 'normal',
            height: 'auto',
            minHeight: '20px',
            minWidth: '20px',
            overflow: 'hidden'
          }
        },
        component: {
          name: 'Image',
          options: {
            image: 'https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        '@type': '@builder.io/sdk:Element',
        responsiveStyles: {
          large: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            flexShrink: '0',
            position: 'relative',
            marginTop: '30px',
            textAlign: 'center',
            lineHeight: 'normal',
            height: 'auto'
          }
        },
        component: {
          name: 'Text',
          options: {
            text: '<p>Enter some text...</p>'
          }
        }
      }]
    }, {
      name: 'width',
      type: 'number',
      hideFromUI: true,
      helperText: 'Width %, e.g. set to 50 to fill half of the space'
    }, {
      name: 'link',
      type: 'url',
      helperText: 'Optionally set a url that clicking this column will link to'
    }],
    defaultValue: [{
      blocks: [{
        '@type': '@builder.io/sdk:Element',
        responsiveStyles: {
          large: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            flexShrink: '0',
            position: 'relative',
            marginTop: '30px',
            textAlign: 'center',
            lineHeight: 'normal',
            height: 'auto',
            minHeight: '20px',
            minWidth: '20px',
            overflow: 'hidden'
          }
        },
        component: {
          name: 'Image',
          options: {
            image: 'https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        '@type': '@builder.io/sdk:Element',
        responsiveStyles: {
          large: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            flexShrink: '0',
            position: 'relative',
            marginTop: '30px',
            textAlign: 'center',
            lineHeight: 'normal',
            height: 'auto'
          }
        },
        component: {
          name: 'Text',
          options: {
            text: '<p>Enter some text...</p>'
          }
        }
      }]
    }, {
      blocks: [{
        '@type': '@builder.io/sdk:Element',
        responsiveStyles: {
          large: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            flexShrink: '0',
            position: 'relative',
            marginTop: '30px',
            textAlign: 'center',
            lineHeight: 'normal',
            height: 'auto',
            minHeight: '20px',
            minWidth: '20px',
            overflow: 'hidden'
          }
        },
        component: {
          name: 'Image',
          options: {
            image: 'https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        '@type': '@builder.io/sdk:Element',
        responsiveStyles: {
          large: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            flexShrink: '0',
            position: 'relative',
            marginTop: '30px',
            textAlign: 'center',
            lineHeight: 'normal',
            height: 'auto'
          }
        },
        component: {
          name: 'Text',
          options: {
            text: '<p>Enter some text...</p>'
          }
        }
      }]
    }],
    onChange: options => {
      function clearWidths() {
        columns.forEach(col => {
          col.delete('width');
        });
      }
      const columns = options.get('columns');
      if (Array.isArray(columns)) {
        const containsColumnWithWidth = !!columns.find(col => col.get('width'));
        if (containsColumnWithWidth) {
          const containsColumnWithoutWidth = !!columns.find(col => !col.get('width'));
          if (containsColumnWithoutWidth) {
            clearWidths();
          } else {
            const sumWidths = columns.reduce((memo, col) => {
              return memo + col.get('width');
            }, 0);
            const widthsDontAddUp = sumWidths !== 100;
            if (widthsDontAddUp) {
              clearWidths();
            }
          }
        }
      }
    }
  }, {
    name: 'space',
    type: 'number',
    defaultValue: 20,
    helperText: 'Size of gap between columns',
    advanced: true
  }, {
    name: 'stackColumnsAt',
    type: 'string',
    defaultValue: 'tablet',
    helperText: 'Convert horizontal columns to vertical at what device size',
    enum: ['tablet', 'mobile', 'never'],
    advanced: true
  }, {
    name: 'reverseColumnsWhenStacked',
    type: 'boolean',
    defaultValue: false,
    helperText: 'When stacking columns for mobile devices, reverse the ordering',
    advanced: true
  }],
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true
  }
};
const componentInfo$g = {
  name: 'Fragment',
  static: true,
  hidden: true,
  canHaveChildren: true,
  noWrap: true
};
const IMAGE_FILE_TYPES = ['jpeg', 'jpg', 'png', 'svg', 'webp', 'gif', 'jfif', 'pjpeg', 'pjp', 'apng', 'avif', 'tif', 'tiff', 'heif', 'bmp', 'eps', 'raw', 'cr2', 'nef', 'orf', 'sr2', 'psd', 'heic', 'dib', 'ai'];
const VIDEO_FILE_TYPES = ['mp4', 'webm', 'mkv', 'flv', 'vob', 'ogv', 'ogg', 'drc', 'gif', 'gifv', 'mng', 'avi', 'mov', 'qt', 'mts', 'm2ts', 'ts', 'wmv', 'yuv', 'rm', 'rmvb', 'viv', 'asf', 'amv', 'm4p', 'mpeg', 'mpe', 'm2v', 'm4v', 'svi', '3gp', '3g2', 'mxf', 'roq', 'nsv', 'f4v', 'f4p', 'f4a', 'f4b'];
const componentInfo$f = {
  name: 'Image',
  static: true,
  image: 'https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4',
  defaultStyles: {
    position: 'relative',
    minHeight: '20px',
    minWidth: '20px',
    overflow: 'hidden'
  },
  canHaveChildren: true,
  inputs: [{
    name: 'image',
    type: 'file',
    bubble: true,
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true,
    defaultValue: 'https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F72c80f114dc149019051b6852a9e3b7a',
    onChange: options => {
      const DEFAULT_ASPECT_RATIO = 0.7041;
      options.delete('srcset');
      options.delete('noWebp');
      function loadImage(url, timeout = 60000) {
        return new Promise((resolve, reject) => {
          const img = document.createElement('img');
          let loaded = false;
          img.onload = () => {
            loaded = true;
            resolve(img);
          };
          img.addEventListener('error', event => {
            console.warn('Image load failed', event.error);
            reject(event.error);
          });
          img.src = url;
          setTimeout(() => {
            if (!loaded) {
              reject(new Error('Image load timed out'));
            }
          }, timeout);
        });
      }
      function round(num) {
        return Math.round(num * 1000) / 1000;
      }
      const value = options.get('image');
      const aspectRatio = options.get('aspectRatio');
      // For SVG images - don't render as webp, keep them as SVG
      fetch(value).then(res => res.blob()).then(blob => {
        if (blob.type.includes('svg')) {
          options.set('noWebp', true);
        }
      });
      if (value && (!aspectRatio || aspectRatio === DEFAULT_ASPECT_RATIO)) {
        return loadImage(value).then(img => {
          const possiblyUpdatedAspectRatio = options.get('aspectRatio');
          if (options.get('image') === value && (!possiblyUpdatedAspectRatio || possiblyUpdatedAspectRatio === DEFAULT_ASPECT_RATIO)) {
            if (img.width && img.height) {
              options.set('aspectRatio', round(img.height / img.width));
              options.set('height', img.height);
              options.set('width', img.width);
            }
          }
        });
      }
    }
  }, {
    name: 'backgroundSize',
    type: 'text',
    defaultValue: 'cover',
    enum: [{
      label: 'contain',
      value: 'contain',
      helperText: 'The image should never get cropped'
    }, {
      label: 'cover',
      value: 'cover',
      helperText: "The image should fill it's box, cropping when needed"
    }]
  }, {
    name: 'backgroundPosition',
    type: 'text',
    defaultValue: 'center',
    enum: ['center', 'top', 'left', 'right', 'bottom', 'top left', 'top right', 'bottom left', 'bottom right']
  }, {
    name: 'altText',
    type: 'string',
    helperText: 'Text to display when the user has images off'
  }, {
    name: 'title',
    type: 'string',
    helperText: 'Text to display when hovering over the asset'
  }, {
    name: 'height',
    type: 'number',
    hideFromUI: true
  }, {
    name: 'width',
    type: 'number',
    hideFromUI: true
  }, {
    name: 'sizes',
    type: 'string',
    hideFromUI: true
  }, {
    name: 'srcset',
    type: 'string',
    hideFromUI: true
  }, {
    name: 'lazy',
    type: 'boolean',
    defaultValue: true,
    hideFromUI: true
  }, {
    name: 'fitContent',
    type: 'boolean',
    helperText: "When child blocks are provided, fit to them instead of using the image's aspect ratio",
    defaultValue: true
  }, {
    name: 'highPriority',
    type: 'boolean',
    advanced: true,
    helperText: 'Mark this image as high priority compared to other images on the page. This prevents lazy loading of the image and tells the browser to load this image before others on the page.'
  }, {
    name: 'aspectRatio',
    type: 'number',
    helperText: "This is the ratio of height/width, e.g. set to 1.5 for a 300px wide and 200px tall photo. Set to 0 to not force the image to maintain it's aspect ratio",
    advanced: true,
    defaultValue: 0.7041
  }],
  shouldReceiveBuilderProps: {
    builderBlock: true
  }
};
const componentInfo$e = {
  name: 'PersonalizationContainer',
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true
  },
  noWrap: true,
  image: 'https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F37229ed30d8c41dfb10b8cca1992053a',
  canHaveChildren: true,
  inputs: [{
    name: 'variants',
    defaultValue: [],
    behavior: 'personalizationVariantList',
    type: 'list',
    subFields: [{
      name: 'name',
      type: 'text'
    }, {
      name: 'query',
      friendlyName: 'Targeting rules',
      type: 'BuilderQuery',
      defaultValue: []
    }, {
      name: 'startDate',
      type: 'date'
    }, {
      name: 'endDate',
      type: 'date'
    }, {
      name: 'blocks',
      type: 'uiBlocks',
      hideFromUI: true,
      defaultValue: []
    }]
  }]
};
let InlinedScript = /*#__PURE__*/(() => {
  class InlinedScript {
    constructor(renderer, elRef) {
      this.renderer = renderer;
      this.elRef = elRef;
      this.scriptStr = input.required();
      this.id = input.required();
      this.nonce = input.required();
    }
    ngOnInit() {
      const script = this.renderer.createElement('script');
      script.text = this.scriptStr();
      this.renderer.setAttribute(script, 'data-id', this.id());
      this.renderer.setAttribute(script, 'nonce', this.nonce());
      this.renderer.appendChild(this.elRef.nativeElement, script);
    }
    static {
      this.ɵfac = function InlinedScript_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InlinedScript)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InlinedScript,
        selectors: [["inlined-script"], ["InlinedScript"]],
        inputs: {
          scriptStr: [1, "scriptStr"],
          id: [1, "id"],
          nonce: [1, "nonce"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 0,
        vars: 0,
        template: function InlinedScript_Template(rf, ctx) {},
        dependencies: [CommonModule],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return InlinedScript;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function isPreviewing(_search) {
  const search = _search || (isBrowser() ? window.location.search : undefined);
  /**
   * If this function is called on the server without an explicit `search` argument,
   * then it can't check if the user is previewing, and will return `false`.
   */
  if (!search) {
    return false;
  }
  const normalizedSearch = getSearchString(search);
  return Boolean(normalizedSearch.indexOf('builder.preview=') !== -1);
}
let PersonalizationContainer = /*#__PURE__*/(() => {
  class PersonalizationContainer {
    templateStr_lw6jtt() {
      return `variants-styles-${this.builderBlock()?.id}`;
    }
    templateStr_rpibqx() {
      return `variants-visibility-script-${this.builderBlock()?.id}`;
    }
    objSpread_BlocksWrapperProps_wq9i0g(variant, index) {
      return {
        ...this.builderContext()?.BlocksWrapperProps,
        "aria-hidden": true,
        hidden: true,
        "data-variant-id": `${this.builderBlock()?.id}-${index}`
      };
    }
    templateStr_q6jkc(variant, index) {
      return `component.options.variants.${index}.blocks`;
    }
    templateStr_cbpzp5(variant, index) {
      return `variants-script-${this.builderBlock()?.id}-${index}`;
    }
    templateStr_f5w03p() {
      return `variants-script-${this.builderBlock()?.id}-${DEFAULT_INDEX}`;
    }
    setAttributes(el, value, changes) {
      if (!el) {
        return;
      }
      const target = typeof changes === "undefined" ? value : changes;
      Object.keys(target).forEach(key => {
        if (key.startsWith("on")) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace("on", "").toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key.toLowerCase(), target[key] ?? "");
        }
      });
    }
    trackByVariant0(index, variant) {
      return `${this.builderBlock()?.id}-${index}`;
    }
    constructor(renderer) {
      this.renderer = renderer;
      this.SDKS_REQUIRING_RESET_APPROACH = SDKS_REQUIRING_RESET_APPROACH;
      this.TARGET = TARGET;
      this.builderContext = input();
      this.variants = input();
      this.builderBlock = input();
      this.attributes = input();
      this.previewingIndex = input();
      this.builderComponents = input();
      this.rootRef = viewChild("rootRef");
      this.elRef0 = viewChild("elRef0");
      this.userAttributes = signal(userAttributesService.getUserAttributes());
      this.scriptStr = signal(undefined);
      this.updateVisibilityStylesScript = signal(undefined);
      this.unsubscribers = signal([]);
      this.shouldRenderVariants = signal(undefined);
      this.shouldResetVariants = signal(false);
      this._listenerFns = new Map();
      this.attrs = computed(() => {
        return {
          ...this.attributes(),
          ...{},
          [getClassPropName()]: `builder-personalization-container ${this.attributes()[getClassPropName()] || ""}`
        };
      });
      this.filteredVariants = computed(() => {
        return (this.variants() || []).filter(variant => {
          return filterWithCustomTargeting({
            ...(this.builderContext()?.rootState?.locale ? {
              locale: this.builderContext()?.rootState?.locale
            } : {}),
            ...this.userAttributes()
          }, variant.query, variant.startDate, variant.endDate);
        });
      });
      this.blocksToRender = computed(() => {
        return getBlocksToRender({
          variants: this.variants(),
          fallbackBlocks: this.builderBlock()?.children,
          isHydrated: this.shouldResetVariants(),
          filteredVariants: this.filteredVariants(),
          previewingIndex: this.previewingIndex()
        });
      });
      this.hideVariantsStyleString = computed(() => {
        return (this.variants() || []).map((_, index) => `div[data-variant-id="${this.builderBlock()?.id}-${index}"] { display: none !important; } `).join("");
      });
      this.objSpread_BlocksWrapperProps_oi5c20 = computed(() => {
        return {
          ...this.builderContext()?.BlocksWrapperProps,
          "data-variant-id": `${this.builderBlock()?.id}-${this.blocksToRender().index}`
        };
      });
      if (typeof window !== "undefined") {
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, this.attrs());
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngOnInit() {
      this.shouldRenderVariants.set(checkShouldRenderVariants$1(this.variants(), getDefaultCanTrack(this.builderContext()?.canTrack)));
      this.updateVisibilityStylesScript.set(getUpdateVisibilityStylesScript(this.variants(), this.builderBlock()?.id || "none", this.builderContext()?.rootState?.locale));
      this.scriptStr.set(getPersonalizationScript(this.variants(), this.builderBlock()?.id || "none", this.builderContext()?.rootState?.locale));
    }
    ngAfterViewInit() {
      if (typeof window !== "undefined") {
        this.shouldResetVariants.set(true);
        const unsub = userAttributesService.subscribeOnUserAttributesChange(attrs => {
          this.userAttributes.set(attrs);
        }, {
          fireImmediately: TARGET === "qwik"
        });
        if (!(isEditing() || isPreviewing())) {
          const variant = this.filteredVariants()[0];
          if (this.rootRef()?.nativeElement) {
            this.rootRef()?.nativeElement.dispatchEvent(new CustomEvent("builder.variantLoaded", {
              detail: {
                variant: variant || DEFAULT_INDEX,
                content: this.builderContext()?.content
              },
              bubbles: true
            }));
            const observer = new IntersectionObserver(entries => {
              entries.forEach(entry => {
                if (entry.isIntersecting && this.rootRef()?.nativeElement) {
                  this.rootRef()?.nativeElement.dispatchEvent(new CustomEvent("builder.variantDisplayed", {
                    detail: {
                      variant: variant || DEFAULT_INDEX,
                      content: this.builderContext()?.content
                    },
                    bubbles: true
                  }));
                }
              });
            });
            observer.observe(this.rootRef()?.nativeElement);
          }
        }
        this.unsubscribers().push(unsub);
      }
      this.setAttributes(this.elRef0()?.nativeElement, this.attrs());
    }
    ngOnDestroy() {
      this.unsubscribers().forEach(unsub => unsub());
    }
    static {
      this.ɵfac = function PersonalizationContainer_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PersonalizationContainer)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PersonalizationContainer,
        selectors: [["personalization-container"]],
        viewQuery: function PersonalizationContainer_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.rootRef, _c16, 5);
            i0.ɵɵviewQuerySignal(ctx.elRef0, _c12, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(2);
          }
        },
        inputs: {
          builderContext: [1, "builderContext"],
          variants: [1, "variants"],
          builderBlock: [1, "builderBlock"],
          attributes: [1, "attributes"],
          previewingIndex: [1, "previewingIndex"],
          builderComponents: [1, "builderComponents"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 5,
        vars: 2,
        consts: [["rootRef", "", "elRef0", ""], [3, "blocks", "parent", "path", "context", "registeredComponents", "BlocksWrapperProps"], [3, "nonce", "scriptStr", "id"], [3, "nonce", "styles", "id"], [3, "BlocksWrapperProps", "blocks", "parent", "path", "context", "registeredComponents"]],
        template: function PersonalizationContainer_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", null, 0);
            i0.ɵɵtemplate(3, PersonalizationContainer_Conditional_3_Template, 1, 6, "blocks", 1)(4, PersonalizationContainer_Conditional_4_Template, 3, 8, "blocks", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.shouldResetVariants() && ctx.SDKS_REQUIRING_RESET_APPROACH.includes(ctx.TARGET) ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.shouldResetVariants() && ctx.SDKS_REQUIRING_RESET_APPROACH.includes(ctx.TARGET) || !ctx.SDKS_REQUIRING_RESET_APPROACH.includes(ctx.TARGET) ? 4 : -1);
          }
        },
        dependencies: [CommonModule, Blocks, InlinedStyles, InlinedScript],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return PersonalizationContainer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const componentInfo$d = {
  name: 'Core:Section',
  static: true,
  image: 'https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F682efef23ace49afac61748dd305c70a',
  inputs: [{
    name: 'maxWidth',
    type: 'number',
    defaultValue: 1200
  }, {
    name: 'lazyLoad',
    type: 'boolean',
    defaultValue: false,
    advanced: true,
    description: 'Only render this section when in view'
  }],
  defaultStyles: {
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '50px',
    paddingBottom: '50px',
    marginTop: '0px',
    width: '100vw',
    marginLeft: 'calc(50% - 50vw)'
  },
  canHaveChildren: true,
  defaultChildren: [{
    '@type': '@builder.io/sdk:Element',
    responsiveStyles: {
      large: {
        textAlign: 'center'
      }
    },
    component: {
      name: 'Text',
      options: {
        text: "<p><b>I am a section! My content keeps from getting too wide, so that it's easy to read even on big screens.</b></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur</p>"
      }
    }
  }]
};
const componentInfo$c = {
  name: 'Slot',
  isRSC: true,
  description: 'Allow child blocks to be inserted into this content when used as a Symbol',
  docsLink: 'https://www.builder.io/c/docs/symbols-with-blocks',
  image: 'https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F3aad6de36eae43b59b52c85190fdef56',
  // Maybe wrap this for canHaveChildren so bind children to this hm
  inputs: [{
    name: 'name',
    type: 'string',
    required: true,
    defaultValue: 'children'
  }],
  shouldReceiveBuilderProps: {
    builderContext: true,
    builderComponents: true
  }
};
let Slot = /*#__PURE__*/(() => {
  class Slot {
    templateStr_y9vvxs() {
      return `symbol.data.${this.name()}`;
    }
    setAttributes(el, value, changes) {
      if (!el) {
        return;
      }
      const target = typeof changes === "undefined" ? value : changes;
      Object.keys(target).forEach(key => {
        if (key.startsWith("on")) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace("on", "").toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key.toLowerCase(), target[key] ?? "");
        }
      });
    }
    constructor(renderer) {
      this.renderer = renderer;
      this.builderContext = input();
      this.name = input();
      this.builderComponents = input();
      this.elRef0 = viewChild("elRef0");
      this._listenerFns = new Map();
      this.objSpread_parent_76vll8 = computed(() => {
        return this.builderContext().context?.symbolId;
      });
      this.objSpread_blocks_j4a76r = computed(() => {
        return this.builderContext().rootState?.[this.name()];
      });
      if (typeof window !== "undefined") {
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, !this.builderContext().context?.symbolId && {
            "builder-slot": this.name()
          });
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngAfterViewInit() {
      this.setAttributes(this.elRef0()?.nativeElement, !this.builderContext().context?.symbolId && {
        "builder-slot": this.name()
      });
    }
    ngOnDestroy() {
      for (const fn of this._listenerFns.values()) {
        fn();
      }
    }
    static {
      this.ɵfac = function Slot_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Slot)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Slot,
        selectors: [["slot"]],
        viewQuery: function Slot_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.elRef0, _c12, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          builderContext: [1, "builderContext"],
          name: [1, "name"],
          builderComponents: [1, "builderComponents"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 7,
        consts: [["elRef0", ""], [3, "ngStyle"], [3, "parent", "path", "context", "registeredComponents", "blocks"]],
        template: function Slot_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵelement(2, "blocks", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(6, _c17));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("parent", ctx.objSpread_parent_76vll8())("path", ctx.templateStr_y9vvxs())("context", ctx.builderContext())("registeredComponents", ctx.builderComponents())("blocks", ctx.objSpread_blocks_j4a76r());
          }
        },
        dependencies: [CommonModule, i1.NgStyle, Blocks],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return Slot;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const componentInfo$b = {
  name: 'Symbol',
  noWrap: true,
  static: true,
  isRSC: true,
  inputs: [{
    name: 'symbol',
    type: 'uiSymbol'
  }, {
    name: 'dataOnly',
    helperText: "Make this a data symbol that doesn't display any UI",
    type: 'boolean',
    defaultValue: false,
    advanced: true,
    hideFromUI: true
  }, {
    name: 'inheritState',
    helperText: 'Inherit the parent component state and data',
    type: 'boolean',
    defaultValue: false,
    advanced: true
  }, {
    name: 'renderToLiquid',
    helperText: 'Render this symbols contents to liquid. Turn off to fetch with javascript and use custom targeting',
    type: 'boolean',
    defaultValue: false,
    advanced: true,
    hideFromUI: true
  }, {
    name: 'useChildren',
    hideFromUI: true,
    type: 'boolean'
  }],
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true
  }
};
const defaultTab = {
  '@type': '@builder.io/sdk:Element',
  responsiveStyles: {
    large: {
      paddingLeft: '20px',
      paddingRight: '20px',
      paddingTop: '10px',
      paddingBottom: '10px',
      minWidth: '100px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      cursor: 'pointer',
      userSelect: 'none'
    }
  },
  component: {
    name: 'Text',
    options: {
      text: 'New tab'
    }
  }
};
const defaultElement = {
  '@type': '@builder.io/sdk:Element',
  responsiveStyles: {
    large: {
      height: '200px',
      display: 'flex',
      marginTop: '20px',
      flexDirection: 'column'
    }
  },
  component: {
    name: 'Text',
    options: {
      text: 'New tab content '
    }
  }
};
const componentInfo$a = {
  name: 'Builder: Tabs',
  inputs: [{
    name: 'tabs',
    type: 'list',
    broadcast: true,
    subFields: [{
      name: 'label',
      type: 'uiBlocks',
      hideFromUI: true,
      defaultValue: [defaultTab]
    }, {
      name: 'content',
      type: 'uiBlocks',
      hideFromUI: true,
      defaultValue: [defaultElement]
    }],
    defaultValue: [{
      label: [{
        ...defaultTab,
        component: {
          name: 'Text',
          options: {
            text: 'Tab 1'
          }
        }
      }],
      content: [{
        ...defaultElement,
        component: {
          name: 'Text',
          options: {
            text: 'Tab 1 content'
          }
        }
      }]
    }, {
      label: [{
        ...defaultTab,
        component: {
          name: 'Text',
          options: {
            text: 'Tab 2'
          }
        }
      }],
      content: [{
        ...defaultElement,
        component: {
          name: 'Text',
          options: {
            text: 'Tab 2 content'
          }
        }
      }]
    }]
  }, {
    name: 'activeTabStyle',
    type: 'uiStyle',
    helperText: 'CSS styles for the active tab',
    defaultValue: {
      backgroundColor: 'rgba(0, 0, 0, 0.1)'
    }
  }, {
    name: 'defaultActiveTab',
    type: 'number',
    helperText: 'Default tab to open to. Set to "1" for the first tab, "2" for the second, or choose "0" for none',
    defaultValue: 1,
    advanced: true
  }, {
    name: 'collapsible',
    type: 'boolean',
    helperText: 'If on, clicking an open tab closes it so no tabs are active',
    defaultValue: false,
    advanced: true
  }, {
    name: 'tabHeaderLayout',
    type: 'enum',
    helperText: 'Change the layout of the tab headers (uses justify-content)',
    defaultValue: 'flex-start',
    enum: [{
      label: 'Center',
      value: 'center'
    }, {
      label: 'Space between',
      value: 'space-between'
    }, {
      label: 'Space around',
      value: 'space-around'
    }, {
      label: 'Left',
      value: 'flex-start'
    }, {
      label: 'Right',
      value: 'flex-end'
    }]
  }],
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true
  }
};
let Tabs = /*#__PURE__*/(() => {
  class Tabs {
    activeTabContent(active) {
      return this.tabs() && this.tabs()[active].content;
    }
    getTabStyle(index) {
      return index === this.activeTab() ? this.activeTabStyle() : {};
    }
    onClick(index) {
      if (index === this.activeTab() && this.collapsible()) {
        this.activeTab.set(-1);
      } else {
        this.activeTab.set(index);
      }
    }
    templateStr_1fubij(tab, index) {
      return `builder-tab-wrap ${this.activeTab() === index ? "builder-tab-active" : ""}`;
    }
    templateStr_fz5znr(tab, index) {
      return `tabs.${index}.label`;
    }
    templateStr_nlekn6() {
      return `tabs.${this.activeTab()}.content`;
    }
    trackByTab0(index, tab) {
      return index;
    }
    constructor() {
      this.defaultActiveTab = input();
      this.tabs = input();
      this.activeTabStyle = input();
      this.collapsible = input();
      this.tabHeaderLayout = input();
      this.builderBlock = input();
      this.builderContext = input();
      this.builderComponents = input();
      this.builderLinkComponent = input();
      this.activeTab = signal(undefined);
    }
    ngOnInit() {
      this.activeTab.set(this.defaultActiveTab() ? this.defaultActiveTab() - 1 : 0);
    }
    static {
      this.ɵfac = function Tabs_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Tabs)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Tabs,
        selectors: [["tabs"]],
        inputs: {
          defaultActiveTab: [1, "defaultActiveTab"],
          tabs: [1, "tabs"],
          activeTabStyle: [1, "activeTabStyle"],
          collapsible: [1, "collapsible"],
          tabHeaderLayout: [1, "tabHeaderLayout"],
          builderBlock: [1, "builderBlock"],
          builderContext: [1, "builderContext"],
          builderComponents: [1, "builderComponents"],
          builderLinkComponent: [1, "builderLinkComponent"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 5,
        vars: 4,
        consts: [[1, "builder-tabs-wrap", 3, "ngStyle"], [3, "class", "ngStyle"], [3, "click", "ngStyle"], [3, "parent", "path", "blocks", "context", "registeredComponents", "linkComponent"]],
        template: function Tabs_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "div", 0);
            i0.ɵɵrepeaterCreate(2, Tabs_For_3_Template, 2, 9, "span", 1, ctx.trackByTab0, true);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, Tabs_Conditional_4_Template, 2, 6, "div");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c18, ctx.tabHeaderLayout() || "flex-start"));
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.tabs());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.activeTabContent(ctx.activeTab()) ? 4 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgStyle, Blocks],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return Tabs;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const componentInfo$9 = {
  shouldReceiveBuilderProps: TARGET === 'reactNative' ? {
    builderBlock: true,
    builderContext: true
  } : {},
  name: 'Text',
  static: true,
  isRSC: true,
  image: 'https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-text_fields-24px%20(1).svg?alt=media&token=12177b73-0ee3-42ca-98c6-0dd003de1929',
  inputs: [{
    name: 'text',
    type: 'html',
    required: true,
    autoFocus: true,
    bubble: true,
    defaultValue: 'Enter some text...'
  }],
  defaultStyles: {
    lineHeight: 'normal',
    height: 'auto',
    textAlign: 'center'
  }
};
let Text = /*#__PURE__*/(() => {
  class Text {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
      this.text = input();
    }
    static {
      this.ɵfac = function Text_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Text)(i0.ɵɵdirectiveInject(i1$1.DomSanitizer));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Text,
        selectors: [["text"]],
        inputs: {
          text: [1, "text"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 3,
        consts: [[1, "builder-text", 3, "innerHTML", "ngStyle"]],
        template: function Text_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵproperty("innerHTML", ctx.sanitizer.bypassSecurityTrustHtml(((tmp_0_0 = ctx.text()) == null ? null : tmp_0_0.toString()) || ""), i0.ɵɵsanitizeHtml)("ngStyle", i0.ɵɵpureFunction0(2, _c19));
          }
        },
        dependencies: [CommonModule, i1.NgStyle],
        styles: ["[_nghost-%COMP%]{display:contents}"],
        changeDetection: 0
      });
    }
  }
  return Text;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const componentInfo$8 = {
  name: 'Custom Code',
  static: true,
  requiredPermissions: ['editCode'],
  inputs: [{
    name: 'code',
    type: 'html',
    required: true,
    defaultValue: '<p>Hello there, I am custom HTML code!</p>',
    code: true
  }, {
    name: 'replaceNodes',
    type: 'boolean',
    helperText: 'Preserve server rendered dom nodes',
    advanced: true
  }, {
    name: 'scriptsClientOnly',
    type: 'boolean',
    defaultValue: false,
    helperText: 'Only print and run scripts on the client. Important when scripts influence DOM that could be replaced when client loads',
    advanced: true
  }]
};
let CustomCode = /*#__PURE__*/(() => {
  class CustomCode {
    runScripts() {
      if (!this.elementRef()?.nativeElement || !this.elementRef()?.nativeElement?.getElementsByTagName || typeof window === "undefined") {
        return;
      }
      const scripts = this.elementRef()?.nativeElement.getElementsByTagName("script");
      for (let i = 0; i < scripts.length; i++) {
        const script = scripts[i];
        if (script.src) {
          if (this.scriptsInserted().includes(script.src)) {
            continue;
          }
          this.scriptsInserted().push(script.src);
          const newScript = document.createElement("script");
          newScript.async = true;
          newScript.src = script.src;
          document.head.appendChild(newScript);
        } else if (!script.type || ["text/javascript", "application/javascript", "application/ecmascript"].includes(script.type)) {
          if (this.scriptsRun().includes(script.innerText)) {
            continue;
          }
          try {
            requestAnimationFrame(() => {
              this.scriptsRun().push(script.innerText);
              new Function(script.innerText)();
            });
          } catch (error) {
            logger.warn("[BUILDER.IO] `CustomCode`: Error running script:", error);
          }
        }
      }
    }
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
      this.code = input();
      this.replaceNodes = input();
      this.elementRef = viewChild("elementRef");
      this.scriptsInserted = signal([]);
      this.scriptsRun = signal([]);
      if (typeof window !== "undefined") {
        effect(() => {
          // --- Mitosis: Workaround to make sure the effect() is triggered ---
          this.code();
          // ---
          if (isEditing()) {
            setTimeout(() => {
              this.runScripts();
            }, 0);
          }
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngAfterViewInit() {
      if (typeof window !== "undefined") {
        this.runScripts();
      }
    }
    static {
      this.ɵfac = function CustomCode_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CustomCode)(i0.ɵɵdirectiveInject(i1$1.DomSanitizer));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CustomCode,
        selectors: [["custom-code"]],
        viewQuery: function CustomCode_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.elementRef, _c20, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          code: [1, "code"],
          replaceNodes: [1, "replaceNodes"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 3,
        consts: [["elementRef", ""], [3, "innerHTML"]],
        template: function CustomCode_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 1, 0);
          }
          if (rf & 2) {
            i0.ɵɵclassMap("builder-custom-code" + (ctx.replaceNodes() ? " replace-nodes" : ""));
            i0.ɵɵproperty("innerHTML", ctx.sanitizer.bypassSecurityTrustHtml(ctx.code()), i0.ɵɵsanitizeHtml);
          }
        },
        dependencies: [CommonModule],
        styles: ["[_nghost-%COMP%]{display:contents}"],
        changeDetection: 0
      });
    }
  }
  return CustomCode;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const componentInfo$7 = {
  name: 'Embed',
  static: true,
  inputs: [{
    name: 'url',
    type: 'url',
    required: true,
    defaultValue: '',
    helperText: 'e.g. enter a youtube url, google map, etc'
  }, {
    name: 'content',
    type: 'html',
    defaultValue: '<div style="padding: 20px; text-align: center">(Choose an embed URL)<div>',
    hideFromUI: true
  }]
};
const SCRIPT_MIME_TYPES = ['text/javascript', 'application/javascript', 'application/ecmascript'];
const isJsScript = script => SCRIPT_MIME_TYPES.includes(script.type);
let Embed = /*#__PURE__*/(() => {
  class Embed {
    findAndRunScripts() {
      if (!this.elem()?.nativeElement || !this.elem()?.nativeElement.getElementsByTagName) return;
      const scripts = this.elem()?.nativeElement.getElementsByTagName("script");
      for (let i = 0; i < scripts.length; i++) {
        const script = scripts[i];
        if (script.src && !this.scriptsInserted().includes(script.src)) {
          this.scriptsInserted().push(script.src);
          const newScript = document.createElement("script");
          newScript.async = true;
          newScript.src = script.src;
          document.head.appendChild(newScript);
        } else if (isJsScript(script) && !this.scriptsRun().includes(script.innerText)) {
          try {
            requestAnimationFrame(() => {
              this.scriptsRun().push(script.innerText);
              new Function(script.innerText)();
            });
          } catch (error) {
            logger.warn("[BUILDER.IO] `Embed`: Error running script:", error);
          }
        }
      }
    }
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
      this.content = input();
      this.elem = viewChild("elem");
      this.scriptsInserted = signal([]);
      this.scriptsRun = signal([]);
      this.ranInitFn = signal(false);
      if (typeof window !== "undefined") {
        effect(() => {
          // --- Mitosis: Workaround to make sure the effect() is triggered ---
          this.elem();
          this.ranInitFn();
          // ---
          if (this.elem()?.nativeElement && !this.ranInitFn()) {
            this.ranInitFn.set(true);
            this.findAndRunScripts();
          }
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    static {
      this.ɵfac = function Embed_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Embed)(i0.ɵɵdirectiveInject(i1$1.DomSanitizer));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Embed,
        selectors: [["builder-embed"]],
        viewQuery: function Embed_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.elem, _c21, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          content: [1, "content"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 1,
        consts: [["elem", ""], [1, "builder-embed", 3, "innerHTML"]],
        template: function Embed_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 1, 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("innerHTML", ctx.sanitizer.bypassSecurityTrustHtml(ctx.content()), i0.ɵɵsanitizeHtml);
          }
        },
        dependencies: [CommonModule],
        styles: ["[_nghost-%COMP%]{display:contents}"],
        changeDetection: 0
      });
    }
  }
  return Embed;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const componentInfo$6 = {
  name: 'Form:Form',
  // editableTags: ['builder-form-error']
  defaults: {
    responsiveStyles: {
      large: {
        marginTop: '15px',
        paddingBottom: '15px'
      }
    }
  },
  image: 'https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fef36d2a846134910b64b88e6d18c5ca5',
  inputs: [{
    name: 'sendSubmissionsTo',
    type: 'string',
    // TODO: save to builder data and user can download as csv
    // TODO: easy for mode too or computed add/remove fields form mode
    // so you can edit details and high level mode at same time...
    // Later - more integrations like mailchimp
    // /api/v1/form-submit?to=mailchimp
    enum: [{
      label: 'Send to email',
      value: 'email',
      helperText: 'Send form submissions to the email address of your choosing'
    }, {
      label: 'Custom',
      value: 'custom',
      helperText: 'Handle where the form requests go manually with a little code, e.g. to your own custom backend'
    }],
    defaultValue: 'email'
  }, {
    name: 'sendSubmissionsToEmail',
    type: 'string',
    required: true,
    // TODO: required: () => options.get("sendSubmissionsTo") === "email"
    defaultValue: 'your@email.com',
    showIf: 'options.get("sendSubmissionsTo") === "email"'
  }, {
    name: 'sendWithJs',
    type: 'boolean',
    helperText: 'Set to false to use basic html form action',
    defaultValue: true,
    showIf: 'options.get("sendSubmissionsTo") === "custom"'
  }, {
    name: 'name',
    type: 'string',
    defaultValue: 'My form'
    // advanced: true
  }, {
    name: 'action',
    type: 'string',
    helperText: 'URL to send the form data to',
    showIf: 'options.get("sendSubmissionsTo") === "custom"'
  }, {
    name: 'contentType',
    type: 'string',
    defaultValue: 'application/json',
    advanced: true,
    // TODO: do automatically if file input
    enum: ['application/json', 'multipart/form-data', 'application/x-www-form-urlencoded'],
    showIf: 'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'
  }, {
    name: 'method',
    type: 'string',
    showIf: 'options.get("sendSubmissionsTo") === "custom"',
    defaultValue: 'POST',
    advanced: true
  }, {
    name: 'previewState',
    type: 'string',
    // TODO: persist: false flag
    enum: ['unsubmitted', 'sending', 'success', 'error'],
    defaultValue: 'unsubmitted',
    helperText: 'Choose a state to edit, e.g. choose "success" to show what users see on success and edit the message',
    showIf: 'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'
  }, {
    name: 'successUrl',
    type: 'url',
    helperText: 'Optional URL to redirect the user to on form submission success',
    showIf: 'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'
  }, {
    name: 'resetFormOnSubmit',
    type: 'boolean',
    showIf: "options.get('sendSubmissionsTo') === 'custom' && options.get('sendWithJs') === true",
    advanced: true
  }, {
    name: 'successMessage',
    type: 'uiBlocks',
    hideFromUI: true,
    defaultValue: [{
      '@type': '@builder.io/sdk:Element',
      responsiveStyles: {
        large: {
          marginTop: '10px'
        }
      },
      component: {
        name: 'Text',
        options: {
          text: '<span>Thanks!</span>'
        }
      }
    }]
  }, {
    name: 'validate',
    type: 'boolean',
    defaultValue: true,
    advanced: true
  }, {
    name: 'errorMessagePath',
    type: 'text',
    advanced: true,
    helperText: 'Path to where to get the error message from in a JSON response to display to the user, e.g. "error.message" for a response like { "error": { "message": "this username is taken" }}'
  }, {
    name: 'errorMessage',
    type: 'uiBlocks',
    hideFromUI: true,
    defaultValue: [{
      '@type': '@builder.io/sdk:Element',
      responsiveStyles: {
        large: {
          marginTop: '10px'
        }
      },
      bindings: {
        'component.options.text': 'state.formErrorMessage || block.component.options.text'
      },
      component: {
        name: 'Text',
        options: {
          text: '<span>Form submission error :( Please check your answers and try again</span>'
        }
      }
    }]
  }, {
    name: 'sendingMessage',
    type: 'uiBlocks',
    hideFromUI: true,
    defaultValue: [{
      '@type': '@builder.io/sdk:Element',
      responsiveStyles: {
        large: {
          marginTop: '10px'
        }
      },
      component: {
        name: 'Text',
        options: {
          text: '<span>Sending...</span>'
        }
      }
    }]
  }, {
    name: 'customHeaders',
    type: 'map',
    valueType: {
      type: 'string'
    },
    advanced: true,
    showIf: 'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'
  }],
  noWrap: true,
  canHaveChildren: true,
  defaultChildren: [{
    '@type': '@builder.io/sdk:Element',
    responsiveStyles: {
      large: {
        marginTop: '10px'
      }
    },
    component: {
      name: 'Text',
      options: {
        text: '<span>Enter your name</span>'
      }
    }
  }, {
    '@type': '@builder.io/sdk:Element',
    responsiveStyles: {
      large: {
        marginTop: '10px'
      }
    },
    component: {
      name: 'Form:Input',
      options: {
        name: 'name',
        placeholder: 'Jane Doe'
      }
    }
  }, {
    '@type': '@builder.io/sdk:Element',
    responsiveStyles: {
      large: {
        marginTop: '10px'
      }
    },
    component: {
      name: 'Text',
      options: {
        text: '<span>Enter your email</span>'
      }
    }
  }, {
    '@type': '@builder.io/sdk:Element',
    responsiveStyles: {
      large: {
        marginTop: '10px'
      }
    },
    component: {
      name: 'Form:Input',
      options: {
        name: 'email',
        placeholder: 'jane@doe.com'
      }
    }
  }, {
    '@type': '@builder.io/sdk:Element',
    responsiveStyles: {
      large: {
        marginTop: '10px'
      }
    },
    component: {
      name: 'Form:SubmitButton',
      options: {
        text: 'Submit'
      }
    }
  }],
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true
  }
};
const validEnvList = ['production', 'qa', 'test', 'development', 'dev', 'cdn-qa', 'cloud', 'fast', 'cdn2', 'cdn-prod'];
const getEnv = () => {
  const env = process.env.NODE_ENV || 'production';
  return validEnvList.includes(env) ? env : 'production';
};
function logFetch(url) {
  if (typeof process !== 'undefined' && process.env?.DEBUG) {
    if (String(process.env.DEBUG) == 'true') {
      logger.log(url);
    }
  }
}
let FormComponent = /*#__PURE__*/(() => {
  class FormComponent {
    mergeNewRootState(newData) {
      const combinedState = {
        ...this.builderContext().rootState,
        ...newData
      };
      if (this.builderContext().rootSetState) {
        this.builderContext().rootSetState?.(combinedState);
      } else {
        this.builderContext().rootState = combinedState;
      }
    }
    submissionState() {
      return isEditing() && this.previewState() || this.formState();
    }
    errorResponse(response) {
      return JSON.stringify(response, null, 2);
    }
    onSubmit(event) {
      const sendWithJsProp = this.sendWithJs() || this.sendSubmissionsTo() === "email";
      if (this.sendSubmissionsTo() === "zapier") {
        event.preventDefault();
      } else if (sendWithJsProp) {
        if (!(this.action() || this.sendSubmissionsTo() === "email")) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        const el = event.currentTarget || event.target;
        const headers = this.customHeaders() || {};
        let body;
        const formData = new FormData(el);
        // TODO: maybe support null
        const formPairs = Array.from(el.querySelectorAll("input,select,textarea")).filter(el => !!el.name).filter(el => !!el.name && (el.type !== "radio" || el.checked)).map(el => {
          let value;
          const key = el.name;
          if (el instanceof HTMLInputElement) {
            if (el.type === "radio") {
              if (el.checked) {
                value = el.value;
                return {
                  key,
                  value
                };
              }
            } else if (el.type === "checkbox") {
              value = el.checked;
            } else if (el.type === "number" || el.type === "range") {
              const num = el.valueAsNumber;
              if (!isNaN(num)) {
                value = num;
              }
            } else if (el.type === "file") {
              // TODO: one vs multiple files
              value = el.files;
            } else {
              value = el.value;
            }
          } else {
            value = el.value;
          }
          return {
            key,
            value
          };
        });
        let formContentType = this.contentType();
        if (this.sendSubmissionsTo() === "email") {
          formContentType = "multipart/form-data";
        }
        Array.from(formPairs).forEach(({
          value
        }) => {
          if (value instanceof File || Array.isArray(value) && value[0] instanceof File || value instanceof FileList) {
            formContentType = "multipart/form-data";
          }
        });
        // TODO: send as urlEncoded or multipart by default
        // because of ease of use and reliability in browser API
        // for encoding the form?
        if (formContentType !== "application/json") {
          body = formData;
        } else {
          // Json
          const json = {};
          Array.from(formPairs).forEach(({
            value,
            key
          }) => {
            set(json, key, value);
          });
          body = JSON.stringify(json);
        }
        if (formContentType && formContentType !== "multipart/form-data") {
          if (/* Zapier doesn't allow content-type header to be sent from browsers */
          !(sendWithJsProp && this.action()?.includes("zapier.com"))) {
            headers["content-type"] = formContentType;
          }
        }
        const presubmitEvent = new CustomEvent("presubmit", {
          detail: {
            body
          }
        });
        if (this.formRef()?.nativeElement) {
          this.formRef()?.nativeElement.dispatchEvent(presubmitEvent);
          if (presubmitEvent.defaultPrevented) {
            return;
          }
        }
        this.formState.set("sending");
        if (this.sendSubmissionsTo() === "email" && (this.sendSubmissionsToEmail() === "your@email.com" || !this.sendSubmissionsToEmail())) {
          const message = "SubmissionsToEmail is required when sendSubmissionsTo is set to email";
          console.error(message);
          this.formState.set("error");
          this.mergeNewRootState({
            formErrorMessage: message
          });
          return;
        }
        const formUrl = `${getEnv() === "dev" ? "http://localhost:5000" : "https://builder.io"}/api/v1/form-submit?apiKey=${this.builderContext().apiKey}&to=${btoa(this.sendSubmissionsToEmail() || "")}&name=${encodeURIComponent(this.name() || "")}`;
        const url = this.sendSubmissionsTo() === "email" ? formUrl : this.action(); /* TODO: throw error if no action URL */
        logFetch(url);
        fetch(url, {
          body,
          headers,
          method: this.method() || "post"
        }).then(async res => {
          let body;
          const contentType = res.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            body = await res.json();
          } else {
            body = await res.text();
          }
          if (!res.ok) {
            const submitErrorEvent = new CustomEvent("submit:error", {
              detail: {
                error: body,
                status: res.status
              }
            });
            if (this.formRef()?.nativeElement?.nativeElement) {
              this.formRef()?.nativeElement?.nativeElement.dispatchEvent(submitErrorEvent);
              if (submitErrorEvent.defaultPrevented) {
                return;
              }
            }
            this.responseData.set(body);
            this.formState.set("error");
            let message = this.errorMessagePath() ? get(body, this.errorMessagePath()) : body.message || body.error || body;
            if (typeof message !== "string") {
              message = JSON.stringify(message);
            }
            this.formErrorMessage.set(message);
            this.mergeNewRootState({
              formErrorMessage: message
            });
            return;
          }
          this.responseData.set(body);
          this.formState.set(res.ok ? "success" : "error");
          if (res.ok) {
            const submitSuccessEvent = new CustomEvent("submit:success", {
              detail: {
                res,
                body
              }
            });
            if (this.formRef()?.nativeElement) {
              this.formRef()?.nativeElement.dispatchEvent(submitSuccessEvent);
              if (submitSuccessEvent.defaultPrevented) {
                return;
              }
              /* TODO: option to turn this on/off? */
              if (this.resetFormOnSubmit() !== false) {
                this.formRef()?.nativeElement.reset();
              }
            }
            /* TODO: client side route event first that can be preventDefaulted */
            if (this.successUrl()) {
              if (this.formRef()?.nativeElement) {
                const event = new CustomEvent("route", {
                  detail: {
                    url: this.successUrl()
                  }
                });
                this.formRef()?.nativeElement.dispatchEvent(event);
                if (!event.defaultPrevented) {
                  location.href = this.successUrl();
                }
              } else {
                location.href = this.successUrl();
              }
            }
          }
        }, err => {
          const submitErrorEvent = new CustomEvent("submit:error", {
            detail: {
              error: err
            }
          });
          if (this.formRef()?.nativeElement) {
            this.formRef()?.nativeElement.dispatchEvent(submitErrorEvent);
            if (submitErrorEvent.defaultPrevented) {
              return;
            }
          }
          this.responseData.set(err);
          this.formState.set("error");
        });
      }
    }
    setAttributes(el, value, changes) {
      if (!el) {
        return;
      }
      const target = typeof changes === "undefined" ? value : changes;
      Object.keys(target).forEach(key => {
        if (key.startsWith("on")) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace("on", "").toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key.toLowerCase(), target[key] ?? "");
        }
      });
    }
    constructor(renderer) {
      this.renderer = renderer;
      this.builderContext = input();
      this.previewState = input();
      this.sendWithJs = input();
      this.sendSubmissionsTo = input();
      this.action = input();
      this.customHeaders = input();
      this.contentType = input();
      this.sendSubmissionsToEmail = input();
      this.name = input();
      this.method = input();
      this.errorMessagePath = input();
      this.resetFormOnSubmit = input();
      this.successUrl = input();
      this.validate = input();
      this.attributes = input();
      this.errorMessage = input();
      this.sendingMessage = input();
      this.successMessage = input();
      this.formRef = viewChild("formRef");
      this.elRef0 = viewChild("elRef0");
      this.formState = signal("unsubmitted");
      this.responseData = signal(null);
      this.formErrorMessage = signal("");
      this._listenerFns = new Map();
      if (typeof window !== "undefined") {
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, {});
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, {});
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngAfterViewInit() {
      this.setAttributes(this.elRef0()?.nativeElement, {});
      this.setAttributes(this.elRef0()?.nativeElement, {});
      this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
    }
    ngOnDestroy() {
      for (const fn of this._listenerFns.values()) {
        fn();
      }
    }
    static {
      this.ɵfac = function FormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormComponent)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormComponent,
        selectors: [["form-component"]],
        viewQuery: function FormComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.formRef, _c22, 5);
            i0.ɵɵviewQuerySignal(ctx.elRef0, _c12, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(2);
          }
        },
        inputs: {
          builderContext: [1, "builderContext"],
          previewState: [1, "previewState"],
          sendWithJs: [1, "sendWithJs"],
          sendSubmissionsTo: [1, "sendSubmissionsTo"],
          action: [1, "action"],
          customHeaders: [1, "customHeaders"],
          contentType: [1, "contentType"],
          sendSubmissionsToEmail: [1, "sendSubmissionsToEmail"],
          name: [1, "name"],
          method: [1, "method"],
          errorMessagePath: [1, "errorMessagePath"],
          resetFormOnSubmit: [1, "resetFormOnSubmit"],
          successUrl: [1, "successUrl"],
          validate: [1, "validate"],
          attributes: [1, "attributes"],
          errorMessage: [1, "errorMessage"],
          sendingMessage: [1, "sendingMessage"],
          successMessage: [1, "successMessage"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 8,
        vars: 8,
        consts: [["formRef", "", "elRef0", ""], [3, "submit"], ["path", "errorMessage", 3, "blocks", "context"], ["path", "sendingMessage", 3, "blocks", "context"], [1, "builder-form-error-text", "pre"], ["path", "successMessage", 3, "blocks", "context"]],
        template: function FormComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "form", 1, 0);
            i0.ɵɵlistener("submit", function FormComponent_Template_form_submit_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSubmit($event));
            });
            i0.ɵɵprojection(3);
            i0.ɵɵtemplate(4, FormComponent_Conditional_4_Template, 1, 2, "blocks", 2)(5, FormComponent_Conditional_5_Template, 1, 2, "blocks", 3)(6, FormComponent_Conditional_6_Template, 2, 1, "pre", 4)(7, FormComponent_Conditional_7_Template, 1, 2, "blocks", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵattribute("validate", ctx.validate())("action", !ctx.sendWithJs() && ctx.action(), i0.ɵɵsanitizeUrl)("method", ctx.method())("name", ctx.name());
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.submissionState() === "error" ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.submissionState() === "sending" ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.submissionState() === "error" && ctx.responseData() ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.submissionState() === "success" ? 7 : -1);
          }
        },
        dependencies: [CommonModule, Blocks],
        styles: ["[_nghost-%COMP%]{display:contents}.pre[_ngcontent-%COMP%]{padding:10px;color:red;text-align:center}"]
      });
    }
  }
  return FormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const componentInfo$5 = {
  name: 'Form:Input',
  image: 'https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fad6f37889d9e40bbbbc72cdb5875d6ca',
  inputs: [{
    name: 'type',
    type: 'text',
    enum: ['text', 'number', 'email', 'url', 'checkbox', 'radio', 'range', 'date', 'datetime-local', 'search', 'tel', 'time', 'file', 'month', 'week', 'password', 'color', 'hidden'],
    defaultValue: 'text'
  }, {
    name: 'name',
    type: 'string',
    required: true,
    helperText: 'Every input in a form needs a unique name describing what it takes, e.g. "email"'
  }, {
    name: 'placeholder',
    type: 'string',
    defaultValue: 'Hello there',
    helperText: 'Text to display when there is no value'
  },
  // TODO: handle value vs default value automatically like ng-model
  {
    name: 'defaultValue',
    type: 'string'
  }, {
    name: 'value',
    type: 'string',
    advanced: true
  }, {
    name: 'required',
    type: 'boolean',
    helperText: 'Is this input required to be filled out to submit a form',
    defaultValue: false
  }],
  noWrap: true,
  static: true,
  defaultStyles: {
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingLeft: '10px',
    paddingRight: '10px',
    borderRadius: '3px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#ccc'
  }
};
let FormInputComponent = /*#__PURE__*/(() => {
  class FormInputComponent {
    setAttributes(el, value, changes) {
      if (!el) {
        return;
      }
      const target = typeof changes === "undefined" ? value : changes;
      Object.keys(target).forEach(key => {
        if (key.startsWith("on")) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace("on", "").toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key.toLowerCase(), target[key] ?? "");
        }
      });
    }
    constructor(renderer) {
      this.renderer = renderer;
      this.isEditing = isEditing;
      this.attributes = input();
      this.defaultValue = input();
      this.placeholder = input();
      this.type = input();
      this.name = input();
      this.value = input();
      this.required = input();
      this.elRef0 = viewChild("elRef0");
      this._listenerFns = new Map();
      if (typeof window !== "undefined") {
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, {});
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngAfterViewInit() {
      this.setAttributes(this.elRef0()?.nativeElement, {});
      this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
    }
    ngOnDestroy() {
      for (const fn of this._listenerFns.values()) {
        fn();
      }
    }
    static {
      this.ɵfac = function FormInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormInputComponent)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormInputComponent,
        selectors: [["form-input-component"]],
        viewQuery: function FormInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.elRef0, _c12, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          defaultValue: [1, "defaultValue"],
          placeholder: [1, "placeholder"],
          type: [1, "type"],
          name: [1, "name"],
          value: [1, "value"],
          required: [1, "required"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 6,
        consts: [["elRef0", ""]],
        template: function FormInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "input", null, 0);
          }
          if (rf & 2) {
            i0.ɵɵattribute("placeholder", ctx.placeholder())("type", ctx.type())("name", ctx.name())("value", ctx.value())("defaultValue", ctx.defaultValue())("required", ctx.required());
          }
        },
        dependencies: [CommonModule],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return FormInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const componentInfo$4 = {
  name: 'Form:Select',
  image: 'https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F83acca093fb24aaf94dee136e9a4b045',
  defaultStyles: {
    alignSelf: 'flex-start'
  },
  inputs: [{
    name: 'options',
    type: 'list',
    required: true,
    subFields: [{
      name: 'value',
      type: 'text',
      required: true
    }, {
      name: 'name',
      type: 'text'
    }],
    defaultValue: [{
      value: 'option 1'
    }, {
      value: 'option 2'
    }]
  }, {
    name: 'name',
    type: 'string',
    required: true,
    helperText: 'Every select in a form needs a unique name describing what it gets, e.g. "email"'
  }, {
    name: 'defaultValue',
    type: 'string'
  }, {
    name: 'value',
    type: 'string',
    advanced: true
  }, {
    name: 'required',
    type: 'boolean',
    defaultValue: false
  }],
  static: true,
  noWrap: true
};
let SelectComponent = /*#__PURE__*/(() => {
  class SelectComponent {
    setAttributes(el, value, changes) {
      if (!el) {
        return;
      }
      const target = typeof changes === "undefined" ? value : changes;
      Object.keys(target).forEach(key => {
        if (key.startsWith("on")) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace("on", "").toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key.toLowerCase(), target[key] ?? "");
        }
      });
    }
    trackByOption0(index, option) {
      return `${option.name}-${index}`;
    }
    constructor(renderer) {
      this.renderer = renderer;
      this.isEditing = isEditing;
      this.attributes = input();
      this.value = input();
      this.defaultValue = input();
      this.name = input();
      this.required = input();
      this.options = input();
      this.elRef0 = viewChild("elRef0");
      this._listenerFns = new Map();
      if (typeof window !== "undefined") {
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, {});
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngAfterViewInit() {
      this.setAttributes(this.elRef0()?.nativeElement, {});
      this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
    }
    ngOnDestroy() {
      for (const fn of this._listenerFns.values()) {
        fn();
      }
    }
    static {
      this.ɵfac = function SelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SelectComponent)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SelectComponent,
        selectors: [["select-component"]],
        viewQuery: function SelectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.elRef0, _c12, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          value: [1, "value"],
          defaultValue: [1, "defaultValue"],
          name: [1, "name"],
          required: [1, "required"],
          options: [1, "options"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 4,
        consts: [["elRef0", ""]],
        template: function SelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "select", null, 0);
            i0.ɵɵrepeaterCreate(2, SelectComponent_For_3_Template, 2, 2, "option", null, ctx.trackByOption0, true);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵattribute("value", ctx.value())("defaultValue", ctx.defaultValue())("name", ctx.name())("required", ctx.required());
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.options());
          }
        },
        dependencies: [CommonModule],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return SelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const componentInfo$3 = {
  name: 'Form:SubmitButton',
  image: 'https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fdf2820ffed1f4349a94c40b3221f5b98',
  defaultStyles: {
    appearance: 'none',
    paddingTop: '15px',
    paddingBottom: '15px',
    paddingLeft: '25px',
    paddingRight: '25px',
    backgroundColor: '#3898EC',
    color: 'white',
    borderRadius: '4px',
    cursor: 'pointer'
  },
  inputs: [{
    name: 'text',
    type: 'text',
    defaultValue: 'Click me'
  }],
  static: true,
  noWrap: true
  // TODO: optional children? maybe as optional form input
  // that only shows if advanced setting is flipped
  // TODO: defaultChildren
  // canHaveChildren: true,
};
let SubmitButton = /*#__PURE__*/(() => {
  class SubmitButton {
    setAttributes(el, value, changes) {
      if (!el) {
        return;
      }
      const target = typeof changes === "undefined" ? value : changes;
      Object.keys(target).forEach(key => {
        if (key.startsWith("on")) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace("on", "").toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key.toLowerCase(), target[key] ?? "");
        }
      });
    }
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input();
      this.text = input();
      this.elRef0 = viewChild("elRef0");
      this._listenerFns = new Map();
      if (typeof window !== "undefined") {
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, {});
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngAfterViewInit() {
      this.setAttributes(this.elRef0()?.nativeElement, {});
      this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
    }
    ngOnDestroy() {
      for (const fn of this._listenerFns.values()) {
        fn();
      }
    }
    static {
      this.ɵfac = function SubmitButton_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SubmitButton)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SubmitButton,
        selectors: [["submit-button"]],
        viewQuery: function SubmitButton_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.elRef0, _c12, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          text: [1, "text"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 1,
        consts: [["elRef0", ""], ["type", "submit"]],
        template: function SubmitButton_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 1, 0);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.text());
          }
        },
        dependencies: [CommonModule],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return SubmitButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const componentInfo$2 = {
  name: 'Form:TextArea',
  image: 'https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Ff74a2f3de58c4c3e939204e5b6b8f6c3',
  inputs: [{
    advanced: true,
    name: 'value',
    type: 'string'
  }, {
    name: 'name',
    type: 'string',
    required: true,
    helperText: 'Every input in a form needs a unique name describing what it gets, e.g. "email"'
  }, {
    name: 'defaultValue',
    type: 'string'
  }, {
    name: 'placeholder',
    type: 'string',
    defaultValue: 'Hello there'
  }, {
    name: 'required',
    type: 'boolean',
    defaultValue: false
  }],
  defaultStyles: {
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingLeft: '10px',
    paddingRight: '10px',
    borderRadius: '3px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#ccc'
  },
  static: true,
  noWrap: true
};
let Textarea = /*#__PURE__*/(() => {
  class Textarea {
    setAttributes(el, value, changes) {
      if (!el) {
        return;
      }
      const target = typeof changes === "undefined" ? value : changes;
      Object.keys(target).forEach(key => {
        if (key.startsWith("on")) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace("on", "").toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key.toLowerCase(), target[key] ?? "");
        }
      });
    }
    constructor(renderer) {
      this.renderer = renderer;
      this.attributes = input();
      this.placeholder = input();
      this.name = input();
      this.value = input();
      this.defaultValue = input();
      this.required = input();
      this.elRef0 = viewChild("elRef0");
      this._listenerFns = new Map();
      if (typeof window !== "undefined") {
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, {});
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngAfterViewInit() {
      this.setAttributes(this.elRef0()?.nativeElement, {});
      this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
    }
    ngOnDestroy() {
      for (const fn of this._listenerFns.values()) {
        fn();
      }
    }
    static {
      this.ɵfac = function Textarea_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Textarea)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Textarea,
        selectors: [["builder-textarea"]],
        viewQuery: function Textarea_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.elRef0, _c12, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          attributes: [1, "attributes"],
          placeholder: [1, "placeholder"],
          name: [1, "name"],
          value: [1, "value"],
          defaultValue: [1, "defaultValue"],
          required: [1, "required"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 5,
        consts: [["elRef0", ""]],
        template: function Textarea_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "textarea", null, 0);
          }
          if (rf & 2) {
            i0.ɵɵattribute("placeholder", ctx.placeholder())("name", ctx.name())("value", ctx.value())("defaultValue", ctx.defaultValue())("required", ctx.required());
          }
        },
        dependencies: [CommonModule],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return Textarea;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const componentInfo$1 = {
  // friendlyName?
  name: 'Raw:Img',
  hideFromInsertMenu: true,
  image: 'https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4',
  inputs: [{
    name: 'image',
    bubble: true,
    type: 'file',
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true
  }],
  noWrap: true,
  static: true
};
let ImgComponent = /*#__PURE__*/(() => {
  class ImgComponent {
    setAttributes(el, value, changes) {
      if (!el) {
        return;
      }
      const target = typeof changes === "undefined" ? value : changes;
      Object.keys(target).forEach(key => {
        if (key.startsWith("on")) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace("on", "").toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key.toLowerCase(), target[key] ?? "");
        }
      });
    }
    constructor(renderer) {
      this.renderer = renderer;
      this.isEditing = isEditing;
      this.imgSrc = input();
      this.image = input();
      this.backgroundSize = input();
      this.backgroundPosition = input();
      this.altText = input();
      this.attributes = input();
      this.elRef0 = viewChild("elRef0");
      this._listenerFns = new Map();
      this.srcSetToUse = computed(() => {
        const url = this.imgSrc() || this.image();
        if (!url || typeof url !== "string") {
          return undefined;
        }
        // We can auto add srcset for cdn.builder.io images
        if (!url.match(/builder\.io/)) {
          return undefined;
        }
        return getSrcSet(url);
      });
      if (typeof window !== "undefined") {
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, {});
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngAfterViewInit() {
      this.setAttributes(this.elRef0()?.nativeElement, {});
      this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
    }
    ngOnDestroy() {
      for (const fn of this._listenerFns.values()) {
        fn();
      }
    }
    static {
      this.ɵfac = function ImgComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ImgComponent)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ImgComponent,
        selectors: [["img-component"]],
        viewQuery: function ImgComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.elRef0, _c12, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          imgSrc: [1, "imgSrc"],
          image: [1, "image"],
          backgroundSize: [1, "backgroundSize"],
          backgroundPosition: [1, "backgroundPosition"],
          altText: [1, "altText"],
          attributes: [1, "attributes"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 7,
        consts: [["elRef0", ""], ["loading", "lazy", 3, "ngStyle"]],
        template: function ImgComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "img", 1, 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(4, _c23, ctx.backgroundSize() || "cover", ctx.backgroundPosition() || "center"));
            i0.ɵɵattribute("alt", ctx.altText())("src", ctx.imgSrc() || ctx.image(), i0.ɵɵsanitizeUrl)("srcSet", ctx.srcSetToUse());
          }
        },
        dependencies: [CommonModule, i1.NgStyle],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return ImgComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const componentInfo = {
  name: 'Video',
  canHaveChildren: true,
  defaultStyles: {
    minHeight: '20px',
    minWidth: '20px'
  },
  image: 'https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-videocam-24px%20(1).svg?alt=media&token=49a84e4a-b20e-4977-a650-047f986874bb',
  inputs: [{
    name: 'video',
    type: 'file',
    allowedFileTypes: VIDEO_FILE_TYPES,
    bubble: true,
    defaultValue: 'https://cdn.builder.io/o/assets%2FYJIGb4i01jvw0SRdL5Bt%2Fd27731a526464deba0016216f5f9e570%2Fcompressed?apiKey=YJIGb4i01jvw0SRdL5Bt&token=d27731a526464deba0016216f5f9e570&alt=media&optimized=true',
    required: true
  }, {
    name: 'posterImage',
    type: 'file',
    allowedFileTypes: IMAGE_FILE_TYPES,
    helperText: 'Image to show before the video plays'
  }, {
    name: 'autoPlay',
    type: 'boolean',
    defaultValue: true
  }, {
    name: 'controls',
    type: 'boolean',
    defaultValue: false
  }, {
    name: 'muted',
    type: 'boolean',
    defaultValue: true
  }, {
    name: 'loop',
    type: 'boolean',
    defaultValue: true
  }, {
    name: 'playsInline',
    type: 'boolean',
    defaultValue: true
  }, {
    name: 'fit',
    type: 'text',
    defaultValue: 'cover',
    enum: ['contain', 'cover', 'fill', 'auto']
  }, {
    name: 'preload',
    type: 'text',
    defaultValue: 'metadata',
    enum: ['auto', 'metadata', 'none']
  }, {
    name: 'fitContent',
    type: 'boolean',
    helperText: 'When child blocks are provided, fit to them instead of using the aspect ratio',
    defaultValue: true,
    advanced: true
  }, {
    name: 'position',
    type: 'text',
    defaultValue: 'center',
    enum: ['center', 'top', 'left', 'right', 'bottom', 'top left', 'top right', 'bottom left', 'bottom right']
  }, {
    name: 'height',
    type: 'number',
    advanced: true
  }, {
    name: 'width',
    type: 'number',
    advanced: true
  }, {
    name: 'aspectRatio',
    type: 'number',
    advanced: true,
    defaultValue: 0.7004048582995948
  }, {
    name: 'lazyLoad',
    type: 'boolean',
    helperText: 'Load this video "lazily" - as in only when a user scrolls near the video. Recommended for optmized performance and bandwidth consumption',
    defaultValue: true,
    advanced: true
  }],
  shouldReceiveBuilderProps: {
    builderBlock: true
  }
};
let Video = /*#__PURE__*/(() => {
  class Video {
    setAttributes(el, value, changes) {
      if (!el) {
        return;
      }
      const target = typeof changes === "undefined" ? value : changes;
      Object.keys(target).forEach(key => {
        if (key.startsWith("on")) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace("on", "").toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key.toLowerCase(), target[key] ?? "");
        }
      });
    }
    constructor(renderer) {
      this.renderer = renderer;
      this.lazyLoad = input();
      this.autoPlay = input();
      this.muted = input();
      this.controls = input();
      this.loop = input();
      this.playsInline = input();
      this.preload = input();
      this.attributes = input();
      this.fit = input();
      this.position = input();
      this.aspectRatio = input();
      this.posterImage = input();
      this.video = input();
      this.fitContent = input();
      this.builderBlock = input();
      this.videoRef = viewChild("videoRef");
      this.elRef0 = viewChild("elRef0");
      this.elRef1 = viewChild("elRef1");
      this.lazyVideoObserver = signal(undefined);
      this._listenerFns = new Map();
      this.videoProps = computed(() => {
        return {
          ...(this.autoPlay() === true ? {
            autoPlay: true
          } : {}),
          ...(this.muted() === true ? {
            muted: true
          } : {}),
          ...(this.controls() === true ? {
            controls: true
          } : {}),
          ...(this.loop() === true ? {
            loop: true
          } : {}),
          ...(this.playsInline() === true ? {
            playsInline: true
          } : {})
        };
      });
      this.spreadProps = computed(() => {
        return {
          ...this.videoProps()
        };
      });
      this.objSpread_style_8mtss2 = computed(() => {
        return {
          width: "100%",
          height: "100%",
          ...this.attributes()?.style,
          objectFit: this.fit(),
          objectPosition: this.position(),
          // Hack to get object fit to work as expected and
          // not have the video overflow
          borderRadius: "1px",
          ...(this.aspectRatio() ? {
            position: "absolute"
          } : null)
        };
      });
      if (typeof window !== "undefined") {
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, this.spreadProps());
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          this.setAttributes(this.elRef1()?.nativeElement, this.lazyLoad() ? {
            "data-src": this.video()
          } : {
            src: this.video()
          });
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngAfterViewInit() {
      if (typeof window !== "undefined") {
        if (this.lazyLoad()) {
          const oberver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              const videoElement = entry.target;
              try {
                // Convert HTMLCollection to Array and filter for source elements
                Array.from(videoElement.children).filter(child => child instanceof HTMLElement && child.tagName === "SOURCE").forEach(source => {
                  const src = source.dataset.src;
                  if (src) {
                    source.src = src;
                  }
                });
                videoElement.load();
                oberver.unobserve(videoElement);
              } catch (error) {
                console.error("Error loading lazy video:", error);
              }
            });
          });
          if (this.videoRef()?.nativeElement) {
            oberver.observe(this.videoRef()?.nativeElement);
          }
          this.lazyVideoObserver.set(oberver);
        }
      }
      this.setAttributes(this.elRef0()?.nativeElement, this.spreadProps());
      this.setAttributes(this.elRef1()?.nativeElement, this.lazyLoad() ? {
        "data-src": this.video()
      } : {
        src: this.video()
      });
    }
    ngOnDestroy() {
      if (this.lazyVideoObserver()) {
        this.lazyVideoObserver().disconnect();
      }
    }
    static {
      this.ɵfac = function Video_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Video)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Video,
        selectors: [["builder-video"]],
        viewQuery: function Video_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.videoRef, _c24, 5);
            i0.ɵɵviewQuerySignal(ctx.elRef0, _c12, 5);
            i0.ɵɵviewQuerySignal(ctx.elRef1, _c25, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(3);
          }
        },
        inputs: {
          lazyLoad: [1, "lazyLoad"],
          autoPlay: [1, "autoPlay"],
          muted: [1, "muted"],
          controls: [1, "controls"],
          loop: [1, "loop"],
          playsInline: [1, "playsInline"],
          preload: [1, "preload"],
          attributes: [1, "attributes"],
          fit: [1, "fit"],
          position: [1, "position"],
          aspectRatio: [1, "aspectRatio"],
          posterImage: [1, "posterImage"],
          video: [1, "video"],
          fitContent: [1, "fitContent"],
          builderBlock: [1, "builderBlock"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c9,
        decls: 9,
        vars: 8,
        consts: [["elRef0", "", "videoRef", ""], ["elRef1", ""], [3, "ngStyle"], [1, "builder-video", 3, "ngStyle"], ["type", "video/mp4"]],
        template: function Video_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c9);
            i0.ɵɵelementStart(0, "div", 2)(1, "video", 3, 0);
            i0.ɵɵelement(4, "source", 4, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, Video_Conditional_6_Template, 1, 3, "div", 2)(7, Video_Conditional_7_Template, 2, 2, "div", 2)(8, Video_Conditional_8_Template, 2, 2, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_7_0;
            let tmp_8_0;
            let tmp_9_0;
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(7, _c26));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", ctx.objSpread_style_8mtss2());
            i0.ɵɵattribute("preload", ctx.lazyLoad() ? "none" : ctx.preload() || "metadata")("poster", ctx.posterImage(), i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(ctx.aspectRatio() && !(ctx.fitContent() && ((tmp_7_0 = ctx.builderBlock()) == null ? null : tmp_7_0.children == null ? null : tmp_7_0.children.length)) ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(((tmp_8_0 = ctx.builderBlock()) == null ? null : tmp_8_0.children == null ? null : tmp_8_0.children.length) && ctx.fitContent() ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(((tmp_9_0 = ctx.builderBlock()) == null ? null : tmp_9_0.children == null ? null : tmp_9_0.children.length) && !ctx.fitContent() ? 8 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgStyle],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return Video;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * These are in a separate file because React Native does not support them (yet).
 * Having them in a separate file allows us to override it to be empty in the
 * React Native SDK.
 */
const getExtraComponents = () => [{
  component: CustomCode,
  ...componentInfo$8
}, {
  component: Embed,
  ...componentInfo$7
}, ...(TARGET === 'rsc' ? [] : [{
  component: FormComponent,
  ...componentInfo$6
}, {
  component: FormInputComponent,
  ...componentInfo$5
}, {
  component: SubmitButton,
  ...componentInfo$3
}, {
  component: SelectComponent,
  ...componentInfo$4
}, {
  component: Textarea,
  ...componentInfo$2
}]), {
  component: ImgComponent,
  ...componentInfo$1
}, {
  component: Video,
  ...componentInfo
}];

/**
 * Returns a list of all registered components.
 * NOTE: This needs to be a function to work around ESM circular dependencies.
 */
const getDefaultRegisteredComponents = () => [{
  component: Button,
  ...componentInfo$i
}, {
  component: Columns,
  ...componentInfo$h
}, {
  component: FragmentComponent,
  ...componentInfo$g
}, {
  component: Image,
  ...componentInfo$f
}, {
  component: SectionComponent,
  ...componentInfo$d
}, {
  component: Slot,
  ...componentInfo$c
}, {
  component: Symbol,
  ...componentInfo$b
}, {
  component: Text,
  ...componentInfo$9
}, ...(SDKS_SUPPORTING_PERSONALIZATION.includes(TARGET) ? [{
  component: PersonalizationContainer,
  ...componentInfo$e
}] : []), ...(TARGET === 'rsc' ? [] : [{
  component: Tabs,
  ...componentInfo$a
}, {
  component: Accordion,
  ...componentInfo$j
}]), ...getExtraComponents()];
const createRegisterComponentMessage = info => ({
  type: 'builder.registerComponent',
  data: serializeIncludingFunctions(info)
});
// eslint-disable-next-line @typescript-eslint/ban-types
const serializeFn = fnValue => {
  const fnStr = fnValue.toString().trim();
  // we need to account for a few different fn syntaxes:
  // 1. `function name(args) => {code}`
  // 2. `name(args) => {code}`
  // 3. `(args) => {}`
  // 4. `args => {}`
  // 5. `async function(args) {code}`
  // 6. `async (args) => {}`
  // 7. `async args => {}`
  const isArrowWithoutParens = /^[a-zA-Z0-9_]+\s*=>/i.test(fnStr);
  const appendFunction = !fnStr.startsWith('function') && !fnStr.startsWith('async') && !fnStr.startsWith('(') && !isArrowWithoutParens;
  return `return (${appendFunction ? 'function ' : ''}${fnStr}).apply(this, arguments)`;
};
function serializeIncludingFunctions(info) {
  return JSON.parse(JSON.stringify(info, (key, value) => {
    if (typeof value === 'function') {
      return serializeFn(value);
    }
    return value;
  }));
}

/**
 * WARNING: This file contains functions that get stringified and inlined into the HTML at build-time.
 * They cannot import anything.
 */
/**
 * For more information on how this works,
 * see our [SSR A/B Test Docs](https://github.com/BuilderIO/builder/tree/main/packages/sdks/src/SSR_AB_TEST.md)
 */
/**
 * For more information on how this works,
 * see our [SSR A/B Test Docs](https://github.com/BuilderIO/builder/tree/main/packages/sdks/docs/SSR_AB_TEST.md)
 */
const UPDATE_COOKIES_AND_STYLES_SCRIPT = "function updateCookiesAndStyles(contentId, variants, isHydrationTarget, isAngularSDK) {\n  function getAndSetVariantId() {\n    function setCookie(name, value, days) {\n      let expires = '';\n      if (days) {\n        const date = new Date();\n        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);\n        expires = '; expires=' + date.toUTCString();\n      }\n      document.cookie = name + '=' + (value || '') + expires + '; path=/' + '; Secure; SameSite=None';\n    }\n    function getCookie(name) {\n      const nameEQ = name + '=';\n      const ca = document.cookie.split(';');\n      for (let i = 0; i < ca.length; i++) {\n        let c = ca[i];\n        while (c.charAt(0) === ' ') c = c.substring(1, c.length);\n        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);\n      }\n      return null;\n    }\n    const cookieName = `builder.tests.${contentId}`;\n    const variantInCookie = getCookie(cookieName);\n    const availableIDs = variants.map(vr => vr.id).concat(contentId);\n    if (variantInCookie && availableIDs.includes(variantInCookie)) {\n      return variantInCookie;\n    }\n    let n = 0;\n    const random = Math.random();\n    for (let i = 0; i < variants.length; i++) {\n      const variant = variants[i];\n      const testRatio = variant.testRatio;\n      n += testRatio;\n      if (random < n) {\n        setCookie(cookieName, variant.id);\n        return variant.id;\n      }\n    }\n    setCookie(cookieName, contentId);\n    return contentId;\n  }\n  const winningVariantId = getAndSetVariantId();\n  let styleEl = document.currentScript?.previousElementSibling;\n  if (isAngularSDK) {\n    styleEl = document.currentScript?.parentElement?.previousElementSibling?.querySelector('style');\n  }\n  if (isHydrationTarget) {\n    styleEl.remove();\n    const thisScriptEl = document.currentScript;\n    thisScriptEl?.remove();\n  } else {\n    const newStyleStr = variants.concat({\n      id: contentId\n    }).filter(variant => variant.id !== winningVariantId).map(value => {\n      return `.variant-${value.id} {  display: none; }\n        `;\n    }).join('');\n    styleEl.innerHTML = newStyleStr;\n  }\n}";
const UPDATE_VARIANT_VISIBILITY_SCRIPT = "function updateVariantVisibility(variantContentId, defaultContentId, isHydrationTarget) {\n  if (!navigator.cookieEnabled) {\n    return;\n  }\n  function getCookie(name) {\n    const nameEQ = name + '=';\n    const ca = document.cookie.split(';');\n    for (let i = 0; i < ca.length; i++) {\n      let c = ca[i];\n      while (c.charAt(0) === ' ') c = c.substring(1, c.length);\n      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);\n    }\n    return null;\n  }\n  const cookieName = `builder.tests.${defaultContentId}`;\n  const winningVariant = getCookie(cookieName);\n  const parentDiv = document.currentScript?.parentElement;\n  const isDefaultContent = variantContentId === defaultContentId;\n  const isWinningVariant = winningVariant === variantContentId;\n  if (isWinningVariant && !isDefaultContent) {\n    parentDiv?.removeAttribute('hidden');\n    parentDiv?.removeAttribute('aria-hidden');\n  } else if (!isWinningVariant && isDefaultContent) {\n    parentDiv?.setAttribute('hidden', 'true');\n    parentDiv?.setAttribute('aria-hidden', 'true');\n  }\n  if (isHydrationTarget) {\n    if (!isWinningVariant) {\n      parentDiv?.remove();\n    }\n    const thisScriptEl = document.currentScript;\n    thisScriptEl?.remove();\n  }\n  return;\n}";

/**
 * We hardcode explicit function names here, because the `.toString()` of a function can change depending on the bundler.
 * Some bundlers will minify the fn name, etc.
 *
 * So we hardcode the function names here, and then use those names in the script string to make sure the function names are consistent.
 */
const UPDATE_COOKIES_AND_STYLES_SCRIPT_NAME = 'builderIoAbTest';
const UPDATE_VARIANT_VISIBILITY_SCRIPT_FN_NAME = 'builderIoRenderContent';
const getVariants = content => Object.values(content?.variations || {}).map(variant => ({
  ...variant,
  testVariationId: variant.id,
  id: content?.id
}));
const checkShouldRenderVariants = ({
  canTrack,
  content
}) => {
  const hasVariants = getVariants(content).length > 0;
  /**
   * We cannot SSR in React-Native.
   */
  if (TARGET === 'reactNative') return false;
  if (!hasVariants) return false;
  if (!canTrack) return false;
  /**
   * For Vue and Svelte, we need to (initially) render the variants. This is to avoid hydration mismatch errors.
   *
   * Unlike React, Vue's hydration checks are shallow and do not check the attributes/contents of each element, so we
   * are able to modify the `hidden` HTML attributes and `display` CSS properties without causing a hydration mismatch error.
   *
   * NOTE: For Solid/Svelte: after the app is hydrated, we strip the variants from the DOM (on mount) to reduce the amount of HTML in the DOM.
   * This isn't necessary, just a nice to have.
   */
  if (TARGET === 'vue' || TARGET === 'svelte') return true;
  if (isBrowser()) return false;
  return true;
};
const getIsHydrationTarget = target => target === 'react' || target === 'reactNative';
const isAngularSDK = TARGET === 'angular';
const isHydrationTarget = getIsHydrationTarget(TARGET);
const getInitVariantsFnsScriptString = () => `
  window.${UPDATE_COOKIES_AND_STYLES_SCRIPT_NAME} = ${UPDATE_COOKIES_AND_STYLES_SCRIPT}
  window.${UPDATE_VARIANT_VISIBILITY_SCRIPT_FN_NAME} = ${UPDATE_VARIANT_VISIBILITY_SCRIPT}
  `;
const getUpdateCookieAndStylesScript = (variants, contentId) => `
  window.${UPDATE_COOKIES_AND_STYLES_SCRIPT_NAME}(
    "${contentId}",${JSON.stringify(variants)}, ${isHydrationTarget}, ${isAngularSDK}
  )`;
const getUpdateVariantVisibilityScript = ({
  contentId,
  variationId
}) => `window.${UPDATE_VARIANT_VISIBILITY_SCRIPT_FN_NAME}(
    "${variationId}", "${contentId}", ${isHydrationTarget}
  )`;
function getPreviewContent(_searchParams) {
  return undefined;
}
const SDK_VERSION = "0.21.1";
const getSdkHeaders = () => ({
  'X-Builder-SDK': TARGET,
  'X-Builder-SDK-GEN': '2',
  'X-Builder-SDK-Version': SDK_VERSION
});
function getGlobalThis() {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return globalThis;
}
function getFetch() {
  const globalFetch = getGlobalThis().fetch;
  if (typeof globalFetch === 'undefined') {
    console.warn(`Builder SDK could not find a global fetch function. Make sure you have a polyfill for fetch in your project. 
      For more information, read https://github.com/BuilderIO/this-package-uses-fetch`);
    throw new Error('Builder SDK could not find a global `fetch` function');
  }
  return globalFetch;
}
const fetch$1 = getFetch();

/**
 * Convert deep object to a flat object with dots
 *
 * { foo: { bar: 'baz' }} -> { 'foo.bar': 'baz' }
 */
function flatten(object, path = null, separator = '.') {
  return Object.keys(object).reduce((acc, key) => {
    const value = object[key];
    const newPath = [path, key].filter(Boolean).join(separator);
    const isObject = [typeof value === 'object', value !== null, !(Array.isArray(value) && value.length === 0)].every(Boolean);
    return isObject ? {
      ...acc,
      ...flatten(value, newPath, separator)
    } : {
      ...acc,
      [newPath]: value
    };
  }, {});
}
/**
 * Flatten a nested MongoDB query object into a flat object with dot-separated keys.
 * $ keys are not flattened and are left as is.
 *
 * { foo: { bar: { $gt: 5 }}} -> { 'foo.bar': { '$gt': 5 }}
 * { foo: {'bar.id': { $elemMatch: { 'baz.id': { $in: ['abc', 'bcd'] }}}}} -> { 'foo.bar.id': { '$elemMatch': { 'baz.id': { '$in': ['abc', 'bcd'] }}}}
 */
function flattenMongoQuery(obj, _current, _res = {}) {
  for (const key in obj) {
    const value = obj[key];
    const newKey = _current ? _current + '.' + key : key;
    if (value && typeof value === 'object' && !Array.isArray(value) && !Object.keys(value).find(item => item.startsWith('$'))) {
      flattenMongoQuery(value, newKey, _res);
    } else {
      _res[newKey] = value;
    }
  }
  return _res;
}
/**
 * Unflatten a flat object with dot-separated keys back into a nested object.
 *
 * { 'foo.bar': 'baz' } -> { foo: { bar: 'baz' }}
 */
function unflatten(obj) {
  const result = {};
  for (const key in obj) {
    const parts = key.split('.');
    let current = result;
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      if (i === parts.length - 1) {
        current[part] = obj[key];
      } else {
        current[part] = current[part] || {};
        current = current[part];
      }
    }
  }
  return result;
}
const DEFAULT_API_VERSION = 'v3';
const BUILDER_SEARCHPARAMS_PREFIX = 'builder.';
const BUILDER_OPTIONS_PREFIX = 'options.';
/**
 * Receives a `URLSearchParams` object or a regular query object, and returns the subset of query params that are
 * relevant to the Builder SDK.
 *
 * @returns
 */
const getBuilderSearchParams = _options => {
  if (!_options) {
    return {};
  }
  const options = normalizeSearchParams(_options);
  const newOptions = {};
  Object.keys(options).forEach(key => {
    if (key.startsWith(BUILDER_SEARCHPARAMS_PREFIX)) {
      const trimmedKey = key.replace(BUILDER_SEARCHPARAMS_PREFIX, '').replace(BUILDER_OPTIONS_PREFIX, '');
      newOptions[trimmedKey] = options[key];
    }
  });
  return newOptions;
};
const getBuilderSearchParamsFromWindow = () => {
  if (!isBrowser()) {
    return {};
  }
  const searchParams = new URLSearchParams(window.location.search);
  return getBuilderSearchParams(searchParams);
};
const isPositiveNumber = thing => typeof thing === 'number' && !isNaN(thing) && thing >= 0;
const generateContentUrl = options => {
  const {
    limit = 30,
    userAttributes,
    query,
    model,
    apiKey,
    enrich,
    locale,
    apiVersion = DEFAULT_API_VERSION,
    fields,
    omit,
    offset,
    cacheSeconds,
    staleCacheSeconds,
    sort,
    includeUnpublished,
    apiHost
  } = options;
  if (!apiKey) {
    throw new Error('Missing API key');
  }
  if (!['v3'].includes(apiVersion)) {
    throw new Error(`Invalid apiVersion: expected 'v3', received '${apiVersion}'`);
  }
  // if we are fetching an array of content, we disable noTraverse for perf reasons.
  const noTraverse = limit !== 1;
  const baseUrl = apiHost || 'https://cdn.builder.io';
  const url = new URL(`${baseUrl}/api/${apiVersion}/content/${model}`);
  url.searchParams.set('apiKey', apiKey);
  url.searchParams.set('limit', String(limit));
  url.searchParams.set('noTraverse', String(noTraverse));
  url.searchParams.set('includeRefs', String(true));
  const finalLocale = locale || userAttributes?.locale;
  let finalUserAttributes = userAttributes || {};
  if (finalLocale) {
    url.searchParams.set('locale', finalLocale);
    finalUserAttributes = {
      locale: finalLocale,
      ...finalUserAttributes
    };
  }
  if (enrich) url.searchParams.set('enrich', String(enrich));
  url.searchParams.set('omit', omit ?? 'meta.componentsUsed');
  if (fields) {
    url.searchParams.set('fields', fields);
  }
  if (Number.isFinite(offset) && offset > -1) {
    url.searchParams.set('offset', String(Math.floor(offset)));
  }
  if (typeof includeUnpublished === 'boolean') {
    url.searchParams.set('includeUnpublished', String(includeUnpublished));
  }
  if (cacheSeconds && isPositiveNumber(cacheSeconds)) {
    url.searchParams.set('cacheSeconds', String(cacheSeconds));
  }
  if (staleCacheSeconds && isPositiveNumber(staleCacheSeconds)) {
    url.searchParams.set('staleCacheSeconds', String(staleCacheSeconds));
  }
  if (sort) {
    const flattened = flatten({
      sort
    });
    for (const key in flattened) {
      url.searchParams.set(key, JSON.stringify(flattened[key]));
    }
  }
  // TODO: how to express 'offset' in the url - as direct queryparam or as flattened in options[key] ?
  const queryOptions = {
    ...getBuilderSearchParamsFromWindow(),
    ...normalizeSearchParams(options.options || {})
  };
  finalUserAttributes = {
    ...finalUserAttributes,
    ...getUserAttributesAsJSON(queryOptions)
  };
  const flattened = flatten(queryOptions);
  for (const key in flattened) {
    url.searchParams.set(key, String(flattened[key]));
  }
  if (Object.keys(finalUserAttributes).length > 0) {
    url.searchParams.set('userAttributes', JSON.stringify(finalUserAttributes));
  }
  if (query) {
    const flattened = flattenMongoQuery({
      query
    });
    for (const key in flattened) {
      url.searchParams.set(key, JSON.stringify(flattened[key]));
    }
  }
  return url;
};
const getUserAttributesFromQueryOptions = queryOptions => {
  const newUserAttributes = {};
  for (const key in queryOptions) {
    if (key.startsWith('userAttributes.')) {
      newUserAttributes[key] = queryOptions[key];
      delete queryOptions[key];
    }
  }
  return newUserAttributes;
};
const getUserAttributesAsJSON = queryOptions => {
  if (isBrowser() && queryOptions['preview'] === 'BUILDER_STUDIO') {
    queryOptions['userAttributes.urlPath'] = window.location.pathname;
    queryOptions['userAttributes.host'] = window.location.host;
    const queryOptionsForUserAttributes = getUserAttributesFromQueryOptions(queryOptions);
    const {
      userAttributes
    } = unflatten(queryOptionsForUserAttributes);
    return userAttributes;
  }
  return {};
};
const checkContentHasResults = content => 'results' in content;
/**
 * Returns the first content entry that matches the given options.
 */
async function fetchOneEntry(options) {
  const allContent = await fetchEntries({
    ...options,
    limit: 1
  });
  if (allContent) {
    return allContent[0] || null;
  }
  return null;
}
const _fetchContent = async options => {
  const url = generateContentUrl(options);
  const _fetch = options.fetch ?? fetch$1;
  const fetchOptions = {
    ...options.fetchOptions,
    headers: {
      ...options.fetchOptions?.headers,
      ...getSdkHeaders()
    }
  };
  const res = await _fetch(url.href, fetchOptions);
  const content = await res.json();
  return content;
};
/**
 * @internal Exported only for testing purposes. Do not use.
 */
const _processContentResult = async (options, content, url = generateContentUrl(options)) => {
  const canTrack = getDefaultCanTrack(options.canTrack);
  const isPreviewing = url.search.includes(`preview=`);
  if (TARGET === 'rsc' && isPreviewing) {
    const newResults = [];
    for (const item of content.results) {
      const previewContent = getPreviewContent(url.searchParams);
      newResults.push(previewContent || item);
    }
    content.results = newResults;
  }
  if (!canTrack) return content.results;
  if (!(isBrowser() || TARGET === 'reactNative')) return content.results;
  /**
   * For client-side navigations, it is ideal to handle AB testing at this point instead of using our
   * complex multi-rendering variants approach, which is only needed for SSR'd content.
   *
   * This is also where react-native would handle AB testing.
   */
  try {
    const newResults = [];
    for (const item of content.results) {
      newResults.push(await handleABTesting({
        item,
        canTrack
      }));
    }
    content.results = newResults;
  } catch (e) {
    logger.error('Could not process A/B tests. ', e);
  }
  return content.results;
};
/**
 * Returns a paginated array of entries that match the given options.
 */
async function fetchEntries(options) {
  const url = generateContentUrl(options);
  const content = await _fetchContent(options);
  if (!checkContentHasResults(content)) {
    logger.error('Error fetching data. ', {
      url,
      content,
      options
    });
    throw content;
  }
  return _processContentResult(options, content);
}

/**
 * @credit https://stackoverflow.com/a/2117523
 */
function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0,
      v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}
/**
 * Slightly cleaner and smaller UUIDs
 */
function uuid() {
  return uuidv4().replace(/-/g, '');
}
const SESSION_LOCAL_STORAGE_KEY = 'builderSessionId';
const getSessionId = async ({
  canTrack
}) => {
  if (!canTrack) {
    return undefined;
  }
  const sessionId = await getCookie({
    name: SESSION_LOCAL_STORAGE_KEY,
    canTrack
  });
  if (checkIsDefined(sessionId)) {
    return sessionId;
  } else {
    const newSessionId = createSessionId();
    setSessionId({
      id: newSessionId,
      canTrack
    });
    return newSessionId;
  }
};
const createSessionId = () => uuid();
const setSessionId = ({
  id,
  canTrack
}) => setCookie({
  name: SESSION_LOCAL_STORAGE_KEY,
  value: id,
  canTrack
});
const getLocalStorage = () => isBrowser() && typeof localStorage !== 'undefined' ? localStorage : undefined;
const getLocalStorageItem = ({
  key,
  canTrack
}) => {
  try {
    if (canTrack) {
      return getLocalStorage()?.getItem(key);
    }
    return undefined;
  } catch (err) {
    console.debug('[LocalStorage] GET error: ', err);
    return undefined;
  }
};
const setLocalStorageItem = ({
  key,
  canTrack,
  value
}) => {
  try {
    if (canTrack) {
      getLocalStorage()?.setItem(key, value);
    }
  } catch (err) {
    console.debug('[LocalStorage] SET error: ', err);
  }
};
const VISITOR_LOCAL_STORAGE_KEY = 'builderVisitorId';
const getVisitorId = ({
  canTrack
}) => {
  if (!canTrack) {
    return undefined;
  }
  const visitorId = getLocalStorageItem({
    key: VISITOR_LOCAL_STORAGE_KEY,
    canTrack
  });
  if (checkIsDefined(visitorId)) {
    return visitorId;
  } else {
    const newVisitorId = createVisitorId();
    setVisitorId({
      id: newVisitorId,
      canTrack
    });
    return newVisitorId;
  }
};
const createVisitorId = () => uuid();
const setVisitorId = ({
  id,
  canTrack
}) => setLocalStorageItem({
  key: VISITOR_LOCAL_STORAGE_KEY,
  value: id,
  canTrack
});
const getTrackingEventData = async ({
  canTrack
}) => {
  if (!canTrack) {
    return {
      visitorId: undefined,
      sessionId: undefined
    };
  }
  const sessionId = await getSessionId({
    canTrack
  });
  const visitorId = getVisitorId({
    canTrack
  });
  return {
    sessionId,
    visitorId
  };
};
const createEvent = async ({
  type: eventType,
  canTrack,
  apiKey,
  metadata,
  ...properties
}) => ({
  type: eventType,
  data: {
    ...properties,
    metadata: {
      url: location.href,
      ...metadata
    },
    ...(await getTrackingEventData({
      canTrack
    })),
    userAttributes: getUserAttributes(),
    ownerId: apiKey
  }
});
async function _track({
  apiHost,
  ...eventProps
}) {
  if (!eventProps.apiKey) {
    logger.error('Missing API key for track call. Please provide your API key.');
    return;
  }
  if (!eventProps.canTrack) {
    return;
  }
  if (isEditing()) {
    return;
  }
  if (!(isBrowser() || TARGET === 'reactNative')) {
    return;
  }
  const baseUrl = apiHost || 'https://cdn.builder.io';
  const url = `${baseUrl}/api/v1/track`;
  logFetch(url);
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      events: [await createEvent(eventProps)]
    }),
    headers: {
      'content-type': 'application/json',
      ...getSdkHeaders()
    },
    mode: 'cors'
  }).catch(err => {
    console.error('Failed to track: ', err);
  });
}
const track = args => _track({
  ...args,
  canTrack: true
});
function round(num) {
  return Math.round(num * 1000) / 1000;
}
const findParentElement = (target, callback, checkElement = true) => {
  if (!(target instanceof HTMLElement)) {
    return null;
  }
  let parent = checkElement ? target : target.parentElement;
  do {
    if (!parent) {
      return null;
    }
    const matches = callback(parent);
    if (matches) {
      return parent;
    }
  } while (parent = parent.parentElement);
  return null;
};
const findBuilderParent = target => findParentElement(target, el => {
  const id = el.getAttribute('builder-id') || el.id;
  return Boolean(id?.indexOf('builder-') === 0);
});
const computeOffset = ({
  event,
  target
}) => {
  const targetRect = target.getBoundingClientRect();
  const xOffset = event.clientX - targetRect.left;
  const yOffset = event.clientY - targetRect.top;
  const xRatio = round(xOffset / targetRect.width);
  const yRatio = round(yOffset / targetRect.height);
  return {
    x: xRatio,
    y: yRatio
  };
};
const getInteractionPropertiesForEvent = event => {
  const target = event.target;
  const targetBuilderElement = target && findBuilderParent(target);
  const builderId = targetBuilderElement?.getAttribute('builder-id') || targetBuilderElement?.id;
  return {
    targetBuilderElement: builderId || undefined,
    metadata: {
      targetOffset: target ? computeOffset({
        event,
        target
      }) : undefined,
      builderTargetOffset: targetBuilderElement ? computeOffset({
        event,
        target: targetBuilderElement
      }) : undefined,
      builderElementIndex: targetBuilderElement && builderId ? [].slice.call(document.getElementsByClassName(builderId)).indexOf(targetBuilderElement) : undefined
    }
  };
};
const DEFAULT_TRUSTED_HOSTS = ['*.beta.builder.io', 'beta.builder.io', 'builder.io', 'localhost', 'qa.builder.io'];
function isFromTrustedHost(trustedHosts, e) {
  if (!e.origin.startsWith('http') && !e.origin.startsWith('https')) {
    return false;
  }
  const url = new URL(e.origin),
    hostname = url.hostname;
  return (trustedHosts || DEFAULT_TRUSTED_HOSTS).findIndex(trustedHost => trustedHost.startsWith('*.') ? hostname.endsWith(trustedHost.slice(1)) : trustedHost === hostname) > -1;
}
let isSetupForEditing = false;
const setupBrowserForEditing = options => {
  if (isSetupForEditing) {
    return;
  }
  isSetupForEditing = true;
  if (isBrowser()) {
    window.parent?.postMessage({
      type: 'builder.sdkInfo',
      data: {
        target: TARGET,
        version: SDK_VERSION,
        supportsPatchUpdates: false,
        // Supports builder-model="..." attribute which is needed to
        // scope our '+ add block' button styling
        supportsAddBlockScoping: true,
        supportsCustomBreakpoints: true,
        modelName: options.modelName,
        apiKey: options.apiKey,
        supportsXSmallBreakpoint: TARGET === 'reactNative' ? false : true,
        blockLevelPersonalization: true
      }
    }, '*');
    window.parent?.postMessage({
      type: 'builder.updateContent',
      data: {
        options
      }
    }, '*');
    window.addEventListener('message', event => {
      if (!isFromTrustedHost(options.trustedHosts, event)) {
        return;
      }
      const {
        data
      } = event;
      if (!data?.type) {
        return;
      }
      switch (data.type) {
        case 'builder.evaluate':
          {
            const text = data.data.text;
            const args = data.data.arguments || [];
            const id = data.data.id;
            // tslint:disable-next-line:no-function-constructor-with-string-args
            const fn = new Function(text);
            let result;
            let error = null;
            try {
              // eslint-disable-next-line prefer-spread
              result = fn.apply(null, args);
            } catch (err) {
              error = err;
            }
            if (error) {
              window.parent?.postMessage({
                type: 'builder.evaluateError',
                data: {
                  id,
                  error: error.message
                }
              }, '*');
            } else {
              if (result && typeof result.then === 'function') {
                result.then(finalResult => {
                  window.parent?.postMessage({
                    type: 'builder.evaluateResult',
                    data: {
                      id,
                      result: finalResult
                    }
                  }, '*');
                }).catch(console.error);
              } else {
                window.parent?.postMessage({
                  type: 'builder.evaluateResult',
                  data: {
                    result,
                    id
                  }
                }, '*');
              }
            }
            break;
          }
      }
    });
  }
};
const createEditorListener = ({
  model,
  trustedHosts,
  callbacks
}) => {
  return event => {
    if (!isFromTrustedHost(trustedHosts, event)) {
      return;
    }
    const {
      data
    } = event;
    if (data) {
      switch (data.type) {
        case 'builder.configureSdk':
          {
            callbacks.configureSdk(data.data);
            break;
          }
        case 'builder.triggerAnimation':
          {
            callbacks.animation(data.data);
            break;
          }
        case 'builder.resetState':
          {
            const messageContent = data.data;
            const modelName = messageContent.model;
            const newState = messageContent?.state;
            if (modelName === model && newState) {
              callbacks.stateUpdate(newState);
            }
            break;
          }
        case 'builder.contentUpdate':
          {
            const messageContent = data.data;
            const key = messageContent.key || messageContent.alias || messageContent.entry || messageContent.modelName;
            const contentData = messageContent.data;
            if (key === model) {
              callbacks.contentUpdate(contentData);
            }
            break;
          }
      }
    }
  };
};
/**
 * Subscribes to the Builder editor and listens to `content` updates of a certain `model`.
 * Sends the updated `content` to the `callback` function.
 */
const subscribeToEditor = ({
  model,
  apiKey,
  callback,
  trustedHosts
}) => {
  if (!isBrowser) {
    logger.warn('`subscribeToEditor` only works in the browser. It currently seems to be running on the server.');
    return () => {};
  }
  setupBrowserForEditing({
    modelName: model,
    apiKey
  });
  const listener = createEditorListener({
    callbacks: {
      contentUpdate: callback,
      animation: () => {},
      configureSdk: () => {},
      stateUpdate: () => {}
    },
    model,
    trustedHosts
  });
  window.addEventListener('message', listener);
  return () => {
    window.removeEventListener('message', listener);
  };
};

/**
 * SDKS that use the elementRef approach to enable visual editing.
 * We don't need to render the div for other SDKs as they attach event listeners to the window.
 */
const SDKS_USING_ELEMENT_REF_APPROACH = ['svelte', 'qwik', 'vue'];
/**
 * We need to attach this div only when content exists or isPreviewing/isEditing even when content is null,
 * as we need to set the elementRef and allow previewing and visual editing
 */
const needsElementRefDivForEditing = () => {
  return SDKS_USING_ELEMENT_REF_APPROACH.includes(TARGET) && (isEditing() || isPreviewing());
};
const getCssFromFont = font => {
  // TODO: compute what font sizes are used and only load those.......
  const family = font.family + (font.kind && !font.kind.includes('#') ? ', ' + font.kind : '');
  const name = family.split(',')[0];
  const url = font.fileUrl ?? font?.files?.regular;
  let str = '';
  if (url && family && name) {
    str += `
@font-face {
font-family: "${family}";
src: local("${name}"), url('${url}') format('woff2');
font-display: fallback;
font-weight: 400;
}
      `.trim();
  }
  if (font.files) {
    for (const weight in font.files) {
      const isNumber = String(Number(weight)) === weight;
      if (!isNumber) {
        continue;
      }
      // TODO: maybe limit number loaded
      const weightUrl = font.files[weight];
      if (weightUrl && weightUrl !== url) {
        str += `
@font-face {
font-family: "${family}";
src: url('${weightUrl}') format('woff2');
font-display: fallback;
font-weight: ${weight};
}
        `.trim();
      }
    }
  }
  return str;
};
const getFontCss = ({
  customFonts
}) => {
  // TODO: flag for this
  // if (!this.builder.allowCustomFonts) {
  //   return '';
  // }
  // TODO: separate internal data from external
  return customFonts?.map(font => getCssFromFont(font))?.join(' ') || '';
};
const getCss = ({
  cssCode,
  contentId
}) => {
  if (!cssCode) {
    return '';
  }
  if (!contentId) {
    return cssCode;
  }
  // Allow using `&` in custom CSS code like @emotion
  // E.g. `& .foobar { ... }` to scope CSS
  // TODO: handle if '&' is within a string like `content: "&"`
  return cssCode?.replace(/&/g, `div[builder-content-id="${contentId}"]`) || '';
};
const DEFAULT_STYLES = `
.builder-button {
  all: unset;
}

.builder-text > p:first-of-type, .builder-text > .builder-paragraph:first-of-type {
  margin: 0;
}
.builder-text > p, .builder-text > .builder-paragraph {
  color: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  font-weight: inherit;
  font-size: inherit;
  text-align: inherit;
  font-family: inherit;
}
`;
const getDefaultStyles = isNested => {
  return !isNested ? DEFAULT_STYLES : '';
};
const getWrapperClassName = variationId => {
  return `variant-${variationId}`;
};
let EnableEditor = /*#__PURE__*/(() => {
  class EnableEditor {
    mergeNewRootState(newData) {
      const combinedState = {
        ...this.builderContextSignal().rootState,
        ...newData
      };
      if (this.builderContextSignal().rootSetState) {
        this.builderContextSignal().rootSetState?.(combinedState);
      } else {
        this.builderContextSignal().rootState = combinedState;
      }
    }
    mergeNewContent(newContent) {
      const newContentValue = {
        ...this.builderContextSignal().content,
        ...newContent,
        data: {
          ...this.builderContextSignal().content?.data,
          ...newContent?.data
        },
        meta: {
          ...this.builderContextSignal().content?.meta,
          ...newContent?.meta,
          breakpoints: newContent?.meta?.breakpoints || this.builderContextSignal().content?.meta?.breakpoints
        }
      };
      this.builderContextSignal().content = newContentValue;
    }
    processMessage(event) {
      return createEditorListener({
        model: this.model(),
        trustedHosts: this.trustedHosts(),
        callbacks: {
          configureSdk: messageContent => {
            const {
              breakpoints,
              contentId
            } = messageContent;
            if (!contentId || contentId !== this.builderContextSignal().content?.id) {
              return;
            }
            if (breakpoints) {
              this.mergeNewContent({
                meta: {
                  breakpoints
                }
              });
            }
          },
          animation: animation => {
            triggerAnimation(animation);
          },
          contentUpdate: newContent => {
            this.mergeNewContent(newContent);
          },
          stateUpdate: newState => {
            this.mergeNewRootState(newState);
          }
        }
      })(event);
    }
    onClick(event) {
      if (this.builderContextSignal().content) {
        const variationId = this.builderContextSignal().content?.testVariationId;
        const contentId = this.builderContextSignal().content?.id;
        _track({
          apiHost: this.apiHost(),
          type: "click",
          canTrack: getDefaultCanTrack(this.canTrack()),
          contentId,
          apiKey: this.apiKey(),
          variationId: variationId !== contentId ? variationId : undefined,
          ...getInteractionPropertiesForEvent(event),
          unique: !this.clicked()
        });
      }
      if (!this.clicked()) {
        this.clicked.set(true);
      }
    }
    runHttpRequests() {
      const requests = this.builderContextSignal().content?.data?.httpRequests ?? {};
      Object.entries(requests).forEach(([key, httpRequest]) => {
        if (!httpRequest) return;
        const isCoreRequest = typeof httpRequest === "object" && httpRequest["@type"] === "@builder.io/core:Request";
        // request already in progress
        if (this.httpReqsPending()[key]) return;
        // request already completed, and not in edit mode
        if (this.httpReqsData()[key] && !isEditing()) return;
        const url = isCoreRequest ? httpRequest.request.url : httpRequest;
        this.httpReqsPending.update(httpReqsPending => {
          httpReqsPending[key] = true;
          return httpReqsPending;
        });
        const evaluatedUrl = url.replace(/{{([^}]+)}}/g, (_match, group) => String(evaluate({
          code: group,
          context: this.context() || {},
          localState: undefined,
          rootState: this.builderContextSignal().rootState,
          rootSetState: this.builderContextSignal().rootSetState
        })));
        const fetchRequestObj = isCoreRequest ? {
          url: evaluatedUrl,
          method: httpRequest.request.method,
          headers: httpRequest.request.headers,
          body: httpRequest.request.body
        } : {
          url: evaluatedUrl,
          method: "GET"
        };
        logFetch(JSON.stringify(fetchRequestObj));
        const fetchOptions = {
          method: fetchRequestObj.method,
          headers: fetchRequestObj.headers,
          body: fetchRequestObj.body
        };
        if (fetchRequestObj.method === "GET") {
          delete fetchOptions.body;
        }
        fetch(fetchRequestObj.url, fetchOptions).then(response => response.json()).then(json => {
          this.mergeNewRootState({
            [key]: json
          });
          this.httpReqsData.update(httpReqsData => {
            httpReqsData[key] = true;
            return httpReqsData;
          });
        }).catch(err => {
          console.error("error fetching dynamic data", JSON.stringify(httpRequest), err);
        }).finally(() => {
          this.httpReqsPending.update(httpReqsPending => {
            httpReqsPending[key] = false;
            return httpReqsPending;
          });
        });
      });
    }
    emitStateUpdate() {
      if (isEditing()) {
        window.dispatchEvent(new CustomEvent("builder:component:stateChange", {
          detail: {
            state: fastClone(this.builderContextSignal().rootState),
            ref: {
              name: this.model()
            }
          }
        }));
      }
    }
    constructor(viewContainer) {
      this.viewContainer = viewContainer;
      this.needsElementRefDivForEditing = needsElementRefDivForEditing;
      this.getWrapperClassName = getWrapperClassName;
      this.myContent = signal([]);
      this.contentwrapperTemplateRef = viewChild("contentwrapperTemplate");
      this.isNestedRender = input();
      this.locale = input();
      this.enrich = input();
      this.trustedHosts = input();
      this.model = input();
      this.apiKey = input();
      this.builderContextSignal = input();
      this.canTrack = input();
      this.apiHost = input();
      this.content = input();
      this.context = input();
      this.data = input();
      this.showContent = input();
      this.contentWrapper = input();
      this.contentWrapperProps = input();
      this.elementRef = viewChild("elementRef");
      this.hasExecuted = signal(false);
      this.prevData = signal(null);
      this.prevLocale = signal("");
      this.ContentWrapper = signal(undefined);
      this.httpReqsData = signal({});
      this.httpReqsPending = signal({});
      this.clicked = signal(false);
      this.showContentProps = computed(() => {
        return this.showContent() ? {} : {
          hidden: true,
          "aria-hidden": true
        };
      });
      this.dynamicProps_sb7chb = computed(() => {
        return {
          ref: this.elementRef(),
          onClick: this.onClick.bind(this),
          "builder-content-id": this.builderContextSignal().content?.id,
          "builder-model": this.model(),
          className: getWrapperClassName(this.content()?.testVariationId || this.content()?.id),
          style: {
            display: !this.builderContextSignal().content && needsElementRefDivForEditing() ? "none" : undefined
          },
          ...this.showContentProps(),
          ...this.contentWrapperProps()
        };
      });
      if (typeof window !== "undefined") {
        effect(() => {
          // --- Mitosis: Workaround to make sure the effect() is triggered ---
          this.content();
          // ---
          if (this.content()) {
            this.mergeNewContent(this.content());
          }
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          this.emitStateUpdate();
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          // --- Mitosis: Workaround to make sure the effect() is triggered ---
          this.data();
          // ---
          if (this.data()) {
            if (this.prevData() === this.data()) {
              return;
            }
            this.mergeNewRootState(this.data());
            this.prevData.set(this.data());
          }
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          // --- Mitosis: Workaround to make sure the effect() is triggered ---
          this.locale();
          // ---
          if (this.locale()) {
            if (this.prevLocale() === this.locale()) {
              return;
            }
            this.mergeNewRootState({
              locale: this.locale()
            });
            this.prevLocale.set(this.locale());
          }
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngOnInit() {
      this.ContentWrapper.set(this.contentWrapper() || DynamicDiv);
      this.runHttpRequests();
      this.emitStateUpdate();
    }
    _updateView() {
      this.myContent.set([this.viewContainer.createEmbeddedView(this.contentwrapperTemplateRef()).rootNodes]);
    }
    ngAfterViewInit() {
      if (typeof window !== "undefined") {
        if (isBrowser()) {
          if (isEditing() && !this.isNestedRender()) {
            window.addEventListener("message", this.processMessage.bind(this));
            setupBrowserForEditing({
              ...(this.locale() ? {
                locale: this.locale()
              } : {}),
              ...(this.enrich() ? {
                enrich: this.enrich()
              } : {}),
              ...(this.trustedHosts() ? {
                trustedHosts: this.trustedHosts()
              } : {}),
              modelName: this.model() ?? "",
              apiKey: this.apiKey()
            });
            Object.values(this.builderContextSignal().componentInfos).forEach(registeredComponent => {
              if (!registeredComponent.models?.length || registeredComponent.models.includes(this.model())) {
                const message = createRegisterComponentMessage(registeredComponent);
                window.parent?.postMessage(message, "*");
              }
            });
            window.addEventListener("builder:component:stateChangeListenerActivated", this.emitStateUpdate.bind(this));
          }
          const shouldTrackImpression = this.builderContextSignal().content && getDefaultCanTrack(this.canTrack());
          const winningVariantId = getCookieSync({
            name: `builder.tests.${this.builderContextSignal().content?.id}`,
            canTrack: true
          });
          const variationId = this.builderContextSignal().content?.testVariationId;
          if (shouldTrackImpression && variationId === winningVariantId) {
            const contentId = this.builderContextSignal().content?.id;
            const apiKeyProp = this.apiKey();
            _track({
              apiHost: this.apiHost(),
              type: "impression",
              canTrack: true,
              contentId,
              apiKey: apiKeyProp,
              variationId: winningVariantId !== contentId ? winningVariantId : undefined
            });
          }
          /**
           * Override normal content in preview mode.
           * We ignore this when editing, since the edited content is already being sent from the editor via post messages.
           */
          if (isPreviewing() && !isEditing()) {
            const searchParams = new URL(location.href).searchParams;
            const searchParamPreviewModel = searchParams.get("builder.preview");
            const searchParamPreviewId = searchParams.get(`builder.overrides.${searchParamPreviewModel}`);
            const previewApiKey = searchParams.get("apiKey") || searchParams.get("builder.space");
            /**
             * Make sure that:
             * - the preview model name is the same as the one we're rendering, since there can be multiple models rendered
             *  at the same time, e.g. header/page/footer.
             * - the API key is the same, since we don't want to preview content from other organizations.
             * - if there is content, that the preview ID is the same as that of the one we receive.
             *
             * TO-DO: should we only update the state when there is a change?
             **/
            if (searchParamPreviewModel === "BUILDER_STUDIO" || searchParamPreviewModel === this.model() && previewApiKey === this.apiKey() && (!this.content() || searchParamPreviewId === this.content().id)) {
              fetchOneEntry({
                model: this.model(),
                apiKey: this.apiKey(),
                apiVersion: this.builderContextSignal().apiVersion,
                ...(searchParamPreviewModel === "BUILDER_STUDIO" && this.context()?.symbolId ? {
                  query: {
                    id: this.context().symbolId
                  }
                } : {})
              }).then(content => {
                if (content) {
                  this.mergeNewContent(content);
                }
              });
            }
          }
        }
      }
    }
    ngAfterContentInit() {
      this._updateView();
    }
    ngOnDestroy() {
      if (isBrowser()) {
        window.removeEventListener("message", this.processMessage.bind(this));
        window.removeEventListener("builder:component:stateChangeListenerActivated", this.emitStateUpdate.bind(this));
      }
    }
    static {
      this.ɵfac = function EnableEditor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EnableEditor)(i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EnableEditor,
        selectors: [["enable-editor"]],
        viewQuery: function EnableEditor_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.contentwrapperTemplateRef, _c30, 5);
            i0.ɵɵviewQuerySignal(ctx.elementRef, _c20, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(2);
          }
        },
        inputs: {
          isNestedRender: [1, "isNestedRender"],
          locale: [1, "locale"],
          enrich: [1, "enrich"],
          trustedHosts: [1, "trustedHosts"],
          model: [1, "model"],
          apiKey: [1, "apiKey"],
          builderContextSignal: [1, "builderContextSignal"],
          canTrack: [1, "canTrack"],
          apiHost: [1, "apiHost"],
          content: [1, "content"],
          context: [1, "context"],
          data: [1, "data"],
          showContent: [1, "showContent"],
          contentWrapper: [1, "contentWrapper"],
          contentWrapperProps: [1, "contentWrapperProps"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 1,
        consts: [["contentwrapperTemplate", ""], [4, "ngComponentOutlet", "ngComponentOutletInputs", "ngComponentOutletContent"]],
        template: function EnableEditor_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, EnableEditor_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, EnableEditor_Conditional_2_Template, 1, 3, "ng-container");
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.builderContextSignal().content || ctx.needsElementRefDivForEditing() ? 2 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgComponentOutlet],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return EnableEditor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContentStyles = /*#__PURE__*/(() => {
  class ContentStyles {
    constructor() {
      this.cssCode = input();
      this.contentId = input();
      this.customFonts = input();
      this.isNestedRender = input();
      this.nonce = input();
      this.injectedStyles = signal(undefined);
    }
    ngOnInit() {
      this.injectedStyles.set(`
${getCss({
        cssCode: this.cssCode(),
        contentId: this.contentId()
      })}
${getFontCss({
        customFonts: this.customFonts()
      })}
${getDefaultStyles(this.isNestedRender())}
`.trim());
    }
    static {
      this.ɵfac = function ContentStyles_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContentStyles)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ContentStyles,
        selectors: [["content-styles"]],
        inputs: {
          cssCode: [1, "cssCode"],
          contentId: [1, "contentId"],
          customFonts: [1, "customFonts"],
          isNestedRender: [1, "isNestedRender"],
          nonce: [1, "nonce"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 2,
        consts: [["id", "builderio-content", 3, "styles", "nonce"]],
        template: function ContentStyles_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "inlined-styles", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("styles", ctx.injectedStyles())("nonce", ctx.nonce());
          }
        },
        dependencies: [CommonModule, InlinedStyles],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return ContentStyles;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const getRootStateInitialValue = ({
  content,
  data,
  locale
}) => {
  const defaultValues = {};
  const initialState = content?.data?.state || {};
  // set default values for content state inputs
  content?.data?.inputs?.forEach(input => {
    if (input.name && input.defaultValue !== undefined) {
      defaultValues[input.name] = input.defaultValue;
    }
  });
  return {
    ...defaultValues,
    ...initialState,
    ...data,
    ...(locale ? {
      locale
    } : {})
  };
};
const getContentInitialValue = ({
  content,
  data
}) => {
  return !content ? undefined : {
    ...content,
    data: {
      ...content?.data,
      ...data
    },
    meta: content?.meta
  };
};
let ContentComponent = /*#__PURE__*/(() => {
  class ContentComponent {
    contentSetState(newRootState) {
      this.builderContextSignal.update(builderContextSignal => ({
        ...builderContextSignal,
        rootState: newRootState
      }));
    }
    constructor() {
      this.TARGET = TARGET;
      this.apiKey = input();
      this.context = input();
      this.content = input();
      this.customComponents = input();
      this.data = input();
      this.locale = input();
      this.canTrack = input();
      this.apiVersion = input();
      this.blocksWrapper = input();
      this.blocksWrapperProps = input();
      this.nonce = input();
      this.model = input();
      this.apiHost = input();
      this.enrich = input();
      this.showContent = input();
      this.contentWrapper = input();
      this.contentWrapperProps = input();
      this.trustedHosts = input();
      this.isNestedRender = input();
      this.isSsrAbTest = input();
      this.linkComponent = input();
      this.scriptStr = signal(undefined);
      this.registeredComponents = signal(undefined);
      this.builderContextSignal = signal(undefined);
    }
    ngOnInit() {
      this.builderContextSignal.set({
        content: getContentInitialValue({
          content: this.content(),
          data: this.data()
        }),
        localState: undefined,
        rootState: getRootStateInitialValue({
          content: this.content(),
          data: this.data(),
          locale: this.locale()
        }),
        rootSetState: this.contentSetState.bind(this),
        context: this.context() || {},
        canTrack: this.canTrack(),
        apiKey: this.apiKey(),
        apiVersion: this.apiVersion(),
        componentInfos: [...getDefaultRegisteredComponents(), ...(this.customComponents() || [])].reduce((acc, {
          component: _,
          ...info
        }) => ({
          ...acc,
          [info.name]: serializeIncludingFunctions(info)
        }), {}),
        inheritedStyles: {},
        BlocksWrapper: this.blocksWrapper() || DynamicDiv,
        BlocksWrapperProps: this.blocksWrapperProps() || {},
        nonce: this.nonce() || "",
        model: this.model()
      });
      this.registeredComponents.set([...getDefaultRegisteredComponents(), ...(this.customComponents() || [])].reduce((acc, {
        component,
        ...info
      }) => ({
        ...acc,
        [info.name]: {
          component: component,
          ...serializeIncludingFunctions(info)
        }
      }), {}));
      this.scriptStr.set(getUpdateVariantVisibilityScript({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        variationId: this.content()?.testVariationId,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        contentId: this.content()?.id
      }));
      if (!this.apiKey()) {
        logger.error("No API key provided to `Content` component. This can cause issues. Please provide an API key using the `apiKey` prop.");
      }
      // run any dynamic JS code attached to content
      const jsCode = this.builderContextSignal().content?.data?.jsCode;
      if (jsCode) {
        evaluate({
          code: jsCode,
          context: this.context() || {},
          localState: undefined,
          rootState: this.builderContextSignal().rootState,
          rootSetState: newState => {
            this.builderContextSignal().rootSetState?.(newState);
          },
          isExpression: false
        });
      }
    }
    static {
      this.ɵfac = function ContentComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContentComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ContentComponent,
        selectors: [["content-component"]],
        hostAttrs: ["ngSkipHydration", "true"],
        inputs: {
          apiKey: [1, "apiKey"],
          context: [1, "context"],
          content: [1, "content"],
          customComponents: [1, "customComponents"],
          data: [1, "data"],
          locale: [1, "locale"],
          canTrack: [1, "canTrack"],
          apiVersion: [1, "apiVersion"],
          blocksWrapper: [1, "blocksWrapper"],
          blocksWrapperProps: [1, "blocksWrapperProps"],
          nonce: [1, "nonce"],
          model: [1, "model"],
          apiHost: [1, "apiHost"],
          enrich: [1, "enrich"],
          showContent: [1, "showContent"],
          contentWrapper: [1, "contentWrapper"],
          contentWrapperProps: [1, "contentWrapperProps"],
          trustedHosts: [1, "trustedHosts"],
          isNestedRender: [1, "isNestedRender"],
          isSsrAbTest: [1, "isSsrAbTest"],
          linkComponent: [1, "linkComponent"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 22,
        consts: [[3, "apiHost", "nonce", "content", "data", "model", "context", "apiKey", "canTrack", "locale", "enrich", "showContent", "builderContextSignal", "contentWrapper", "contentWrapperProps", "trustedHosts", "isNestedRender"], ["id", "builderio-variant-visibility", 3, "scriptStr", "nonce"], [3, "nonce", "isNestedRender", "contentId", "cssCode", "customFonts"], [3, "blocks", "context", "registeredComponents", "linkComponent"]],
        template: function ContentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "enable-editor", 0);
            i0.ɵɵtemplate(1, ContentComponent_Conditional_1_Template, 1, 2, "inlined-script", 1)(2, ContentComponent_Conditional_2_Template, 1, 5, "content-styles", 2);
            i0.ɵɵelement(3, "blocks", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_18_0;
            i0.ɵɵproperty("apiHost", ctx.apiHost())("nonce", ctx.nonce())("content", ctx.content())("data", ctx.data())("model", ctx.model())("context", ctx.context())("apiKey", ctx.apiKey())("canTrack", ctx.canTrack())("locale", ctx.locale())("enrich", ctx.enrich())("showContent", ctx.showContent())("builderContextSignal", ctx.builderContextSignal())("contentWrapper", ctx.contentWrapper())("contentWrapperProps", ctx.contentWrapperProps())("trustedHosts", ctx.trustedHosts())("isNestedRender", ctx.isNestedRender());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isSsrAbTest() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.TARGET !== "reactNative" ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("blocks", (tmp_18_0 = ctx.builderContextSignal().content) == null ? null : tmp_18_0.data == null ? null : tmp_18_0.data.blocks)("context", ctx.builderContextSignal())("registeredComponents", ctx.registeredComponents())("linkComponent", ctx.linkComponent());
          }
        },
        dependencies: [CommonModule, EnableEditor, InlinedScript, ContentStyles, Blocks],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return ContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContentVariants = /*#__PURE__*/(() => {
  class ContentVariants {
    trackByVariant0(_, variant) {
      return variant.testVariationId;
    }
    constructor() {
      this.TARGET = TARGET;
      this.getInitVariantsFnsScriptString = getInitVariantsFnsScriptString;
      this.SDKS_SUPPORTING_PERSONALIZATION = SDKS_SUPPORTING_PERSONALIZATION;
      this.getInitPersonalizationVariantsFnsScriptString = getInitPersonalizationVariantsFnsScriptString;
      this.getVariants = getVariants;
      this.canTrack = input();
      this.content = input();
      this.isNestedRender = input();
      this.nonce = input();
      this.apiHost = input();
      this.model = input();
      this.data = input();
      this.context = input();
      this.apiKey = input();
      this.apiVersion = input();
      this.customComponents = input();
      this.linkComponent = input();
      this.locale = input();
      this.enrich = input();
      this.blocksWrapper = input();
      this.blocksWrapperProps = input();
      this.contentWrapper = input();
      this.contentWrapperProps = input();
      this.trustedHosts = input();
      this.shouldRenderVariants = signal(undefined);
      this.updateCookieAndStylesScriptStr = computed(() => {
        return getUpdateCookieAndStylesScript(getVariants(this.content()).map(value => ({
          id: value.testVariationId,
          testRatio: value.testRatio
        })), this.content()?.id || "");
      });
      this.hideVariantsStyleString = computed(() => {
        return getVariants(this.content()).map(value => `.variant-${value.testVariationId} { display: none; } `).join("");
      });
      this.defaultContent = computed(() => {
        return this.shouldRenderVariants() ? {
          ...this.content(),
          testVariationId: this.content()?.id
        } : handleABTestingSync({
          item: this.content(),
          canTrack: getDefaultCanTrack(this.canTrack())
        });
      });
    }
    ngOnInit() {
      this.shouldRenderVariants.set(checkShouldRenderVariants({
        canTrack: getDefaultCanTrack(this.canTrack()),
        content: this.content()
      }));
    }
    ngAfterViewInit() {
      if (typeof window !== "undefined") {
        /**
         * For Solid/Svelte: we unmount the non-winning variants post-hydration.
         */
      }
    }
    static {
      this.ɵfac = function ContentVariants_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContentVariants)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ContentVariants,
        selectors: [["builder-content"], ["content-variants"]],
        inputs: {
          canTrack: [1, "canTrack"],
          content: [1, "content"],
          isNestedRender: [1, "isNestedRender"],
          nonce: [1, "nonce"],
          apiHost: [1, "apiHost"],
          model: [1, "model"],
          data: [1, "data"],
          context: [1, "context"],
          apiKey: [1, "apiKey"],
          apiVersion: [1, "apiVersion"],
          customComponents: [1, "customComponents"],
          linkComponent: [1, "linkComponent"],
          locale: [1, "locale"],
          enrich: [1, "enrich"],
          blocksWrapper: [1, "blocksWrapper"],
          blocksWrapperProps: [1, "blocksWrapperProps"],
          contentWrapper: [1, "contentWrapper"],
          contentWrapperProps: [1, "contentWrapperProps"],
          trustedHosts: [1, "trustedHosts"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 23,
        consts: [[3, "apiHost", "nonce", "isNestedRender", "content", "showContent", "model", "data", "context", "apiKey", "apiVersion", "customComponents", "linkComponent", "canTrack", "locale", "enrich", "isSsrAbTest", "blocksWrapper", "blocksWrapperProps", "contentWrapper", "contentWrapperProps", "trustedHosts"], ["id", "builderio-init-variants-fns", 3, "scriptStr", "nonce"], ["id", "builderio-init-personalization-variants-fns", 3, "nonce", "scriptStr"], ["id", "builderio-variants", 3, "styles", "nonce"], ["id", "builderio-variants-visibility", 3, "scriptStr", "nonce"], [3, "apiHost", "isNestedRender", "nonce", "content", "showContent", "model", "data", "context", "apiKey", "apiVersion", "customComponents", "linkComponent", "canTrack", "locale", "enrich", "isSsrAbTest", "blocksWrapper", "blocksWrapperProps", "contentWrapper", "contentWrapperProps", "trustedHosts"]],
        template: function ContentVariants_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainerStart(0);
            i0.ɵɵtemplate(1, ContentVariants_Conditional_1_Template, 2, 3)(2, ContentVariants_Conditional_2_Template, 4, 4);
            i0.ɵɵelement(3, "content-component", 0);
            i0.ɵɵelementContainerEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.isNestedRender() && ctx.TARGET !== "reactNative" ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.shouldRenderVariants() ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("apiHost", ctx.apiHost())("nonce", ctx.nonce())("isNestedRender", ctx.isNestedRender())("content", ctx.defaultContent())("showContent", true)("model", ctx.model())("data", ctx.data())("context", ctx.context())("apiKey", ctx.apiKey())("apiVersion", ctx.apiVersion())("customComponents", ctx.customComponents())("linkComponent", ctx.linkComponent())("canTrack", ctx.canTrack())("locale", ctx.locale())("enrich", ctx.enrich())("isSsrAbTest", ctx.shouldRenderVariants())("blocksWrapper", ctx.blocksWrapper())("blocksWrapperProps", ctx.blocksWrapperProps())("contentWrapper", ctx.contentWrapper())("contentWrapperProps", ctx.contentWrapperProps())("trustedHosts", ctx.trustedHosts());
          }
        },
        dependencies: [CommonModule, InlinedScript, InlinedStyles, ContentComponent],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return ContentVariants;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const fetchSymbolContent = async ({
  builderContextValue,
  symbol
}) => {
  /**
   * If:
   * - we have a symbol prop
   * - yet it does not have any content
   * - and we have not already stored content from before
   * - and it has a model name
   *
   * then we want to re-fetch the symbol content.
   */
  if (symbol?.model &&
  // This is a hack, we should not need to check for this, but it is needed for Svelte.
  builderContextValue?.apiKey) {
    return fetchOneEntry({
      model: symbol.model,
      apiKey: builderContextValue.apiKey,
      apiVersion: builderContextValue.apiVersion,
      ...(symbol?.entry && {
        query: {
          id: symbol.entry
        }
      })
    }).catch(err => {
      logger.error('Could not fetch symbol content: ', err);
      return undefined;
    });
  }
  return undefined;
};
let Symbol = /*#__PURE__*/(() => {
  class Symbol {
    setContent() {
      if (this.contentToUse() && this.symbolEntry() === this.symbol()?.entry) return;
      fetchSymbolContent({
        symbol: this.symbol(),
        builderContextValue: this.builderContext()
      }).then(newContent => {
        if (newContent) {
          this.contentToUse.set(newContent);
          this.symbolEntry.set(this.symbol()?.entry);
        }
      });
    }
    setAttributes(el, value, changes) {
      if (!el) {
        return;
      }
      const target = typeof changes === "undefined" ? value : changes;
      Object.keys(target).forEach(key => {
        if (key.startsWith("on")) {
          if (this._listenerFns.has(key)) {
            this._listenerFns.get(key)();
          }
          this._listenerFns.set(key, this.renderer.listen(el, key.replace("on", "").toLowerCase(), target[key]));
        } else {
          this.renderer.setAttribute(el, key.toLowerCase(), target[key] ?? "");
        }
      });
    }
    constructor(renderer) {
      this.renderer = renderer;
      this.symbol = input();
      this.builderComponents = input();
      this.attributes = input();
      this.dynamic = input();
      this.builderContext = input();
      this.builderBlock = input();
      this.builderLinkComponent = input();
      this.elRef0 = viewChild("elRef0");
      this.contentToUse = signal(undefined);
      this.symbolEntry = signal(undefined);
      this._listenerFns = new Map();
      this.blocksWrapper = computed(() => {
        return DynamicDiv;
      });
      this.contentWrapper = computed(() => {
        return DynamicDiv;
      });
      this.customComponents = computed(() => {
        return Object.values(this.builderComponents());
      });
      this.className = computed(() => {
        return [...[this.attributes()[getClassPropName()]], "builder-symbol", this.symbol()?.inline ? "builder-inline-symbol" : undefined, this.symbol()?.dynamic || this.dynamic() ? "builder-dynamic-symbol" : undefined].filter(Boolean).join(" ");
      });
      this.objSpread_context_c7ynf9 = computed(() => {
        return {
          ...this.builderContext().context,
          symbolId: this.builderBlock()?.id
        };
      });
      this.objSpread_data_9gx4sl = computed(() => {
        return {
          ...this.symbol()?.data,
          ...this.builderContext().localState,
          ...this.contentToUse()?.data?.state
        };
      });
      if (typeof window !== "undefined") {
        effect(() => {
          // --- Mitosis: Workaround to make sure the effect() is triggered ---
          this.symbol();
          // ---
          this.setContent();
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, {});
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
        effect(() => {
          this.setAttributes(this.elRef0()?.nativeElement, {});
        }, {
          allowSignalWrites: true // Enable writing to signals inside effects
        });
      }
    }
    ngOnInit() {
      this.symbolEntry.set(this.symbol()?.entry);
      this.contentToUse.set(this.symbol()?.content);
    }
    ngAfterViewInit() {
      if (typeof window !== "undefined") {}
      this.setAttributes(this.elRef0()?.nativeElement, {});
      this.setAttributes(this.elRef0()?.nativeElement, this.attributes());
      this.setAttributes(this.elRef0()?.nativeElement, {});
    }
    ngOnDestroy() {
      for (const fn of this._listenerFns.values()) {
        fn();
      }
    }
    static {
      this.ɵfac = function Symbol_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Symbol)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Symbol,
        selectors: [["builder-symbol"]],
        viewQuery: function Symbol_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.elRef0, _c12, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          symbol: [1, "symbol"],
          builderComponents: [1, "builderComponents"],
          attributes: [1, "attributes"],
          dynamic: [1, "dynamic"],
          builderContext: [1, "builderContext"],
          builderBlock: [1, "builderBlock"],
          builderLinkComponent: [1, "builderLinkComponent"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 15,
        consts: [["elRef0", ""], [3, "nonce", "isNestedRender", "apiVersion", "apiKey", "context", "customComponents", "data", "canTrack", "model", "content", "linkComponent", "blocksWrapper", "contentWrapper"]],
        template: function Symbol_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", null, 0);
            i0.ɵɵelement(2, "content-variants", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_10_0;
            i0.ɵɵclassMap(ctx.className());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("nonce", ctx.builderContext().nonce)("isNestedRender", true)("apiVersion", ctx.builderContext().apiVersion)("apiKey", ctx.builderContext().apiKey)("context", ctx.objSpread_context_c7ynf9())("customComponents", ctx.customComponents())("data", ctx.objSpread_data_9gx4sl())("canTrack", ctx.builderContext().canTrack)("model", (tmp_10_0 = (tmp_10_0 = ctx.symbol()) == null ? null : tmp_10_0.model) !== null && tmp_10_0 !== undefined ? tmp_10_0 : "")("content", ctx.contentToUse())("linkComponent", ctx.builderLinkComponent())("blocksWrapper", ctx.blocksWrapper())("contentWrapper", ctx.contentWrapper());
          }
        },
        dependencies: [CommonModule, ContentVariants],
        styles: ["[_nghost-%COMP%]{display:contents}"]
      });
    }
  }
  return Symbol;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const registry = {};
function register(type, info) {
  if (type === 'plugin') {
    info = serializeIncludingFunctions(info);
  }
  let typeList = registry[type];
  if (!typeList) {
    typeList = registry[type] = [];
  }
  typeList.push(info);
  if (isBrowser()) {
    const message = {
      type: 'builder.register',
      data: {
        type,
        info
      }
    };
    try {
      parent.postMessage(message, '*');
      if (parent !== window) {
        window.postMessage(message, '*');
      }
    } catch (err) {
      console.debug('Could not postmessage', err);
    }
  }
}
function registerAction(action) {
  if (isBrowser()) {
    const actionClone = JSON.parse(JSON.stringify(action));
    if (action.action) {
      actionClone.action = action.action.toString();
    }
    window.parent?.postMessage({
      type: 'builder.registerAction',
      data: actionClone
    }, '*');
  }
}
const settings = {};
function setEditorSettings(newSettings) {
  if (isBrowser()) {
    Object.assign(settings, newSettings);
    const message = {
      type: 'builder.settingsChange',
      data: settings
    };
    parent.postMessage(message, '*');
  }
}

/**
 * Given an `apiKey` and `url` (or `path` + `searchParams`), provides all props that `Content` needs to render Builder Content.
 *
 * @example
 * ```jsx
 * const builderProps = await fetchBuilderProps({
 *    apiKey: 'API_KEY',
 *    // provide `url`
 *    url: yourPageUrl,
 *    // OR provide `path` + `searchParams`
 *    path: yourPath,
 *    searchParams: yourSearchParams,
 * });
 *
 * return <Content {...builderProps} />;
 * ```
 */
const fetchBuilderProps = async _args => {
  const urlPath = _args.path || _args.url?.pathname || _args.userAttributes?.urlPath;
  const getContentArgs = {
    ..._args,
    apiKey: _args.apiKey,
    model: _args.model || 'page',
    userAttributes: {
      ..._args.userAttributes,
      ...(urlPath ? {
        urlPath
      } : {})
    },
    options: getBuilderSearchParams(_args.searchParams || _args.url?.searchParams || _args.options)
  };
  return {
    apiKey: getContentArgs.apiKey,
    model: getContentArgs.model,
    content: await fetchOneEntry(getContentArgs)
  };
};

// ignore prettier formatting for this file because the order of exports is meaningful
// prettier-ignore

/**
 * Generated bundle index. Do not edit.
 */

export { Blocks, BuilderContext, Button, Columns, ContentVariants as Content, FragmentComponent as Fragment, Image, SectionComponent as Section, Symbol, Text, Video, _processContentResult, createRegisterComponentMessage, fetchBuilderProps, fetchEntries, fetchOneEntry, getBuilderSearchParams, isEditing, isPreviewing, register, registerAction, setClientUserAttributes, setEditorSettings, subscribeToEditor, track };
